// UFLEX School — boshqaruv paneli 3 tilli tarjimalar (uz/ru/en).
// Server javoblari o'zbekcha (bu yerda faqat UI).

const uz = {
  lang: { title: 'Til', uz: "O'zbekcha", ru: 'Русский', en: 'English' },
  common: {
    reset: 'Tozalash',
    save: 'Saqlash', cancel: 'Bekor qilish', add: "Qo'shish", delete: "O'chirish", search: 'Qidirish...',
    loading: 'Yuklanmoqda...', total: 'Jami', noResults: 'Topilmadi', searching: 'Qidirilmoqda...', actions: 'Amallar', selectPlaceholder: 'Tanlang', datePlaceholder: 'kun.oy.yil', error: 'Xatolik',
    noData: "Ma'lumot yo'q", itemsCount: '{{count}} ta',
    list: "Ro'yxat",
    all: 'Hammasi', unreadOnly: "Faqat o'qilmagan", dateFrom: 'Sanadan', dateTo: 'Sanagacha', noMatch: "Filtrga mos yozuv yo'q",
  },
  guard: { denied: "Ruxsat yo'q", deniedMsg: "Bu bo'lim sizning rolingiz uchun mavjud emas.", goHome: 'Bosh sahifaga' },
  // Bayroq bilan muzlatilgan bo'lim (lib/features.ts) — components/FeatureFrozen.tsx
  featureFrozen: {
    title: "Bo'lim vaqtincha o'chirilgan",
    desc: "Premium moduli vaqtincha muzlatilgan. Bu bo'lim keyinroq qayta yoqiladi — ma'lumotlaringiz saqlanib turibdi.",
  },
  contractDownload: {
    title: "O'quvchi shartnomasi", desc: 'Shartnomangiz tayyor. Yuklab olish uchun tugmani bosing.',
    download: 'Yuklab olish', done: 'Shartnoma yuklab olindi', doneHint: 'Fayl qurilmangizga saqlandi.',
    again: 'Qayta yuklab olish', notFound: 'Bunday shartnoma havolasi topilmadi.',
    expired: 'Havola muddati tugagan — belgilangan marta ishlatilgan.', error: "Yuklashda xatolik. Keyinroq urinib ko'ring.",
  },
  block: {
    block: 'Bloklash', unblock: 'Blokdan chiqarish', title: 'Foydalanuvchini bloklash', blocked: 'Bloklangan',
    reasonLabel: 'Bloklash sababi', reasonPlaceholder: "Sababni yozing — foydalanuvchiga ko'rsatiladi",
    hint: "Bloklangan foydalanuvchi tizimga kira olmaydi. Ilova foydalanuvchisiga sabab bildirishnoma orqali yuboriladi.",
  },
  teacherDetail: {
    notFound: "O'qituvchi topilmadi", edit: 'Tahrirlash', fullName: 'F.I.Sh.', phone: 'Telefon', gender: 'Jins',
    male: 'Ustoz (erkak)', female: "O'qituvchi (ayol)", birthDate: "Tug'ilgan sana",
    assignments: 'Biriktirishlar (fan · sinf)', noAssignments: 'Biriktirish yo‘q', contacts: 'Kontaktlar',
    status: 'Holat', salaryLink: 'Maosh va ish vaqti', joined: "Qo'shilgan",
  },
  // Xodim fotosi — yuz tanish terminali (Hikvision) uchun; TeacherDetail va StaffDetail'da yagona blok
  staffDelete: {
    button: "Butunlay o'chirish",
    done: "Xodim o'chirildi",
    blockedTitle: "O'chirib bo'lmaydi",
    blockedIntro: "{{name}} quyidagi yozuvlar bilan bog'langan:",
    blockedHint: "Ularni o'chirish maktab tarixini yo'qotardi. Xodimni tahrirlash oynasidan FAOLSIZLANTIRING — u panelga kira olmaydi, yozuvlari esa joyida qoladi.",
  },
  staffPhoto: {
    upload: 'Foto yuklash', change: 'Fotoni almashtirish', remove: "Fotoni o'chirish",
    uploaded: 'Foto yuklandi', removed: "Foto o'chirildi",
    stickerNote: "Stiker o'rnatilgan — yuz tanish uchun haqiqiy foto kerak",
  },
  // T2 — xodim/o'qituvchi kartochkasidagi YAGONA to'liq tahrirlash modali
  staffEdit: {
    title: 'Xodimni tahrirlash', account: 'Kirish va rol',
    newPassword: 'Yangi parol', passwordHint: "Bo'sh qoldirilsa parol o'zgarmaydi",
    roleLocked: "O'z rolingizni o'zgartira olmaysiz",
    blockHint: "Bloklash / blokdan chiqarish — kartochkadagi «Holat» bo'limida",
    noChanges: "O'zgarish yo'q",
  },
  navGroups: { main: 'Asosiy', academics: "O'quv jarayoni", finance: 'Moliya', management: 'Boshqaruv', platform: 'Platforma' },
  nav: {
    qurilmalar: 'Qurilmalar',
    agentlar: 'FACE ID agentlar',
    faceid: 'FACE ID',
    dashboard: 'Boshqaruv paneli', students: "O'quvchilar", parents: 'Ota-onalar', teachers: "O'qituvchilar", classes: 'Sinflar', subjects: 'Fanlar',
    schedule: 'Dars jadvali', attendance: 'Davomat', grades: 'Baholar', journal: 'Elektron jurnal', homework: 'Uy vazifa',
    ranking: 'Reyting', behavior: 'Xulq', exams: 'Test imtihonlar',
    payments: 'Moliya', reports: 'Hisobotlar', expenses: 'Xarajatlar', payroll: 'Maosh', admissions: 'Qabul / CRM', contracts: 'Shartnomalar', announcements: "E'lonlar", banners: 'Bannerlar', notifications: 'Bildirishnomalar', stickers: 'Stikerlar', support: 'Support', premium: 'Premium', platformSupport: 'Platforma yordami', tenants: 'Maktablar', saasPremium: 'Premium', saasGifts: "Sovg'alar", saasSupport: 'Support',
    audit: 'Audit va xavfsizlik',
    staff: 'Xodimlar', academicYears: "O'quv yili va choraklar", settings: 'Sozlamalar',
  },
  header: { refresh: 'Yangilash', search: "Qidirish yoki bo'limga o'tish...", settings: 'Sozlamalar', logout: 'Chiqish', light: "Yorug' rejim", dark: 'Tungi rejim' },
  roles: {
    SUPER_ADMIN: 'Super admin', DIRECTOR: 'Direktor', ADMIN: 'Administrator', ACCOUNTANT: 'Buxgalter',
    TEACHER: "O'qituvchi", HOMEROOM_TEACHER: 'Sinf rahbari', RECEPTION: "Qabul bo'limi", PARENT: 'Ota-ona', STUDENT: "O'quvchi",
  },
  studentStatus: { ACTIVE: "O'qiyapti", INACTIVE: 'Faol emas', ON_LEAVE: "Ta'tilda", GRADUATED: 'Bitirgan', EXPELLED: 'Chetlashtirilgan' },
  expenses: { title: 'Xarajatlar', add: "Xarajat qo'shish", added: "Xarajat qo'shildi", empty: "Xarajatlar yo'q", income: 'Kirim', expenses: 'Chiqim', net: 'Sof foyda', debt: 'Qarzdorlik', debtors: 'qarzdor', byCategory: "Kategoriya bo'yicha", allCategories: 'Barcha kategoriyalar', category: 'Kategoriya', staff: 'Xodim', staffSearch: 'Xodimni qidiring...', note: 'Izoh', amount: 'Summa', date: 'Sana', forMonth: 'Qaysi oy uchun', amountRequired: 'Summani kiriting', clickHint: 'Batafsil uchun kategoriyaga bosing', categoryTotal: "Kategoriya bo'yicha jami", records: 'Yozuvlar', detailSearch: "Izoh yoki xodim bo'yicha qidirish...", detailEmpty: "Bu kategoriyada xarajat yo'q", createdBy: 'Kiritdi', searchPlaceholder: "Izoh yoki xodim bo'yicha qidirish...", sortCategoryAsc: 'Kategoriya (A-Z)', noMatch: "Filtrga mos xarajat yo'q", allMonths: 'Barcha oylar', statsMonth: "Ko'rsatkichlar {{month}} bo'yicha", statsPeriodDiffers: "Quyidagi jadval boshqa davrni ko'rsatmoqda: {{period}}", rangeFrom: '{{date}} dan boshlab', rangeTo: '{{date}} gacha', emptyMonthHint: "{{month}} uchun xarajat qayd etilmagan — boshqa davrni tanlab ko'ring.", rangeMonthHint: "Sana oralig'i tanlanganda oy filtri qo'llanilmaydi: oraliq xarajat sarflangan sana, oy esa xarajat qaysi oyga tegishli ekani bo'yicha ishlaydi.", backToMonth: "Oy bo'yicha filtrlash", statsIgnoresFilters: "Kartalarga qidiruv va kategoriya filtri qo'llanilmaydi — butun oy bo'yicha", type: 'Xarajat turi', typeHint: "Turlar ro'yxatini administratsiya boshqaradi", allTypes: 'Barcha turlar', noType: "Turga bog'lanmagan", cashIncomeHint: 'Shu oyda kassaga tushgan: {{sum}}', methodHint: "Kassa hisobotida chiqim naqd yoki bank bo'yicha ajratiladi" },
  /** Maosh sahifasi (/payroll) — oylik maoshli xodimlar, spec 2026-10-21 §6.1 */
  payrollPage: {
    title: 'Maosh', prevMonth: 'Oldingi oy', nextMonth: 'Keyingi oy',
    accrued: 'Yozilgan', paid: 'Berilgan', remaining: 'Qolgan', forecast: 'Oy oxirigacha kutilayotgan',
    overpaidHint: 'Ortiqcha berilgan: {{sum}}',
    /** Jarima ishlanganidan katta — yozilgan manfiy (pul berilmagan bo'lishi mumkin, "ortiqcha berilgan" emas). */
    overWithheld: 'ushlanma ishlanganidan oshdi', overWithheldHint: 'Ushlanma ishlanganidan oshdi: {{sum}}',
    meta: 'Ish kunlari: {{kun}} · kechirim {{daq}} daq · hisoblandi {{vaqt}}',
    ruleOff: "Bu oy uchun ish vaqti qoidasi yoqilmagan — hisob eski usulda (to'liq oylik)",
    noSalary: '{{n}} ta xodimga maosh belgilanmagan', toStaff: "Xodimlarga o'tish",
    search: "Xodim ismi bo'yicha qidirish...",
    staff: 'Xodim', role: 'Rol', monthly: 'Oylik', daily: 'Kunlik', days: 'Kunlar', came: 'Kelgan', absent: 'Kelmagan',
    lateEarly: 'Kech/erta', withheld: 'Ushlangan', adjustment: 'Tuzatish',
    lateEarlyValue: '{{kech}} / {{erta}} daq', outsideDays: 'Ish davridan tashqari: {{n}} kun',
    today: 'bugun +{{sum}}', overpaid: 'ortiqcha', pay: 'Maosh berish', payConfirm: 'Berish', total: 'Jami',
    empty: "Bu oyda oylik maoshli xodim yo'q", loadError: "Maosh jadvalini yuklab bo'lmadi", retry: 'Qayta urinish',
    warnNoShift: "Smena yo'q",
    warnNoShiftHint: "Ish vaqti belgilanmagan — kelgan kunlar to'liq hisoblanadi, kech kelish va erta ketish hisoblanmaydi",
    warnOpenLog: 'Ketish belgilanmagan',
    warnOpenLogHint: "O'tgan kunlarda ketish vaqti belgilanmagan yozuv bor — ish vaqti oxirigacha ishlagan deb olindi",
    warnNoLogs: "Yozuv yo'q",
    warnNoLogsHint: "Bu oyda ish kunlarida bitta ham kelish yozuvi yo'q — FACE ID'ga bog'langanini tekshiring",
    warnNoWorkdays: "Smena kunlari maosh kunlariga to'g'ri kelmaydi",
    warnNoWorkdaysHint: "Xodim smenasi maosh ish kunlarida emas — smena yoki Sozlamalar → Maosh ish kunlarini tekshiring",
    passedDays: "O'tgan kunlar", expectedDays: 'Kutilgan kunlar', absentSum: 'Kelmagan kunlar puli',
    lateMin: 'Kech kelish (daq)', earlyMin: 'Erta ketish (daq)', warnings: 'Ogohlantirishlar',
  },
  expenseCat: { SALARY: 'Ish haqi', RENT: 'Ijara', UTILITY: 'Kommunal', SUPPLY: 'Jihoz', TAX: 'Soliq', MAINTENANCE: "Ta'mirlash", OTHER: 'Boshqa' },
  // T11 — maktab o'zi boshqaradigan xarajat turlari
  expenseTypes: {
    title: 'Xarajat turlari', manage: 'Turlarni boshqarish', byType: "Tur bo'yicha",
    name: 'Nomi', namePlaceholder: 'Masalan: Internet', group: 'Guruh',
    groupHint: "Hisobotlarda qaysi kategoriyaga qo'shiladi",
    order: 'Tartib', usage: 'Ishlatilgan', active: 'Faol', inactive: 'Nofaol',
    add: "Tur qo'shish", added: "Tur qo'shildi", updated: 'Saqlandi', deleted: "Tur o'chirildi",
    nameRequired: 'Tur nomini kiriting', edit: 'Tahrirlash', close: 'Yopish',
    activate: 'Faollashtirish', deactivate: 'Nofaol qilish',
    deleteBlocked: "Bu tur xarajatlarda ishlatilmoqda — o'chirib bo'lmaydi, nofaol qiling",
    empty: "Xarajat turlari yo'q", emptyDesc: "Yuqoridagi maydondan birinchi turni qo'shing.",
  },
  // T10 — o'quvchilar balansi (moliya sahifasi)
  plans: {
    tab: "Oylik to'lovlar",
    progress: "Oylik summa kiritilgan: {{done}} / {{total}} o'quvchi",
    hint: "Qarzdorlik shu summadan hisoblanadi: summasi kiritilmagan o'quvchi qarzdorlar ro'yxatiga tushmaydi.",
    search: "O'quvchini qidiring...",
    allClasses: 'Barcha sinflar',
    onlyMissing: 'Faqat kiritilmaganlar',
    discard: 'Bekor qilish',
    save: 'Saqlash ({{count}} ta)',
    saved: "{{count}} ta o'quvchining summasi saqlandi",
    emptyAmount: "{{count}} ta o'zgargan qatorda oylik summa yo'q — summani kiriting yoki o'zgarishni bekor qiling.",
    student: "O'quvchi",
    class: 'Sinf',
    monthly: 'Oylik summa',
    discount: 'Chegirma',
    due: "To'lanadi",
    note: 'Izoh',
    noAmount: 'kiritilmagan',
  },
  debtStart: {
    section: 'Qarz hisobi',
    sectionDesc: "Maktab tizimga o'tgan oy — undan oldingi oylar qarzga hisoblanmaydi",
    label: 'Qarz hisobi boshlangan oy',
    hint: "Bu oydan oldingi to'lovlar tizimda yo'q bo'lsa, o'sha oylar qarzdorlarda ko'rinmaydi.",
    none: 'Chegara yo\'q',
    noneHint: "Chegara yo'q — barcha oylar qarz hisobiga kiradi.",
    saved: 'Qarz hisobi boshlangan oy saqlandi',
    cleared: 'Chegara olib tashlandi',
    beforeNotice: "Qarz hisobi {{month}} dan boshlangan — bu oy hisobga kirmaydi.",
  },
  payrollRule: {
    section: 'Maosh qoidasi',
    sectionDesc: "Oylik va soatbay maosh belgilangan ish vaqti bo'yicha hisoblanadi",
    fromMonth: 'Qaysi oydan',
    fromMonthHint: "Shu oydan boshlab kech kelish va erta ketish maoshni kamaytiradi, erta kelish va kech ketish qo'shilmaydi.",
    offPlaceholder: "O'chiq",
    offHint: "O'chiq — maosh avvalgidek hisoblanadi.",
    grace: 'Kechirim',
    graceHint: "Shuncha daqiqagacha kechikish yoki erta ketish kechiriladi.",
    min: 'daq',
    saved: 'Maosh qoidasi saqlandi',
    off: "Maosh qoidasi o'chirildi",
    workDays: 'Maosh ish kunlari',
    workDaysHint: "Oylik maoshning kunlik qiymati shu kunlar bo'yicha hisoblanadi (dars kunlariga ta'sir qilmaydi)",
    workDaysRequired: 'Kamida bitta kunni tanlang',
  },
  kunlar: {
    monthsTitle: "Oylar bo'yicha", monthsSubtitle: "Qaysi oyda necha kun kelgan, qancha ishlagan va qancha maosh yozilgan. Oyni tanlash uchun qatorni bosing",
    month: 'Oy', came: 'Keldi', absent: 'Kelmadi', worked: 'Ishlagan vaqt', accrued: 'Hisoblandi', paid: 'Berildi', remaining: 'Qolgan',
    daysOf: '{{n}} / {{jami}} kun', extraDays: '+{{n}} dam olish kuni', noOutDays: '{{n}} kun ketish yo\'q', selected: 'tanlangan',
    title: "Kunlar bo'yicha — {{month}}", subtitle: "Har kuni qachon kelgan, qachon ketgan, necha soat ishlagan va shu kun uchun qancha yozilgan",
    date: 'Sana', status: 'Holat', in: 'Keldi', out: 'Ketdi', workedCol: 'Ishladi', shift: 'Ish vaqti', dayPay: 'Kun puli', adj: 'Bonus / jarima',
    s_KELDI: 'Keldi', s_ISHDA: 'Ishda', s_KELMADI: 'Kelmadi', s_KUTILMOQDA: 'Kutilmoqda', s_DAM: 'Dam olish', s_TASHQARI: 'Ish davridan tashqari',
    noOut: "Ketish belgilanmagan", setOut: "Ketgan vaqtini kiritish", late: 'kech {{n}} daq', early: 'erta ketdi {{n}} daq',
    soFar: 'hozirgacha', notCounted: 'hisobga kirmaydi', noPerDay: "Bu maosh turida kun bo'yicha pul hisoblanmaydi",
    showRest: "Dam olish kunlarini ko'rsatish", total: 'Jami', totalDays: '{{n}} kun keldi',
    roundHint: "Kun pullari yig'indisi oy hisobidan bir necha so'm farq qilishi mumkin — oy bo'yicha bir marta yaxlitlanadi",
    noOutHint: "Ketish belgilanmagan o'tgan kunlar: {{n}} ta. Ish vaqti bo'lsa ish oxirigacha, bo'lmasa to'liq kun deb hisoblanmoqda — to'g'ri vaqtni kiriting",
    outTitle: 'Ketgan vaqtini kiritish', outDay: 'Kun: {{day}}', outCame: 'Kelgan vaqti: {{time}}', outTime: 'Ketgan vaqti', outSave: 'Saqlash',
    outSaved: 'Ketish vaqti saqlandi', outAfterIn: "Ketish vaqti kelish vaqtidan keyin bo'lishi kerak", h: '{{h}} s {{m}} daq',
  },
  ishVaqti: {
    title: "Ish vaqti bo'yicha kunlar",
    subtitle: "Kech kelish va erta ketish kamaytiradi, erta kelish va kech ketish qo'shilmaydi",
    day: 'Sana', shift: 'Ish vaqti', in: 'Keldi', out: 'Ketdi', late: 'Kechikish', early: 'Erta ketish',
    extra: 'Ortiqcha', counted: 'Hisoblandi', min: 'daq', bonus: 'Bonus',
    absent: 'Kelmadi', noOut: 'belgilanmagan', pending: 'kutilmoqda', soFar: 'hozirgacha', inProgress: 'davom etmoqda',
    bonusReason: "Kech qolib ishlagani uchun (+{{n}} daq)",
    workDays: 'Xodimning ish kunlari',
    noShift: "Ish vaqti belgilanmagan — kech kelish hisoblanmayapti. \"Ish jadvali\" yorlig'ida ish vaqtini kiriting.",
    noShiftFixed: "Smena belgilanmagan — kelgan kunlar to'liq hisoblanadi, kech kelish va erta ketish hisoblanmaydi",
    outsidePeriod: "Ish davridan tashqari {{n}} ish kuni hisobga kirmadi (ishga kirgan/ketgan sanaga qarang)",
    openCounted: "ochiq yozuv (ish vaqti oxirigacha hisoblanadi)",
    openPlain: "ochiq yozuv",
  },
  cashbook: {
    tab: 'Kassa hisoboti', title: 'Kassa hisoboti', subtitle: "Tanlangan kun uchun moliyaviy ko'rsatkichlar", refresh: 'Hisobotni yangilash', date: 'Sana',
    dayIncome: 'Bir kunlik kirim', dayExpense: 'Bir kunlik chiqim', dayNet: 'Bir kunlik qoldiq', totalCash: 'Umumiy kassa',
    netHint: 'Kirim − Chiqim', totalHint: 'Naqd + Bank, kun oxiriga', vsPrev: "{{pct}}% (o'tgan kun bilan)", prevZero: "O'tgan kuni: 0 so'm", same: "O'tgan kun bilan bir xil",
    cashBox: 'Naqd (kassa)', bank: 'Bank', bankSub: "karta, o'tkazma", shuKun: 'shu kun', income: 'Kirim', expense: 'Chiqim', rest: 'Qoldiq',
    cashLeft: 'Naqd qoldiq', bankLeft: 'Bank qoldiq', leftHint: 'kun oxiriga, jami',
    chart: 'Kirim va chiqim — {{year}}, oylar kesimida',
    details: "Tanlangan kun bo'yicha tafsilotlar", colType: 'Turi', colSum: "Summa (so'm)", colDate: 'Sana', colNote: 'Izoh', total: 'Jami',
    incCash: 'Kirim (naqd)', incBank: 'Kirim (bank)', expCash: 'Chiqim (naqd)', expBank: 'Chiqim (bank)',
    payCount: "{{count}} ta to'lov", expCount: '{{count}} ta xarajat', reversals: '{{count}} ta qaytarilgan pul', noRows: "Yozuv yo'q",
    debtTitle: "O'tgan oy qarzdorligi — {{month}}", colStudent: "O'quvchi", colClass: 'Sinfi', colDebt: "Qarz (so'm)", monthsDebt: '{{count}} oy',
    debtTotal: 'Jami qarzdorlik', debtCount: "{{count}} nafar o'quvchi", debtNone: "O'tgan oy uchun qarzdor yo'q", seeAll: "Barchasini ko'rish",
    monthsHint: "Izoh — {{from}} dan beri necha oy uchun to'lov to'liq emas",
    shareTitle: "Naqd va bank ulushi (shu kun)", cashIn: 'Naqd kirim', cashOut: 'Naqd chiqim', bankIn: 'Bank kirim', bankOut: 'Bank chiqim',
    shareHintIn: 'kirimning {{pct}}%', shareHintOut: 'chiqimning {{pct}}%',
    summary: 'Xulosa', sumIncome: 'Kunlik kirim: {{sum}}', sumExpense: 'Kunlik chiqim: {{sum}}', sumNet: 'Kunlik qoldiq: {{sum}}', sumCash: 'Umumiy kassa: {{sum}} (naqd {{cash}} + bank {{bank}})', sumDebt: "O'tgan oy qarzdorligi: {{sum}} ({{count}} nafar o'quvchi)",
    howTitle: 'Qanday hisoblanadi',
    how1: "Kirim — shu kuni qabul qilingan to'lovlar (qaysi oy uchunligidan qat'i nazar). Qaytarilgan pul ayiriladi.",
    how2: "Chiqim — Xarajatlar bo'limiga shu sana bilan kiritilgan xarajatlar.",
    how3: "Naqd — «Naqd» usuli; Bank — karta, o'tkazma va boshqa usullar.",
    how4: "Umumiy kassa — kassa boshlanish sanasidan tanlangan kun oxirigacha kiritilgan barcha kirim minus barcha chiqim.",
    startButton: 'Kassa boshlanishi', startTitle: 'Kassa hisobi qaysi kundan boshlanadi',
    startDesc: "Shu kundan oldingi to'lov va xarajatlar kassa hisobotiga (kirim, chiqim, qoldiq, grafik) kirmaydi. Yozuvlar o'chirilmaydi — o'quvchi balansi va qarzdorlik o'zgarmaydi.",
    startLabel: 'Boshlanish sanasi', startClear: 'Butun tarixni hisoblash', startSaved: 'Kassa boshlanish sanasi saqlandi', startFrom: '{{date}} dan boshlab',
  },
  balances: {
    tab: 'Balanslar', tabPayments: "To'lovlar", due: 'Reja', overpaid: 'Ortiqcha', status: 'Holat',
    byStatus: "Holat bo'yicha", clickHint: 'Filtrlash uchun holatga bosing',
    allStatuses: 'Barcha holatlar', searchPlaceholder: "O'quvchi yoki sinf...",
    empty: "Balans ma'lumoti yo'q", noPlan: "To'lov rejasi yo'q",
    balanceHint: 'Balans: {{value}}',
    filteredSummary: "{{status}}: {{count}} o'quvchi · qarz {{debt}} · to'langan {{paid}}",
    sortOverpaidDesc: 'Ortiqcha (katta)',
    discount: 'Chegirma', discountHint: "Reja summasida chegirma ALLAQACHON ayrilgan (oylik − chegirma)",
  },
  balanceStatus: { PAID: "To'liq to'langan", PARTIAL: "Qisman to'langan", DEBT: 'Qarzdor', OVERPAID: "Ortiqcha to'langan" },
  days: { '1': 'Dushanba', '2': 'Seshanba', '3': 'Chorshanba', '4': 'Payshanba', '5': 'Juma', '6': 'Shanba', '7': 'Yakshanba' },
  monthsShort: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyn', 'Iyl', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
  monthsFull: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'],
  charts: { income: 'Tushum', count: "O'quvchilar", monthIncome: 'Oy daromadi', cashIncome: 'Kassa tushumi' },
  currency: { som: "so'm", thousand: 'ming', million: 'mln', billion: 'mlrd' },
  timeAgo: { justNow: 'hozirgina', min: '{{n}} daqiqa oldin', hour: '{{n}} soat oldin', day: '{{n}} kun oldin' },
  reports: {
    byClass: "Sinflar kesimida o'quvchilar", students: "O'quvchilar", monthlyRevenue: '{{year}}-yil oylik tushum', revenueHint: "Oy daromadi — shu oy uchun to'langan pul. Kassa tushumi — shu oy ichida kassaga tushgan pul. Oldindan (bir necha oylik) to'lovda ular farq qiladi.",
    noData: "Ma'lumot yo'q", debtors: 'Qarzdorlar', totalDebt: 'Umumiy qarz', found: 'Topildi',
    count: '{{count}} ta', searchDebtor: "O'quvchi yoki sinf...", noDebtors: "Qarzdorlar yo'q",
    class: 'Sinf', plan: 'Reja', paidCol: "To'langan", debtCol: 'Qarz',
    sortDebtDesc: 'Qarz (katta)', sortDebtAsc: 'Qarz (kichik)', sortNameAsc: 'Ism (A-Z)', sortNameDesc: 'Ism (Z-A)',
    sortClassAsc: 'Sinf (A-Z)', sortDueDesc: 'Reja (katta)', sortPaidDesc: "To'langan (katta)",
    year: 'Yil', noMatch: "Filtrga mos qarzdor yo'q",
  },
  qc: {
    selectPlaceholder: 'Tanlang', nothingFound: "Topilmadi — yangi qo'shing", addNew: "Yangi qo'shish", searchPlaceholder: 'Qidirish...',
    gender: 'Jinsi', male: 'Erkak', female: 'Ayol',
    yearNameRequired: 'Nom kiriting (masalan 2025-2026)', yearAdded: "O'quv yili qo'shildi", academicYear: "O'quv yili", save: 'Saqlash',
    fullNameRequired: 'F.I.Sh. kiriting', loginMinLength: 'Login kamida 3 belgi', passwordMinLength: 'Parol kamida 5 belgi', genderRequired: 'Jinsni tanlang',
    teacherAdded: "O'qituvchi qo'shildi", fullName: 'F.I.Sh.', login: 'Login', password: 'Parol', phone: 'Telefon',
    parentCreated: 'Ota-ona akkaunti yaratildi', parentFullName: "Ota-ona F.I.Sh.",
    subjectNameRequired: 'Fan nomini kiriting', subjectAdded: "Fan qo'shildi", subjectName: 'Fan nomi', subjectNamePlaceholder: 'Matematika', code: 'Kod',
    classNameRequired: 'Sinf nomini kiriting', academicYearRequired: "O'quv yilini tanlang", classAdded: "Sinf qo'shildi", className: 'Sinf nomi', homeroomTeacher: 'Sinf rahbari',
    newAcademicYear: "Yangi o'quv yili", newTeacher: "Yangi o'qituvchi",
  },
  contactsMgr: {
    saved: 'Saqlandi', deleted: "O'chirildi", phones: 'Telefonlar', add: "Qo'shish", noPhones: "Telefon qo'shilmagan",
    primaryPhone: 'Asosiy raqam', makePrimary: 'Asosiy qilish', primary: 'asosiy',
    addresses: 'Manzillar', noAddresses: "Manzil qo'shilmagan", primaryAddress: 'Asosiy manzil',
    phone: 'Telefon', address: 'Manzil', labelName: 'Nomi (masalan: Ota, Uy, Ish)', number: 'Raqam', cancel: 'Bekor', save: 'Saqlash',
  },
  multiContact: {
    phones: 'Telefon raqamlari', labelPlaceholder: 'Belgi (Ish, Uy...)', primary: 'Asosiy', addPhone: "Raqam qo'shish", primaryHint: '◉ — asosiy raqam',
    addresses: 'Manzillar', labelShort: 'Belgi', address: 'Manzil', addAddress: "Manzil qo'shish",
  },
  staffPage: {
    payrollWarnTitle: "Maosh hisobi to'liq emas",
    fullName: 'F.I.Sh.', login: 'Login', password: 'Parol', role: 'Rol', phone: 'Telefon', status: 'Holat', active: 'Faol',
    user: 'Foydalanuvchi', create: 'Yaratish', birthDate: "Tug'ilgan kun", birthDateOptional: "Tug'ilgan kun (ixtiyoriy)", datePlaceholder: 'kun.oy.yil',
    searchPlaceholder: 'Ism yoki login...', sortNewest: "Yangi qo'shilganlar", sortNameAsc: 'Ism (A-Z)', sortRole: 'Rol',
    saved: 'Saqlandi', created: 'Foydalanuvchi yaratildi',
    fullNameRequired: 'F.I.Sh. kiriting', loginMin: 'Login kamida 3 belgi', passwordMin: 'Parol kamida 5 belgi', genderRequired: 'Jinsni tanlang',
    specialty: 'Mutaxassislik',
    specialtyHint: "Rol ichidagi aniq ish — ism yonida ko'rinadi",
    specialtyPlaceholder: 'Matematika, KPP, Psixolog…',
    notifyTitle: 'Bildirishnoma yuborish', notifyHint: "Ushbu xodimga shaxsiy bildirishnoma (masalan tug'ilgan kun tabrigi) yuboriladi.",
    notifySubject: 'Sarlavha', notifyBody: 'Matn', send: 'Yuborish', notifySent: 'Bildirishnoma yuborildi',
    blocked: 'Bloklangan',
    empty: 'Xodim topilmadi', emptyDesc: "Qidiruv yoki filtrni o'zgartiring.",
  },
  teachersPage: {
    add: "Yangi o'qituvchi",
    title: "O'qituvchilar", login: 'Login', role: 'Rol', allRoles: 'Hammasi', active: 'Faol',
    searchPlaceholder: 'Ism yoki login...', sortNameAsc: 'Ism (A-Z)', sortNameDesc: 'Ism (Z-A)', sortNewest: "Yangi qo'shilganlar", sortRole: 'Rol',
    status: 'Holat', blocked: 'Bloklangan',
    exportCsv: 'Eksport (CSV)',
    exportHint: "Yuz tanish terminaliga (Hikvision) yuklash uchun ro'yxat fayli",
  },
  studentsPage: {
    sortNameAsc: 'Ism (A-Z)', sortNameDesc: 'Ism (Z-A)', sortNewest: "Yangi qo'shilganlar", sortAdmissionDate: 'Qabul sanasi',
    colParentPhone: 'Ota-ona tel.', fromAdmission: 'Qabuldan tanlash (ixtiyoriy)',
    fromAdmissionDesc: "Nomzod tanlansa, ma'lumotlar avtomatik to'ldiriladi", fromAdmissionPlaceholder: "Qabul ro'yxatidan nomzod",
    admissionNotice: "Ma'lumotlar qabuldan olindi. Yaratilgach nomzod \"ro'yxatga olindi\" deb belgilanadi.",
    orManual: "yoki ma'lumotlarni qo'lda kiriting", newClass: 'Yangi sinf', birthDate: "Tug'ilgan sana",
    parentAccount: 'Ota-ona akkaunti (tanlash yoki yangi yaratish)', parentSearchPlaceholder: "Ism yoki telefon bo'yicha qidiring...",
    newParent: 'Yangi ota-ona', parentNameNoAccount: 'Ota-ona F.I.Sh. (akkauntsiz)',
    created: "O'quvchi qo'shildi", deleted: "O'chirildi",
    validateFullName: 'F.I.Sh. kiriting', validateClass: 'Sinfni tanlang (majburiy)', validateGender: 'Jinsni tanlang',
  },
  studentDetailPage: { accountTitle: 'Kirish akkaunti', newPassword: 'Yangi parol', passwordHint: "Bo'sh qoldirilsa parol o'zgarmaydi", loginUpdated: 'Akkaunt yangilandi',
    deleteImpactTitle: "Diqqat — qaytarib bo'lmaydi",
    deleteImpactIntro: "{{name}} bilan birga quyidagilar ham o'chadi:",
    deleteImpactWarn: "Bu amalni orqaga qaytarib bo'lmaydi.",
    deleteAnyway: "Baribir o'chirish",
    impactContracts: "Shartnomalar ({{n}} ta) o'chmaydi, lekin egasiz qoladi.",
    impact_tolovlar: 'To\'lovlar',
    impact_davomat: 'Davomat yozuvlari',
    impact_baholar: 'Baholar',
    impact_chorak: 'Chorak baholari',
    impact_testlar: 'Test ballari',
    impact_xulq: 'Xulq baholari',
    impact_reja: "To'lov rejasi",
        createLogin: "Login yaratish",
        hasLogin: "Kabinet: {{login}}",
        loginCreated: "O'quvchi kabineti yaratildi",
        studentLoginTitle: "O'quvchi kabinetini yaratish",
        studentLoginHint: "O'quvchi shu login bilan mobil ilovaga kirib, o'z baholari va davomatini ko'radi. F.I.Sh va jinsi kartochkadan olinadi.",
    notFound: "O'quvchi topilmadi", backToList: "O'quvchilar ro'yxati", noClass: 'Sinfsiz', edit: 'Tahrirlash',
    newParent: 'Yangi ota-ona', linkExisting: 'Mavjudni biriktirish', tuitionPlan: "To'lov rejasi", parent: 'Ota-ona',
    accountChildren: 'akkaunt · {{n}} farzand', otherChildren: 'Boshqa farzandlari:', monthlyTuition: "Oylik to'lov",
    balanceTitle: 'Joriy oy balansi', balanceEmpty: "Bu oy uchun balans ma'lumoti yo'q — to'lov rejasi ham, to'lov ham qayd etilmagan.",
    tabGrades: 'Baholar', tabAttendance: 'Davomat', tabPayments: "To'lovlar", tabContacts: 'Kontaktlar',
    noGrades: "Baholar yo'q", colGrade: 'Baho', noAttendance: "Davomat yozuvlari yo'q", noPayments: "To'lovlar yo'q",
    parentAccountTitle: 'Ota-ona kabineti akkaunti', parentAccountHint: 'Ota-ona mobil kabinetga kirishi uchun login/parol yaratiladi.',
    login: 'Login', password: 'Parol', create: 'Yaratish',
    linkParentTitle: 'Mavjud ota-onani biriktirish', linkParentHint: "Boshqa farzandi tizimda bor ota-onani shu o'quvchiga biriktiring.",
    childrenCount: '{{n}} farzand', link: 'Biriktirish', editTitle: "O'quvchini tahrirlash", selectClass: 'Sinfni tanlang',
    monthlyAmount: "Oylik to'lov (so'm)", discount: "Chegirma (so'm)", final: 'Yakuniy',
    parentLinked: 'Ota-ona biriktirildi', saved: 'Saqlandi', parentCreated: 'Ota-ona akkaunti yaratildi', planSaved: "To'lov rejasi saqlandi",
    validateFullName: 'F.I.Sh. kiriting', validateLogin: 'Login kamida 3 belgi', validatePassword: 'Parol kamida 5 belgi', validateGender: 'Jinsni tanlang',
    deleted: "O'quvchi o'chirildi", deleteHint: "O'quvchini butunlay o'chirish. Bu amalni orqaga qaytarib bo'lmaydi.",
    photo: 'Rasm', uploadPhoto: 'Rasm yuklash', changePhoto: "Rasmni o'zgartirish", removePhoto: "Rasmni o'chirish",
    photoUpdated: 'Rasm yangilandi', photoRemoved: "Rasm o'chirildi",
    limitedNote: "Oxirgi {{n}} ta yozuv ko'rsatilyapti", openFull: "To'liq sahifada ochish",
    year: 'Yil', filteredTotal: "Tanlanganlar bo'yicha jami", noMatch: "Filtrga mos yozuv yo'q",
    note: 'Izoh', mainPhoneHint: "O'quvchilar ro'yxatida ko'rinadigan asosiy raqam",
    contactsHint: "Qo'shimcha telefon va manzillar «Kontaktlar» bo'limida qo'shiladi.",
  },
  homeworkPage: {
    add: "Vazifa qo'shish", searchPlaceholder: 'Vazifa sarlavhasi...', sortNew: 'Yangi vazifalar', sortDueSoon: 'Muddati (yaqin)', sortTitleAsc: 'Sarlavha (A-Z)',
    class: 'Sinf', selectClass: 'Sinfni tanlang', empty: "Uy vazifalari yo'q", subject: 'Fan', task: 'Vazifa', due: 'Muddat',
    modalTitle: "Uy vazifa qo'shish", newSubject: 'Yangi fan', titleField: 'Sarlavha', description: 'Tavsif', dueDate: 'Topshirish muddati',
    fileUrl: 'Fayl havolasi (ixtiyoriy)', subjectRequired: 'Fanni tanlang', titleRequired: 'Sarlavha kiriting', created: "Uy vazifa qo'shildi",
    mineOnly: 'Faqat meniki',
    // T6 — kim bergani + muddat
    teacher: 'Kim bergani', teacherDisabledHint: "«Faqat meniki» yoqilgan",
    dueRange: "Muddat oralig'i", dueRangeHint: "Muddatsizlar ko'rsatilmaydi",
    overdueOnly: "Muddati o'tgan", activeOnly: 'Faol', overdueHint: "Topshirish muddati o'tib ketgan",
    noDue: 'Muddatsiz',
  },
  admissionsPage: {
    stageNew: 'Yangi', stageContacted: "Bog'lanildi", stageTest: 'Test', stageInterview: 'Suhbat',
    statusOpen: 'Ochiq', statusAccepted: 'Qabul', statusRejected: 'Rad etildi', statusEnrolled: 'Yozildi',
    filterEnrolled: "Ro'yxatda", filterRejected: 'Rad', searchPlaceholder: 'Nomzod yoki telefon...', sortNew: 'Yangi murojaatlar', sortNameAsc: 'Ism (A-Z)',
    stage: 'Bosqich', status: 'Holat', empty: "Murojaatlar yo'q", applicant: 'Nomzod', age: 'Yosh', source: 'Manba', ageYears: '{{age}} yosh',
    modalTitle: 'Yangi murojaat', applicantName: "Nomzod (o'quvchi) F.I.Sh.", birthDate: "Tug'ilgan sana", birthDatePlaceholder: 'kun.oy.yil',
    sourcePlaceholder: 'Instagram, tavsiya...', note: 'Izoh', notePlaceholder: "Qo'shimcha ma'lumot, kuzatuvlar...",
    applicantRequired: 'Nomzod ismini kiriting', phoneRequired: 'Telefon kiriting', created: "Murojaat qo'shildi",
    enroll: "O'quvchiga aylantirish", enrollTitle: "O'quvchiga aylantirish",
    enrollDesc: "Nomzod ma'lumotlari to'ldirildi — sinf va jinsni tanlang, so'ng saqlang.",
    enrolled: "O'quvchi ro'yxatga olindi", enrollValidateName: 'F.I.Sh. kamida 3 harf',
    enrollValidateClass: 'Sinfni tanlang', enrollValidateGender: 'Jinsni tanlang',
    alreadyEnrolled: "Ro'yxatga olingan",
  },
  classDetail: {
    name: 'Sinf nomi', nameRequired: 'Sinf nomi majburiy', academicYear: "O'quv yili",
    homeroomTeacher: 'Sinf rahbari', homeroomTeacherPlaceholder: "O'qituvchini tanlang", noTeachers: "O'qituvchi topilmadi",
    studentsCount: "O'quvchilar", groupsCount: 'Guruhlar', students: "O'quvchilar", noStudents: "O'quvchilar yo'q",
    groups: 'Guruhlar', noGroups: "Guruhlar yo'q", edit: 'Tahrirlash', saved: 'Saqlandi',
    deleted: "Sinf o'chirildi", deleteHint: "Sinfni o'chirish qaytarib bo'lmaydi", notFound: 'Sinf topilmadi',
    // T3 — ro'yxatning o'zida o'quvchi statusini o'zgartirish
    changeStatus: "Statusni o'zgartirish", statusUpdated: 'Status yangilandi',
    changeStatusConfirm: '{{name}} — status «{{status}}» ga o\'zgartirilsinmi?',
    statusHint: "Statusni o'zgartirish uchun belgini bosing",
  },
  bannerDetail: {
    notFound: 'Banner topilmadi', preview: "Ko'rinishi", active: 'Faol', inactive: 'Faol emas',
    createdBy: "Qo'shgan", edit: 'Tahrirlash', deleteHint: "Bannerni butunlay o'chirish. Bu amalni orqaga qaytarib bo'lmaydi.",
  },
  bannerTemplate: {
    HERO: { label: 'Rasmli hero', desc: "To'liq rasm/gradient + scrim + CTA" },
    SOLID: { label: "To'liq rang", desc: 'Rang/gradient + ikonka + matn' },
    GRADIENT: { label: 'Gradient bayram', desc: 'Gradient + bezak doiralar' },
    SPLIT: { label: 'Split (media + matn)', desc: "Chapda media, o'ngda matn" },
    MINIMAL: { label: "Minimal e'lon", desc: 'Yengil karta + rangli chiziq' },
    TICKET: { label: 'Chipta (premium)', desc: 'Chipta uslubi + muhr' },
  },
  bannersPage: {
    title: 'Bannerlar', subtitle: "Ilova bosh sahifasi — shablon + 3 til + light/dark konstruktor", add: 'Yangi banner',
    empty: "Banner yo'q", emptyDesc: "Birinchi bannerni yarating — u ilova bosh sahifasida ko'rinadi.",
    preview: "Ko'rinish", templateTitle: 'Shablon / Sarlavha', audience: 'Auditoriya', active: 'Faol',
    confirmDelete: "Bannerni o'chirasizmi?", editTitle: 'Bannerni tahrirlash', createTitle: 'Yangi banner — konstruktor', template: 'Shablon',
    content: 'Kontent (har til alohida)', fieldTitle: 'Sarlavha', fieldBody: 'Matn', fieldCta: 'Tugma (CTA)', fieldEyebrow: 'Yorliq (eyebrow)',
    fallbackHint: "Bo'sh qoldirsangiz — o'zbekcha matn ishlatiladi.", design: "Dizayn (yorug'/qorong'u alohida)",
    alignLeft: 'Chap', alignCenter: 'Markaz', scrim: 'Qora gradient', emoji: 'Emoji / ikonka', themeLight: "Yorug'", themeDark: "Qorong'u",
    gradientBg: 'Gradient fon', bgColor: 'Fon rangi', gradient1: 'Gradient 1', gradient2: 'Gradient 2', ticketBg: 'Chipta foni',
    accentColor: "Urg'u rangi (CTA/chiziq/muhr)", textLight: 'Oq matn', textDark: 'Qora matn',
    uploadImage: 'Rasm yuklash', removeImage: 'Rasmni olib tashlash', imageUploadFailed: 'Rasm yuklanmadi',
    audAll: 'Hammaga', audParents: 'Ota-onalar', audFathers: 'Otalar', audMothers: 'Onalar', audTeachers: "O'qituvchilar",
    audTeachersMale: "Erkak o'qituvchilar", audTeachersFemale: "Ayol o'qituvchilar", audMales: 'Barcha erkaklar', audFemales: 'Barcha ayollar',
    audCustom: 'Tanlangan foydalanuvchilar', roleFather: 'Ota', roleMother: 'Ona', roleTeacherMale: 'Ustoz',
    users: 'Foydalanuvchilar', usersDesc: "Banner faqat tanlanganlarga ko'rinadi", usersPlaceholder: 'Ism yoki telefon...',
    linkScreen: 'Ekran (bosilganda)', linkUrl: 'Tashqi havola', startsAt: 'Boshlanish', endsAt: 'Tugash', optional: 'ixtiyoriy', screenProfile: 'Profil',
    order: 'Tartib', activeLabel: "Faol (ilovada ko'rinadi)", livePreview: "Jonli ko'rinish", saved: 'Saqlandi', deleted: "O'chirildi",
    kioskLabel: "Kiosk ekranida ko'rsatish", kioskDesc: "Banner maktabdagi TV ekranda ham aylanib turadi", kioskBadge: 'Kiosk',
    kioskAllOnly: "TV ekranida faqat «Hammaga» auditoriyali bannerlar ko'rinadi",
    kioskBadgeInactive: 'Kiosk (chiqmaydi)',
    kioskClearedWarn: "Saqlanganda kiosk belgisi o'chiriladi — TV ekranida faqat «Hammaga» auditoriyali bannerlar chiqadi. Belgi kerak bo'lsa, saqlashdan oldin auditoriyani «Hammaga» ga qaytaring",
    linkScreenFrozen: "Bu ekran vaqtincha o'chirilgan — banner ilovada UMUMAN ko'rinmaydi. Boshqa ekranni tanlang yoki havolani bo'sh qoldiring.",
  },
  platformSupportPage: {
    subtitle: 'Tizim superadmini bilan bevosita yozishma', emptyHint: "Savol yoki muammo bo'lsa — platforma superadminiga yozing.",
    messagePlaceholder: 'Xabar yozing...', send: 'Yuborish',
  },
  saasSupportPage: {
    title: 'Support — tenant adminlari', subtitle: 'Maktab adminlari bilan yozishma', emptyTitle: "Xabar yo'q",
    emptyDesc: "Tenant adminlari yozganda shu yerda ko'rinadi.", youPrefix: 'Siz: ', selectSchool: 'Maktabni tanlang',
    replyPlaceholder: 'Javob yozing...', send: 'Yuborish',
    search: 'Maktab nomi...', unreadOnly: "Faqat o'qilmagan",
  },
  saasGiftsPage: {
    title: "Sovg'alar — barcha maktablar", searchPlaceholder: 'Ism yoki telefon...', emptyTitle: "Sovg'a yo'q",
    emptyDesc: "Hali Premium sovg'alar qilinmagan.", school: 'Maktab', from: 'Kimdan', to: 'Kimga', duration: 'Muddat', anonymous: 'anonim', months: '{{n}} oy',
    tenant: 'Maktab', sortDateDesc: 'Sana (yangi)', sortDateAsc: 'Sana (eski)', sortMonthsDesc: 'Muddat (katta)',
  },
  saasPremiumPage: {
    title: 'Premium — barcha maktablar', subtitle: "To'lovlar nazorati faqat superadminda", premiumUpdated: 'Premium yangilandi',
    searchPlaceholder: 'Ism yoki telefon...', school: 'Maktab', allSchools: 'Barcha maktablar', all: 'Hammasi', regular: 'Oddiy',
    sortNameAsc: 'Ism (A-Z)', sortPremiumDesc: 'Premium muddati (uzoq)', sortPremiumAsc: 'Premium muddati (yaqin)', sortNewest: "Yangi qo'shilganlar",
  },
  layout: { search: 'Qidirish' },
  contractGen: {
    tooltip: "Shartnoma yaratish va yuborish", modalTitle: 'Ota-onalar shartnomasi', contractNumber: 'Shartnoma raqami',
    contractNumberAuto: "Bo'sh qoldiring — raqamni server avtomatik beradi",
    contractNumberPlaceholder: 'Avtomatik',
    contractDate: 'Shartnoma sanasi', studentName: "O'quvchi F.I.O.", parentName: "Ota-ona (yoki o'rnini bosuvchi shaxs) F.I.O.",
    parentAddress: 'Ota-onaning yashash manzili', durationMonths: "O'qish muddati (oy)", passport: 'Pasport seriya va raqami',
    jshshir: 'JShShIR (ixtiyoriy)', jshshirPlaceholder: '14 ta raqam',
    selectFromPhones: 'Ota-ona raqamlaridan tanlash', selectPhone: 'Raqam tanlang',
    phoneLabel: "Ota-ona telefoni", phoneLabelExtra: "Qo'shimcha",
    parentFillsHint: "Ixtiyoriy — ota-ona havolada o'zi to'ldiradi",
    // T1 — shaxsni tasdiqlovchi maydonlar yopiq bo'limga olindi
    identitySection: "Shaxsni tasdiqlovchi ma'lumotlar (ixtiyoriy)",
    identityHint: "F.I.O., manzil, pasport va JSHSHIR ni ota-ona havola orqali O'ZI to'ldiradi va imzolashda tasdiqlaydi — maktab ularni kiritishi shart emas.",
    parentNameOptional: "Ixtiyoriy — bo'sh qoldirilsa ota-ona imzolashda o'zi kiritadi",
    identityFilled: "{{count}} ta to'ldirilgan",
    attachPhone: 'Yangi raqamni ota-onaga biriktirish',
    attachPhoneHint: "Bu raqam ota-onaning kontaktlariga qo'shiladi. Belgini olib tashlasangiz, raqam faqat shartnomada qoladi.",
    phoneAttached: "Yangi raqam ota-onaning kontaktlariga qo'shildi.",
    phoneAttachFailed: "Yangi raqamni ota-onaga biriktirib bo'lmadi — kontaktlarni qo'lda tekshiring. Shartnoma baribir yaratildi.",
    fromDate: 'Shartnoma muddati (dan)', toDate: 'Shartnoma muddati (gacha)', createAndSend: "Yaratish va yuborish",
    parentNameTooShort: 'F.I.O. kamida 5 belgi bo\'lishi kerak',
    addressTooShort: 'Manzil kamida 5 belgi bo\'lishi kerak',
    passportInvalid: "Pasport formati noto'g'ri (masalan: AB 1234567)",
    jshshirInvalid: "JSHSHIR 14 ta raqamdan iborat bo'lishi kerak",
    parentPhoneInvalid: "Telefon raqamini to'liq kiriting",
    paymentRequired: "Oylik to'lov musbat son bo'lishi kerak",
    paymentTooBig: "Oylik to'lov juda katta — qiymatni tekshiring",
    monthsInvalid: "O'quv oylari soni 1 dan 12 gacha bo'lishi kerak",
    fromDateRequired: 'Boshlanish sanasini tanlang', toDateRequired: 'Tugash sanasini tanlang',
    toDateBeforeFrom: "Tugash sanasi boshlanish sanasidan keyin bo'lishi kerak",
    numberTaken: 'Bu raqamli shartnoma allaqachon mavjud — boshqa raqam kiriting yoki maydonni bo\'sh qoldiring',
    numberIssued: 'Shartnoma raqami: {{number}}',
    requisitesTitle: "Maktab rekvizitlari to'ldirilmagan",
    requisitesHint: "Shartnoma hujjati maktab rekvizitlarisiz yaratilmaydi. Ularni Sozlamalar bo'limida to'ldiring.",
    requisitesHintNoAccess: "Shartnoma hujjati maktab rekvizitlarisiz yaratilmaydi. Rekvizitlarni faqat maktab ma'muriyati (direktor yoki admin) to'ldira oladi — iltimos, ularga murojaat qiling.",
    requisitesLink: 'Sozlamalar — maktab rekvizitlari',
    openContract: 'Shartnomani ochish',
    createdNotified: "Shartnoma yaratildi va ota-onaga ilovada yuborildi", createdNoApp: "Shartnoma yaratildi (ota-ona ilovada yo'q — havolani ulashing)",
    create: 'Shartnoma yaratish',
    linkReady: 'Havola tayyor', notified: "Ota-onaga ilovada bildirishnoma yuborildi — shartnomani ilovada ko'rib, imzolaydi.", notNotified: "Bu o'quvchiga ota-ona akkaunti bog'lanmagan — bildirishnoma bormadi. Quyidagi havolani ota-onaga o'zingiz ulashing.",
    noParentWarn: "Bu o'quvchiga ota-ona akkaunti bog'lanmagan — ilovaga bildirishnoma bormaydi. Shartnoma yaratilgach, havolani ota-onaga o'zingiz ulashasiz.",
    copied: 'Nusxa olindi', copy: 'Nusxa', linkNote: "Havola orqali ota-ona shartnomani o'qib, ma'lumotlarini kiritadi va onlayn imzolaydi. Ota-ona ilovasi bo'lsa, shartnoma o'sha yerda ham ko'rinadi.", close: 'Yopish',
  },
  contractList: {
    tab: 'Shartnomalar', empty: 'Shartnoma yaratilmagan', number: 'Raqami', created: 'Yaratilgan',
    student: "O'quvchi",
    statusSENT: 'Yuborildi', statusVIEWED: "Ko'rildi", statusSIGNED: 'Tasdiqlandi', statusREJECTED: 'Rad etildi', statusCANCELLED: 'Bekor qilindi',
    expired: "Muddati o'tgan",
    expiredHint: "Havola muddati tugagan — ota-ona imzolay olmaydi. Qayta yuboring (yangi havola va yangi muddat beriladi).",
    expiresAt: 'Havola muddati', viewedAt: "Ota-ona ochgan sana", notViewed: 'Hali ochilmagan',
    answeredAt: 'Javob sanasi', waitingDays: '{{n}} kundan beri kutilmoqda',
    signedAt: 'Tasdiqlangan sana', signer: 'Imzolagan shaxs', signature: 'Imzo', signatureNone: "Imzo yo'q",
    signedVia: 'Imzolash yo\'li', viaApp: 'Mobil ilova', viaToken: "Ochiq havola", rejectedVia: 'Rad etish yo\'li',
    rejectedAt: 'Rad etilgan sana', rejectReason: 'Rad etish sababi', parentData: "Ota-ona kiritgan ma'lumotlar",
    cancelledAt: 'Bekor qilingan sana', cancelReason: 'Bekor qilish sababi', cancelledBy: 'Kim bekor qildi', createdBy: 'Kim yaratdi',
    terms: 'Shartnoma shartlari', period: 'Amal qilish muddati',
    compareTitle: "Maktab kiritgan ↔ ota-ona kiritgan", field: 'Maydon', schoolValue: 'Maktab', parentValue: 'Ota-ona', changed: "o'zgartirilgan",
    auditTitle: 'Audit', device: 'Qurilma / brauzer',
    frozenCopy: 'Muzlatilgan nusxa', frozenYes: 'Saqlangan ({{at}})', frozenNo: "Saqlanmagan — hujjat har safar qayta quriladi",
    downloadsLeft: "Qolgan yuklab olishlar (ochiq havola)",
    downloadsLeftHint: "Bu chegara FAQAT ochiq havolaga tegishli. Mobil ilovadagi ota-ona va maktab arxivi uchun cheklov yo'q.",
    details: 'Batafsil', detailsTitle: 'Shartnoma tafsilotlari',
    link: 'Ota-ona havolasi', openLink: 'Havolani ochish', address: 'Manzil', notFilled: "Ota-ona hali ma'lumot kiritmagan",
    openLinkWarn: "Havola ota-ona uchun. Ota-ona o'rniga imzolash yuridik kuchga ega emas — havolani faqat tekshirish yoki ulashish uchun oching.",
    loadError: "Shartnomalarni yuklab bo'lmadi.", detailLoadError: "Shartnoma ma'lumotini yuklab bo'lmadi.", retry: 'Qayta urinish',
    download: 'DOCX yuklab olish', downloadFailed: "Hujjatni yuklab bo'lmadi",
    resend: 'Qayta yuborish', resendTitle: 'Shartnomani qayta yuborish',
    resendHint: "Yangi havola va yangi muddat beriladi, ota-onaga ilovada qayta bildirishnoma boradi. ESKI HAVOLA ishlamay qoladi. Rad etilgan shartnoma yana «Yuborildi» holatiga qaytadi.",
    resendNewLink: 'Yangi havola tayyor', resendNotified: "Ota-onaga ilovada bildirishnoma yuborildi.",
    resendNotNotified: "Ota-ona akkaunti bog'lanmagan — quyidagi yangi havolani ota-onaga o'zingiz ulashing.",
    resendDone: 'Shartnoma qayta yuborildi', resendDoneNoApp: "Yangi havola yaratildi (ota-ona ilovada yo'q)",
    resendFailed: "Qayta yuborib bo'lmadi",
    cancelAction: 'Bekor qilish', cancelTitle: 'Shartnomani bekor qilish',
    cancelHint: "Bekor qilinganda ota-onaning havolasi DARHOL ishlamay qoladi va sabab unga ko'rsatiladi. Bu amalni orqaga qaytarib bo'lmaydi — kerak bo'lsa yangi shartnoma yarating.",
    cancelReasonLabel: 'Bekor qilish sababi', cancelReasonPlaceholder: "Sababni yozing — ota-onaga ko'rsatiladi",
    cancelReasonRequired: 'Sababni yozing (kamida 3 belgi)', cancelDone: 'Shartnoma bekor qilindi', cancelFailed: "Bekor qilib bo'lmadi",
  },
  contractsPage: {
    emptyFiltered: "Natijalarni filtr yashirmoqda",
    emptyFilteredDesc: "Quyidagi filtrlar qo'llangan: {{list}}. Ularni tozalasangiz barcha shartnomalar ko'rinadi.",
    search: "Raqam, o'quvchi yoki ota-ona ismi...",
    exportCsv: 'CSV yuklab olish (barcha sahifalar)',
    exportAllHint: "Joriy filtrga mos BARCHA shartnomalar yuklanadi — faqat ochiq sahifa emas. Ro'yxat katta bo'lsa biroz vaqt oladi.",
    exportTruncated: "Qatorlar juda ko'p: {{total}} tadan faqat birinchi {{n}} tasi yuklandi. Filtrni toraytiring.",
    exportFailed: "Eksport bajarilmadi — qayta urinib ko'ring",
    pendingQuick: 'Javob kutilmoqda',
    filterExpiry: 'Muddati', expiredOnly: "Muddati o'tganlar", notExpired: "Muddati o'tmaganlar",
    studentFilter: "O'quvchi bo'yicha",
    colWaiting: 'Kutish (kun)', stale: '{{n}} kundan ortiq',
    colLastSent: 'Oxirgi yuborilgan', lastSentAt: 'Hisob oxirgi yuborilgan sanadan: {{at}}',
    sortNewest: 'Yangi shartnomalar', sortLongestWaiting: 'Eng uzoq kutayotgani',
    sortNumberDesc: 'Raqam (kamayish)', sortNumberAsc: "Raqam (o'sish)",
    sortSigned: 'Imzolangan sana', sortExpiringSoon: 'Muddati yaqinlari', sortStatus: 'Holat',
    // T12 — faol filtrlar ko'rinib tursin
    activeFilters: 'Faol filtrlar', clearAll: 'Hammasini tozalash', removeFilter: 'Filtrni olib tashlash',
    searchChip: 'Qidiruv: {{q}}',
  },
  paymentsPage: {
    selectStudent: "O'quvchini tanlang", paymentAccepted: "To'lov qabul qilindi", totalRevenue: 'Umumiy tushum', paymentsCount: "To'lovlar soni",
    searchPlaceholder: "O'quvchi ismi yoki izoh...", sortAmountDesc: 'Summa (katta)', sortAmountAsc: 'Summa (kichik)',
    method: 'Usul', methodCash: 'Naqd', methodCard: 'Karta', methodTransfer: "O'tkazma", methodOther: 'Boshqa',
    studentSearchPlaceholder: "Ism bo'yicha qidiring...", amountSom: "Summa (so'm)", paymentMethod: "To'lov usuli",
    dateFrom: 'Sanadan', dateTo: 'Sanagacha', dateTimePlaceholder: 'kun.oy.yil soat:daqiqa',
    forMonth: 'Qaysi oy uchun', classFilter: 'Sinf',
    forMonthRequired: "«Qaysi oy uchun» tanlanishi SHART — oysiz to'lov qarzdan yechilmaydi va tushum hisobotiga kirmaydi",
    noMatch: "Filtrga mos to'lov yo'q",
    forMonthRangeHint: "«Qaysi oy uchun» va to'lov sanasi oralig'i BIRGA qo'llanadi: oy — to'lov qaysi oyga tegishli ekani, oraliq — to'lov qachon qabul qilingani. Ular mos kelmasa ro'yxat bo'sh chiqadi.",
    clearRange: "Sana oralig'ini tozalash",
    monthCount: 'Necha oy uchun', monthsN: '{{count}} oy', notePlaceholder: 'Masalan: 4 oylik oldindan to\'lov',
    splitPreview: '{{from}} — {{to}}: summa oylarga bo\'linadi, har oyga ≈ {{each}}. Ota-onaga bitta chek beriladi.',
    edit: 'Tahrirlash', editTitle: "To'lovni tahrirlash", note: 'Izoh', editSaved: "To'lov tahrirlandi",
    editReason: 'Tahrirlash sababi', editReasonPlaceholder: 'Masalan: kassir summani xato kiritgan', editReasonRequired: 'Sababni yozing',
    editFinancialHint: "Summa, oy, usul yoki sana o'zgargani uchun eski to'lov «qaytarilgan pul» deb yopiladi va to'g'rilangan yangi to'lov yoziladi. Eski chek haqiqiy bo'lmaydi — yangi chek beriladi.",
    badgeStorno: 'Qaytarilgan pul', badgeReversed: 'Qaytarilgan',
  },
  receipt: {
    title: "To'lov cheki", no: 'Chek № {{no}}', school: 'Maktab', date: 'Sana', student: "O'quvchi", class: 'Sinf',
    forMonth: 'Qaysi oy uchun', method: "To'lov usuli", note: 'Izoh', issuedBy: 'Qabul qildi',
    thanks: "To'lovingiz uchun rahmat!", printedAt: 'Chop etildi: {{at}}',
    print: 'Chop etish', close: 'Yopish', open: 'Chek', notFound: 'Chek topilmadi',
  },
  faceLink: {
    none: "Bog'lanmagan", manage: "FACE ID bog'lash", title: "FACE ID terminalga bog'lash",
    pickHint: "Qurilmada bor, lekin hech kimga bog'lanmagan yozuvni tanlang. ★ — ismi shu xodimga o'xshash.",
    pickPlaceholder: 'Qurilmadagi yozuvni tanlang', noFree: "Bo'sh yozuv yo'q", link: "Bog'lash", or: 'yoki',
    enrollHint: "Xodim qurilmada umuman yo'q bo'lsa — terminalga yangi yozuv qilib yozing. Keyin u terminal oldida yuzini ro'yxatdan o'tkazadi.",
    enroll: 'Terminalga yozish', unlink: 'Uzish',
    linked: "Bog'landi", linkedRestored: "Bog'landi — oxirgi {{count}} kunlik davomat tiklandi", unlinked: 'Uzildi',
    enrollQueued: "Navbatga qo'yildi — №{{no}}. Agent ishga tushganda terminalga yoziladi",
    pendingHint: "Navbatda — agent hali terminalga yozmagan", okHint: "Bog'langan, yuzi terminalda bor — davomat avtomatik yoziladi.",
    noFaceHint: "Bog'langan, lekin yuzi hali ro'yxatdan o'tmagan — xodim terminal oldida yuzini ro'yxatdan o'tkazsin.",
  },
  faceid: {
    pickStaff: 'Xodimni tanlang', linked: "Bog'landi",
    setHttpHost: "Terminalni serverga ulash",
    setHttpHostHint: "Bir marta bosiladi. Shundan keyin qurilma har o'tishni o'zi serverga yuboradi — maktabda hech narsa yoqiq turishi shart bo'lmaydi.",
    subtitle: "Yuz tanish terminali — davomat va boshqaruv",
    autonomyNote: "Davomat yig'ilishi uchun bu sahifa ochiq turishi SHART EMAS. Terminal har o'tishni o'zi serverga yuboradi: ishchi 07:12 da o'tsa, yozuv 07:12 bo'lib keladi — panelni kim qachon ochgani ahamiyatsiz.",
    connectTitle: 'Terminalga ulanish',
    connectHint: "Qurilmaning ichki tarmoqdagi manzili va admin paroli. Ular faqat serverda saqlanadi.",
    defaultName: 'Asosiy kirish',
    settings: 'Sozlamalar',
    name: 'Nomi', host: 'IP manzil', port: 'Port', username: 'Login', password: 'Parol',
    passwordKeep: "Bo'sh qoldirilsa parol o'zgarmaydi",
    nameRequired: 'Nom kiriting', hostRequired: 'IP manzil kiriting', passwordRequired: 'Parol kiriting',
    chooseTerminal: 'Terminal',
    loadError: "Terminal ma'lumotlarini yuklab bo'lmadi — qayta urinib ko'ring.",
    status: 'Holat', online: 'Onlayn', offline: 'Oflayn',
    lastSeen: 'Oxirgi aloqa', lastSync: 'Oxirgi sinxronlash',
    peopleCount: 'Qurilmada', eventCount: 'Hodisalar',
    enabled: 'Terminal yoqilgan',
    enabledHint: "O'chirilsa qurilmadan hech narsa qabul qilinmaydi",
    attendanceEnabled: 'Yuz bilan davomat',
    attendanceEnabledHint: "O'chirilsa hodisa saqlanadi, lekin davomatga yozilmaydi — qo'lda davomatga o'tasiz",
    syncPeople: 'Odamlarni sinxronlash', syncEvents: 'Hodisalarni tortish', ping: 'Aloqani tekshirish',
    syncHint: "Bu amallar maktab ichidagi agent orqali bajariladi — u ishga tushgach navbatdan oladi.",
    taskCancel: "Bekor qilish",
    taskCancelled: "Vazifa bekor qilindi",
    agentLastSeen: "Agent oxirgi marta {{time}} da ishlagan",
    agentsTitle: "Agentlar (maktab kompyuterlari)",
    agentsHint: "Agent — paneldagi buyruqlarni terminalga yetkazadigan kichik dastur. Uni maktab tarmog'idagi 2–3 kompyuterga o'rnating: qaysi biri yoqiq bo'lsa, navbatni o'sha bajaradi.",
    agentsEmpty: "Agent hali hech qaysi kompyuterga o'rnatilmagan — buyruqlar navbatda qolib ketadi.",
    agentComputer: "Kompyuter",
    agentState: "Holat",
    agentTerminal: "Terminal",
    agentVersion: "Versiya",
    agentSeen: "Oxirgi aloqa",
    agentOnline: "Onlayn",
    agentOffline: "Oflayn",
    terminalVisible: "Ko'rinadi",
    terminalHidden: "Ko'rinmaydi",
    terminalUnknown: "Noma'lum",
    terminalHiddenHint: "Kompyuter maktab tarmog'ida emas yoki terminal o'chiq — bu agent buyruq olmaydi",
    appDownload: "SATA Agent (Windows) yuklab olish",
    appVersion: "Versiya {{v}}",
    appNotReleased: "SATA Agent o'rnatuvchisi hali chiqarilmagan — SATA administratoriga murojaat qiling.",
    appLinkError: "O'rnatuvchi havolasini olib bo'lmadi.",
    appStep1: "Maktab kompyuterida (Windows 10/11) o'rnatuvchini yuklab oling va o'rnating.",
    appStep2: "Ilovada quyidagi agent kalitini kiriting va «Ulash» ni bosing.",
    appStep3: "Shundan keyin ilova ochilganda panel o'zi ochiladi. Maktabning birinchi kompyuterini SATA administratori, keyingilarini direktor tasdiqlaydi (FACE ID → Qurilmalar).",
    agentKeyWarn: "Agent kaliti — maktab terminalining kaliti: uni maktabdan tashqariga yubormang.",
    appKeyStaffOnly: "Agent kalitini direktor yoki administrator beradi.",
    queued: "Navbatda {{count}} ta ish bor — ular maktabdagi agent ishga tushganda bajariladi. Yangi xodim shu ish bajarilgach terminal xotirasiga tushadi.",
    taskQueued: "Vazifa navbatga qo'yildi", taskAlready: 'Bu vazifa allaqachon navbatda',
    peopleTitle: 'Qurilmadagi odamlar', noPeople: "Hali sinxronlanmagan — «Odamlarni sinxronlash» ni bosing",
    unlinkedWarn: "{{count}} ta shaxs ERP xodimiga bog'lanmagan — ular uchun davomat yozilmaydi",
    employeeNo: 'Raqami', deviceName: 'Qurilmadagi ism', face: 'Yuz', erpUser: 'ERP xodimi',
    faceYes: 'bor', faceNo: "yo'q", notLinked: "bog'lanmagan",
    tasksTitle: 'Vazifalar',
    noTerminalAsk: "Terminal hali qo'shilmagan. Uni direktor yoki administrator qo'shadi.",
    keysTitle: 'Ulanish kalitlari',
    keysHint: "Birinchisi qurilmaning «HTTP Listening» sozlamasiga, ikkinchisi agentga kiritiladi.",
    ingestUrl: 'Hodisa manzili', agentKey: 'Agent kaliti',
    remove: "Terminalni o'chirish", removed: "Terminal o'chirildi",
  },
  // FACE ID agenti — holat belgisi, batafsil oyna, superadmin sahifasi (lib/agent.ts, components/AgentOynasi.tsx)
  agent: {
    holat: {
      eskiVersiya: 'Eski versiya', aloqaYoq: "Aloqa yo'q", toxtatilgan: "To'xtatilgan", ishlayapti: 'Ishlayapti',
      terminalYoq: "Terminal ko'rinmaydi", terminalSozlanmagan: 'Terminal sozlanmagan', serverYoq: 'Server bilan muammo',
      kalitXato: 'Kalit xato', tekshirilmoqda: 'Tekshirilmoqda',
    },
    davomiylik: { daq: '{{n}} daq', soat: '{{n}} soat', kun: '{{n}} kun' },
    eskiIzoh: 'Holat yubormaydi — SATA Agent 0.1.3 ga yangilang',
    tur: { QAYTA_ISHGA_TUSHIR: 'Qayta ishga tushirish', LOG: 'Logni olish', YANGILA: 'Hozir yangilash', TOXTAT: "To'xtatish", DAVOM: 'Davom ettirish' },
    buyruqHolat: { KUTILMOQDA: 'Kutilmoqda', YUBORILDI: 'Yuborildi', BAJARILDI: 'Bajarildi', XATO: 'Xato', MUDDATI_OTDI: "Muddati o'tdi" },
    maktab: 'Maktab', terminal: 'Terminal', versiya: 'Versiya', os: 'Tizim', ip: 'IP',
    ishgaTushgan: 'Ishga tushgan', oxirgiAloqa: 'Oxirgi aloqa', oxirgiXato: 'Oxirgi xato',
    band: 'Buyruq bajarilmoqda',
    buyruqlar: 'Buyruqlar',
    yangilangIzoh: "Bu kompyuterdagi ilova eski — paneldan buyruq qabul qilmaydi. SATA Agent 0.1.3 ga yangilang.",
    faqatStaff: 'Buyruqlarni direktor yoki administrator beradi.',
    maktabsiz: "Maktabga bog'lanmagan terminal — bu kompyuterga buyruq berib bo'lmaydi.",
    tasdiqSarlavha: 'Buyruqni tasdiqlang',
    tasdiqQayta: 'Ilova qayta ishga tushadi: joriy vazifa tugashi kutiladi (1 daqiqagacha).',
    tasdiqToxtat: 'Davomat va FACE ID buyruqlari shu kompyuterda bajarilmaydi.',
    buyruqYuborildi: 'Buyruq yuborildi — kompyuter 15 soniya ichida oladi',
    xTakror: 'Oldingi buyruq hali bajarilmagan — natijasini kuting.',
    vazifalar: 'Oxirgi vazifalar', vazifaYoq: 'Bu kompyuter hali vazifa bajarmagan',
    tarix: 'Buyruqlar tarixi', tarixYoq: 'Hali buyruq berilmagan',
    colTur: 'Tur', colHolat: 'Holat', colVaqt: 'Vaqt', colKim: 'Kim', colNatija: 'Natija', colMaktab: 'Maktab',
    log: 'Log', logYoq: 'Log hali olinmagan', logBosh: "Log bo'sh", logKutilmoqda: 'Log kutilmoqda — kompyuter 15 soniyada oladi…',
    nusxaOl: 'Nusxa olish', nusxaOlindi: 'Nusxa olindi',
    yuklanmadi: "Kompyuter ma'lumotini yuklab bo'lmadi — eski holat noto'g'ri chiqmasligi uchun ko'rsatilmayapti.",
    qatorniBosing: 'Qatorni bosing — holat, vazifalar, log va buyruqlar',
    sahifaIzoh: "Barcha maktablarning so'nggi 30 kunda ko'ringan kompyuterlari. Muammolilar tepada.",
    jami: 'Jami: {{n}}', muammoli: 'Muammoli: {{n}}',
    bosh: "So'nggi 30 kunda birorta kompyuter ko'rinmadi",
    royxatYuklanmadi: "Kompyuterlar ro'yxatini yuklab bo'lmadi — eski holatlar noto'g'ri chiqmasligi uchun ro'yxat ko'rsatilmayapti.",
    qaytaUrinish: 'Qayta urinish',
  },
  staffAttendance: {
    title: 'Xodimlar davomati', date: 'Sana', staff: 'Xodim', role: 'Lavozim',
    in: 'Keldi', out: 'Ketdi', markIn: 'Keldi', markOut: 'Ketdi', done: 'Yakunlandi',
    manual: "Qo'lda",
    summary: '{{kelgan}} / {{jami}} keldi',
    searchPlaceholder: 'Ism yoki lavozim...',
    undoOut: "Ketishni bekor qilish (kelish vaqti qoladi)",
    restDay: "Bu kun dam olish kuni — davomat olinmaydi",
    undone: 'Ketish bekor qilindi',
    found: '{{jami}} tadan {{topilgan}} tasi topildi',
    empty: 'Faol xodim topilmadi',
    addTitle: 'Davomatni belgilash', editTitle: 'Davomatni tahrirlash',
    markWithTime: 'Vaqt bilan belgilash', edit: 'Tahrirlash',
    saved: 'Saqlandi', deleted: "Yozuv o'chirildi", delete: "O'chirish", deleteConfirm: "Rostdan o'chirilsinmi?",
    outBeforeIn: "Ketish kelishdan keyin bo'lsin",
    outHint: "Ketish vaqti bo'sh qolsa — xodim hali ishda deb hisoblanadi.",
    cellHint: "Katakni bosib, o'sha kun uchun keldi/ketdi vaqtini belgilash yoki tuzatish mumkin",
    range: "Sana oralig'i", thisWeek: 'Shu hafta', thisMonth: 'Shu oy', lastMonth: "O'tgan oy",
    modeDay: 'Kunlik', modeMonth: 'Hisobot', month: 'Oy',
    daysIn: 'Keldi (kun)', daysOut: 'Kelmadi', hours: 'Soat',
    monthSummary: '{{ish}} ish kuni, shundan {{otgan}} kuni o\'tdi',
    legend: "Yashil — keldi, qizil — ish kuni bo'lsa ham kelmadi, kulrang — dam olish kuni, • — hali ketmagan",
    faceNote: "Yuz tanish terminali ishlaganda bu yerga yozuvlar o'zidan tushadi. Qo'lda belgilash terminal nosoz bo'lgan kunlar uchun — ikkalasi bitta jadvalga yozadi, shuning uchun to'qnashmaydi.",
  },
  audit: {
    pageDesc: "Kim, nima, qachon va qaysi manzildan o'zgartirgani",
    logTitle: 'Amallar jurnali',
    blockedTitle: 'Bloklangan manzillar',
    blockedHint: "Bu manzillardan kelgan so'rovlar rad etiladi",
    blockedEmpty: "Bloklangan manzil yo'q",
    blockAdd: 'Manzilni bloklash',
    blockWarn: "Diqqat: maktabda hamma bitta tashqi manzil ortida bo'lishi mumkin — bloklash butun maktabni uzib qo'yadi. Davomat terminaliga ta'sir qilmaydi.",
    block: 'Bloklash',
    unblock: 'Ochish',
    blocked: 'Manzil bloklandi',
    unblocked: 'Blok olib tashlandi',
    ip: 'Manzil (IP)',
    reason: 'Sabab',
    until: 'Muddati',
    forever: 'Muddatsiz',
    hits: 'To\'silgan',
    auto: 'Avtomatik',
    hours: 'Necha soat',
    hoursHint: "0 yoki bo'sh — muddatsiz",
    when: 'Vaqt',
    who: 'Kim',
    school: 'Maktab',
    what: 'Amal',
    status: 'Natija',
    path: "Yo'l",
    method: 'Turi',
    from: 'Dan',
    to: 'Gacha',
    empty: 'Yozuv topilmadi',
    anon: "Noma'lum",
    last24: 'Oxirgi 24 soat',
    actions: "o'zgartirish",
    rejected: 'Rad etilgan',
    rejectedHint: 'xato yoki to\'silgan urinishlar',
    topAccount: 'Eng faol hisob',
    status2: 'Muvaffaqiyatli (2xx)',
    status4: 'Rad etilgan (4xx)',
    status5: 'Server xatosi (5xx)',
    allSchools: 'Barcha maktablar',
    noTenant: 'Platforma (maktabsiz)',
  },
  lessonTimes: {
    section: 'Dars vaqtlari',
    sectionDesc: "Jadvaldagi soatlar shu sozlamadan hisoblanadi",
    start: 'Birinchi dars',
    duration: 'Dars (daq)',
    break: 'Tanaffus (daq)',
    note: "n-dars = boshlanish + (n-1) × (dars + tanaffus)",
  },
  workDays: {
    section: 'Ish kunlari va bayramlar',
    sectionDesc: "Dars va davomat kunlari. Oylik maoshning kunlik qiymati «Maosh qoidasi → Maosh ish kunlari» dan olinadi",
    mon: 'Dush', tue: 'Sesh', wed: 'Chor', thu: 'Pay', fri: 'Juma', sat: 'Shan', sun: 'Yaksh',
    thisMonth: '{{oy}} oyida {{kun}} ish kuni',
    holidaysExcluded: '{{n}} bayram chiqarildi',
    holidays: 'Bayram va dam olish sanalari',
    holidaysEmpty: "{{yil}}-yilda belgilangan sana yo'q",
    date: 'Sana',
    name: 'Nomi',
    namePlaceholder: "Navro'z, Mustaqillik kuni...",
    note: 'Bu sozlama quyidagilarga ta\'sir qiladi:',
    affects: "o'quvchi va xodim davomati",
  },
  backup: {
    connectedTo: 'Ulangan chat:',
    hour: 'Vaqti', hourHelp: 'Toshkent vaqti',
    exactAt: 'Aniq vaqt: {{time}}',
    tokenConnected: 'Bot ulangan',
    tokenReplace: 'Yangi botni ulash',
    section: 'Zaxira nusxa',
    openHint: "Telegram orqali kunlik zaxira — sozlash uchun oching",
    on: 'Yoqilgan',
    warning: "DIQQAT: chat_id xato bo'lsa maktabning BARCHA ma'lumoti begona kanalga yuboriladi. Kanalni va botni yaxshilab tekshiring.",
    token: 'Bot tokeni', tokenSet: 'kiritilgan', tokenNone: "kiritilmagan",
    tokenKeep: "Bo'sh qoldirilsa mavjud token o'zgarmaydi",
    tokenHelp: "@BotFather dan olinadi. Bot kanalga admin qilib qo'shilishi kerak.",
    tokenBad: "Token shakli noto'g'ri (123456:ABC-...)",
    chatId: 'Chat ID', chatHelp: "Kanal raqami (-100... ) yoki @kanal_nomi",
    chatBad: "Raqam yoki @kanal bo'lishi kerak",
    daily: 'Har kuni avtomatik', dailyHint: 'Toshkent vaqti bilan kechqurun',
    testSend: 'Hozir yuborib ko\'rish', sent: 'Yuborildi',
    remove: "Sozlamani o'chirish", removed: "Zaxira sozlamasi o'chirildi",
    lastAt: 'Oxirgi',
    scopeNote: "Faylda FAQAT shu maktab ma'lumoti bo'ladi — parollar va kalitlar tushmaydi. Nomi:",
  },
  export: {
    tooltip: "Joriy filtr bo'yicha BUTUN ro'yxatni Excel faylga yuklash",
    empty: "Yuklash uchun ma'lumot yo'q",
    done: '{{rows}} qator yuklandi',
    doneSheets: "{{rows}} qator, {{sheets}} ta varaqqa (choraklar bo'yicha) bo'lindi",
  },
  pager: {
    range: '{{from}}–{{to}} / jami {{total}}',
    perPage: 'Sahifadagi qatorlar', page: 'sahifa',
  },
  parentsPage: {
      add: "Ota-ona qo'shish", addHint: "Akkaunt yaratilgach kartochkasi ochiladi — farzandni o'sha yerda biriktirasiz.",
    searchPlaceholder: 'Ism yoki telefon...', sortPremium: 'Premium muddati', regular: 'Oddiy', giftsSentReceived: "Sovg'alar (berdi/oldi)",
  },
  announcementsPage: {
    bodyRequired: 'Matn kiriting', selectScreen: 'Ekranni tanlang', fullUrlRequired: "To'liq URL kiriting (https://...)", posted: "E'lon joylandi",
    searchPlaceholder: 'Sarlavha yoki matn...', sortNew: "Yangi e'lonlar", audienceTo: 'Kimga', classNamed: 'Sinf: {{name}}', appNamed: 'Ilova: {{screen}}',
    titleUz: "Sarlavha (o'zbekcha)", bodyUz: "Matn (o'zbekcha)", translations: 'Tarjimalar (ixtiyoriy — ru/en)',
    titleRu: 'Sarlavha (ruscha)', bodyRu: 'Matn (ruscha)', titleEn: 'Sarlavha (inglizcha)', bodyEn: 'Matn (inglizcha)',
    whichClass: 'Qaysi sinf', linkOptional: 'Havola (ixtiyoriy)', linkNone: 'Havolasiz', linkApp: 'Ilova ichidagi sahifa', linkUrl: 'Tashqi (global) havola',
    appScreenLabel: 'Ilova sahifasi', selectScreenPlaceholder: 'Sahifani tanlang', url: 'URL', post: 'Joylash',
    class: 'Sinf',
  },
  supportPage: {
    back: 'Orqaga',
    title: 'Support — foydalanuvchilar bilan chat', searchPlaceholder: 'Ism yoki telefon...', noMessages: "Xabarlar yo'q",
    emptyDesc: "Foydalanuvchilar yozganda shu yerda ko'rinadi.", youPrefix: 'Siz: ', selectThread: 'Suhbatni tanlang', replyPlaceholder: 'Javob yozing...',
    unreadOnly: "Faqat o'qilmagan",
    noMatch: "Mos suhbat topilmadi", noMatchDesc: "Qidiruv yoki filtrni o'zgartiring.",
  },
  premiumPage: {
    title: "Premium sovg'alar", subManage: 'obuna boshqaruvi Ota-onalar sahifasida', searchPlaceholder: 'Yuboruvchi yoki oluvchi...', sortMonthsDesc: 'Muddat (katta)',
    anonymity: 'Anonimlik', anonymous: 'Anonim', open: 'Ochiq', from: 'Kimdan', to: 'Kimga', duration: 'Muddat', greeting: 'Tabriknoma', sentAnon: 'anonim yuborilgan', months: '{{n}} oy',
    emptyTitle: "Sovg'alar yo'q", emptyDesc: "Ota-onalar bir-biriga Premium sovg'a qilganda shu yerda ko'rinadi.",
    errorTitle: "Ma'lumotni yuklab bo'lmadi", errorDesc: "Premium sovg'alar ro'yxatiga ruxsat yo'q yoki server javob bermadi.",
  },
  attPage: {
    tabStudents: "O'quvchilar", tabStaff: 'Xodimlar',
    saveError: "Saqlashda xatolik — qayta urinib ko'ring", searchStudent: "O'quvchi qidirish", namePlaceholder: 'Ism...',
    selectClassToMark: 'Davomatni belgilash uchun sinfni tanlang', selectDateToMark: 'Sanani tanlang', noStudentsInClass: "Bu sinfda o'quvchilar yo'q", saved: 'Saqlandi',
    restDay: "Bu kun dam olish kuni — davomat olinmaydi",
    loadError: "Davomatni yuklab bo'lmadi — ro'yxat ko'rsatilmayapti, chunki holatlar noto'g'ri chiqishi mumkin.", retry: 'Qayta urinish',
  },
  gradesPage: {
    selectStudent: "O'quvchini tanlang", selectSubject: 'Fanni tanlang', gradeRange: "Baho 1-5 oralig'ida", gradeAdded: "Baho qo'yildi",
    addGrade: "Baho qo'yish", searchPlaceholder: "O'quvchi ismi...", sortValueDesc: 'Baho (yuqori)', sortValueAsc: 'Baho (past)',
    selectClassToView: "Baholarni ko'rish uchun sinfni tanlang", noGrades: "Baholar yo'q", grade: 'Baho', term: 'Chorak', gradeValue: 'Baho (1-5)',
    period: 'Davr', periodAll: 'Barchasi', periodDay: 'Kunlik', periodWeek: 'Haftalik', periodMonth: 'Oylik', allSubjects: 'Barcha fanlar',
    student: "O'quvchi", dateFrom: 'Sanadan', dateTo: 'Sanagacha', termN: '{{n}}-chorak',
    // T5 — bahoni kim qo'ygani (ustun + filtr)
    teacher: "O'qituvchi",
    // Elektron jurnal: tahrirlash/o'chirish (PATCH + DELETE /grades/:id) va chorak TANLOVI
    actions: 'Amallar', edit: 'Bahoni tahrirlash', editSaved: 'Baho yangilandi',
    deleteGrade: "Bahoni o'chirish", deleted: "Baho o'chirildi",
    comment: 'Izoh', date: 'Sana', selectTerm: 'Chorakni tanlang',
    noTermSet: 'Chorakka biriktirilmagan',
    onlyOwnGrade: "Bu bahoni boshqa o'qituvchi qo'ygan — tahrirlab bo'lmaydi",
    termsError: "Choraklar ro'yxati yuklanmadi — eski ro'yxat ko'rsatilmoqda",
    termsHint: "Choraklar «O'quv yili va choraklar» bo'limida sozlanadi",
  },
  // -- Elektron jurnal moduli (docs/ELEKTRON-JURNAL.md) --
  terms: {
    title: "O'quv yili va choraklar",
    subtitle: "Chorak o'quv yiliga bog'lanadi — baho qo'yilganda chorak sanadan avtomatik aniqlanadi.",
    tabYears: "O'quv yillari", tabTerms: 'Choraklar', retry: 'Qayta urinish',
    yearsTitle: "O'quv yillari", addYear: "Yangi o'quv yili", editYear: "O'quv yilini tahrirlash",
    yearName: 'Nomi', yearNameHint: 'Masalan: 2026-2027', yearStart: 'Boshlanishi', yearEnd: 'Tugashi',
    yearColumn: "O'quv yili", selectYear: "O'quv yilini tanlang",
    makeActive: 'Faol qilish', active: 'Faol',
    activeHint: "Faqat BITTA o'quv yili faol bo'ladi — boshqasini faollashtirsangiz joriysi avtomatik o'chadi.",
    nameRequired: 'Nom kiriting',
    yearCreated: "O'quv yili qo'shildi", yearUpdated: "O'quv yili yangilandi", yearDeleted: "O'quv yili o'chirildi",
    yearActivated: "{{name}} — endi faol o'quv yili",
    yearsEmpty: "O'quv yili yo'q",
    yearsEmptyDesc: "Birinchi o'quv yilini qo'shing — sinflar, choraklar va elektron jurnal shunga bog'lanadi.",
    yearsLoadError: "O'quv yillarini yuklab bo'lmadi",
    yearInUse: "Bu o'quv yiliga sinflar bog'langan — avval sinflarni ko'chiring yoki o'chiring.",
    noActiveYear: "Faol o'quv yili tanlanmagan",
    noActiveYearDesc: "Jurnal, choraklar va hisobotlar faol yil bo'yicha ishlaydi — ro'yxatdan bittasini «Faol qilish» tugmasi bilan tanlang.",
    activeNoClasses: "Faol o'quv yilida ({{name}}) birorta sinf yo'q",
    activeNoClassesDesc: "Sinflar boshqa o'quv yilida qolgan bo'lishi mumkin. «Sinflar» bo'limida yangi sinf qo'shing yoki sinflar turgan yilni faol qiling.",
    goToClasses: "Sinflar bo'limiga o'tish",
    termsTitle: 'Choraklar', addTerm: 'Yangi chorak', editTerm: 'Chorakni tahrirlash',
    termName: 'Chorak nomi', termIndex: 'Tartib', termIndexHint: '1 dan 4 gacha — saralash va chorak yakuni uchun',
    termStart: 'Boshlanishi', termEnd: 'Tugashi', currentTerm: 'Joriy',
    termCreated: "Chorak qo'shildi", termUpdated: 'Chorak yangilandi', termDeleted: "Chorak o'chirildi",
    termsEmpty: "Chorak qo'shilmagan",
    termsEmptyDesc: "Choraksiz elektron jurnal, chorak yakuni va baho hisoboti ishlamaydi. «Yangi chorak» tugmasi bilan boshlang.",
    termsLoadError: "Choraklarni yuklab bo'lmadi",
    termsNeedYear: "Avval o'quv yili qo'shing — chorak yilga bog'lanadi.",
    termOverlap: 'Chorak sanalari boshqa chorak bilan kesishmoqda yoki bu tartib band.',
    termInUse: "Bu chorakka baholar bog'langan — avval ularni ko'chiring yoki o'chiring.",
    datesRequired: 'Boshlanish va tugash sanasini tanlang',
    endAfterStart: "Tugash sanasi boshlanish sanasidan keyin bo'lishi kerak",
  },
  journal: {
    periodAvg: "Davr o'rtachasi",
    periodGrade: 'Davr bahosi',
    period: 'Davr',
    period7: 'Oxirgi 7 kun',
    period14: 'Oxirgi 14 kun',
    period30: 'Oxirgi 30 kun',
    periodTerm: 'Butun chorak',
    periodCustom: 'Sanani tanlash',
    showAll: "Butun chorakni ko'rsatish",
    dateFrom: 'Sanadan',
    dateTo: 'Sanagacha',
    dateFilterNote: "Sana filtri faqat ko'rinishni kesadi — o'rtacha va taklifiy baho butun chorak bo'yicha qoladi.",
    pageTitle: 'Elektron jurnal',
    pageSubtitle: 'Sinf, fan va chorakni tanlang — jurnal, ommaviy baho, chorak yakuni va hisobot shu kesimda ishlaydi.',
    title: 'Jurnal',
    tabMatrix: 'Jurnal', tabBulk: 'Ommaviy baho', tabTerm: 'Chorak yakuni', tabReport: 'Hisobot',
    student: "O'quvchi", avg: "O'rtacha", termGrade: 'Chorak bahosi',
    selectFilters: 'Sinf, fan va chorakni tanlang',
    scrollHint: "Jadval keng — sanalarni ko'rish uchun gorizontal aylantiring.",
    loadError: "Jurnalni yuklab bo'lmadi",
    empty: "Bu chorakda bu fandan baho qo'yilmagan",
    emptyDesc: "«Ommaviy baho» bo'limidan butun sinfga baho qo'ying yoki jurnal katagini bosing.",
    noStudents: "Bu sinfda o'quvchi yo'q",
    noStudentsDesc: "Avval «O'quvchilar» bo'limida o'quvchi qo'shing va uni shu sinfga biriktiring.",
    cellEmpty: "Bu kunda baho yo'q",
    addGrade: "Baho qo'shish",
    termNotSet: "Qo'yilmagan",
    suggestion: 'Tizim taklifi: {{n}}',
    noTerms: 'Chorak sozlanmagan',
    noTermsDesc: "Elektron jurnal choraksiz ishlamaydi — avval o'quv yili choraklarini kiriting.",
    goToTerms: 'Choraklarni sozlash',
    setupNoClasses: "Sinf yo'q",
    setupNoClassesDesc: "Jurnal sinf bo'yicha ochiladi — avval sinf qo'shing.",
    setupNoSubjects: "Fan yo'q",
    setupNoSubjectsDesc: "Baho fanga qo'yiladi — avval fan qo'shing.",
    goToSubjects: "Fanlar bo'limiga o'tish",
    goToYears: "O'quv yilini qo'shish", goToClasses: "Sinflar bo'limiga o'tish",
    selectFiltersDesc: "Tepadagi tanlovdan sinf va fanni belgilang — jurnal shu kesimda ochiladi.",
    termGradeStale: "Chorak bahosi muzlatilgan; shundan keyin yangi baho qo'shilgan — hozirgi taklif: {{n}}",
    askAdmin: "Bu bo'limga ruxsatingiz yo'q — administratordan sozlashni so'rang.",
    // Bo'sh tizim uchun tabiiy tartib (baza tozalangandan keyin birinchi ko'riladigan ekran)
    stepYears: "1. O'quv yili", stepTerms: '2. Choraklar', stepClasses: '3. Sinflar', stepSubjects: '4. Fanlar',
    setupNoYears: "O'quv yili yo'q",
    setupNoYearsDesc: "Hamma narsa o'quv yilidan boshlanadi — chorak, sinf va jurnal shunga bog'lanadi.",
    setupNoTerms: "Chorak yo'q",
    setupNoTermsDesc: "Baho chorakka biriktiriladi — o'quv yili choraklarini kiriting.",
  },
  bulkGrades: {
    title: "Ommaviy baho qo'yish",
    desc: "Sana tanlang va butun ro'yxatni bir ekranda to'ldiring. Bo'sh qoldirilgan o'quvchiga baho qo'yilmaydi.",
    date: 'Sana', value: 'Baho', comment: 'Izoh', commentPlaceholder: 'Ixtiyoriy izoh',
    save: 'Baholarni saqlash',
    saved: '{{saved}} ta baho saqlandi',
    savedSkipped: "{{saved}} ta baho saqlandi, {{skipped}} tasi o'tkazib yuborildi",
    nothingToSave: "Hech bo'lmasa bitta bahoni belgilang",
    selectFilters: 'Avval sinf va fanni tanlang',
    filled: "{{n}} ta to'ldirildi", fillAll: 'Hammasiga {{n}}',
    clear: 'Tozalash', clearOne: 'Bahoni olib tashlash',
    loadError: "O'quvchilar ro'yxatini yuklab bo'lmadi",
    appendHint: "Saqlash baholarni QO'SHADI, eskisini almashtirmaydi — bir kunda bir nechta baho bo'lishi mumkin. Ikki marta saqlansa ikkita baho tushadi.",
  },
  termSummary: {
    title: 'Chorak yakuni',
    desc: "Tizim joriy baholardan o'rtachani hisoblab TAKLIF qiladi — yakuniy chorak bahosini o'qituvchi qo'yadi va u muzlatib saqlanadi.",
    gradeCount: 'Baholar soni', suggested: 'Taklif', finalGrade: 'Chorak bahosi',
    confirm: 'Tasdiqlash', confirmAll: "Taklifni hammaga qo'llash",
    saved: 'Chorak baholari saqlandi',
    cancelGrade: 'Chorak bahosini bekor qilish', cancelled: 'Chorak bahosi bekor qilindi',
    changed: 'Taklifdan farq qiladi', changedHint: 'Tizim {{n}} taklif qilgan edi',
    alreadySet: "Qo'yilgan", pending: 'Tasdiqlanmagan',
    noSuggestion: "Taklif yo'q — bu chorakda joriy baho qo'yilmagan",
    nothingToSave: "Hech bo'lmasa bitta chorak bahosini belgilang",
    empty: "Ma'lumot yo'q",
    emptyDesc: "Bu sinf, fan va chorak bo'yicha o'quvchi topilmadi.",
    loadError: "Chorak baholarini yuklab bo'lmadi",
    needTerm: "Chorak yakuni uchun sinf, fan va chorak — uchalasi ham tanlanishi shart.",
    // §6.5 — TEACHER faqat o'ziga BIRIKTIRILGAN fandan chorak bahosi qo'yadi
    notAssigned: "Bu fan sizga biriktirilmagan",
    notAssignedDesc: "Chorak bahosini faqat o'zingizga biriktirilgan fandan qo'yish mumkin — sinf rahbari bo'lish yetarli emas. «Dars jadvali va biriktirish» bo'limida biriktirishni administratordan so'rang.",
    stale: 'Taklif eskirgan',
    staleHint: "Yozilganda taklif {{old}} edi, hozir {{now}} — chorak bahosidan keyin yangi baho qo'shilgan.",
  },
  gradeReport: {
    title: 'Baho hisoboti',
    gradeCount: 'Baholar soni', avg: "O'rtacha", termGrade: 'Chorak bahosi',
    summaryAvg: "Umumiy o'rtacha", graded: 'Baholangan', gradedHint: "Chorak bahosi qo'yilgan / jami o'quvchi",
    excellent: "A'lo (5)", good: 'Yaxshi (4)', satisfactory: 'Qoniqarli (3)', poor: 'Qoniqarsiz (2)',
    empty: "Hisobot uchun ma'lumot yo'q",
    emptyDesc: "Tanlangan sinf, fan va chorak bo'yicha baho topilmadi.",
    loadError: "Hisobotni yuklab bo'lmadi",
    summaryAvgHint: "Chorak baholari bo'yicha (joriy baholar emas)",
  },
  rankingPage: {
    scopeClass: 'Sinf ichida', scopeParallel: 'Parallel', scopeSchool: 'Butun maktab',
    schoolHint: "Sinf tanlanmagan — butun maktab bo'yicha reyting ko'rsatilmoqda.",
    scopeNeedsClass: "«Sinf ichida» va «Parallel» qamrovlari uchun avval sinfni tanlang.",
    periodInfo: 'Hisob davri: oxirgi {{days}} kun',
    weightsInfo: 'Fanlar {{grades}}% · Davomat {{attendance}}% · Xulq {{behavior}}% · Testlar {{exams}}% · Uy vazifasi {{homework}}%',
    colRank: '#', colStudent: 'F.I.Sh.', colClass: 'Sinf', colBall: 'Yakuniy ball',
    colGrades: 'Fanlar', colAttendance: 'Davomat', colBehavior: 'Xulq', colExams: 'Testlar', colHomework: 'Uy vazifasi',
    colAdjust: 'Tuzatish',
    tipCount: 'Yozuvlar: {{count}}', tipAvg: "O'rtacha: {{avg}}", tipNoData: "Bu yo'nalish bo'yicha ma'lumot yo'q",
    avgGrade: "O'rtacha baho", gradeCount: 'Baholar soni',
    empty: "Reyting uchun ma'lumot yo'q", totalStudents: "Jami o'quvchi: {{count}}",
    settings: 'Sozlamalar', settingsTitle: 'Reyting sozlamalari',
    weightGrades: "Fanlar og'irligi", weightAttendance: "Davomat og'irligi", weightBehavior: "Xulq og'irligi",
    weightExams: "Testlar og'irligi", weightHomework: "Uy vazifasi og'irligi", periodDays: 'Hisob davri (kun)',
    weightsSum: "Og'irliklar yig'indisi: {{sum}}",
    normalizeHint: "Yig'indi aynan 100 bo'lishi shart emas — tizim og'irliklarni avtomatik normallashtiradi.",
    settingsSaved: 'Sozlamalar saqlandi',
    adjust: 'Tuzatish', adjustTitle: "Qo'lda tuzatish (bonus / jarima)",
    delta: 'Ball (+ bonus / − jarima)', deltaHint: "-100 dan 100 gacha, 0 bo'lishi mumkin emas",
    deltaRequired: "Ball 0 bo'lmagan butun son bo'lishi kerak (-100..100)",
    reason: 'Sabab', reasonPlaceholder: 'Masalan: olimpiada g‘olibi',
    adjustAdded: "Tuzatish qo'shildi", adjustDeleted: "Tuzatish o'chirildi",
    adjustList: 'Mavjud tuzatishlar', noAdjust: "Tuzatishlar yo'q",
    search: "O'quvchi ismi...", period7: 'Oxirgi 7 kun', period30: 'Oxirgi 30 kun', period90: 'Oxirgi 90 kun', limitWarning: "Faqat birinchi {{n}} ta o'quvchi ko'rsatilmoqda", showLimit: "Ko'rsatish soni",
    shownOf: "Ko'rsatilyapti {{shown}} / {{total}}",
    saveError: "Saqlashda xatolik — qayta urinib ko'ring",
  },
  behaviorPage: {
    tabCriteria: 'Mezonlar', tabGrade: "Baho qo'yish",
    addCriterion: "Mezon qo'shish", editCriterion: 'Mezonni tahrirlash',
    criterionName: 'Mezon nomi', criterionNamePlaceholder: 'Masalan: darsda faol qatnashdi',
    points: 'Ball', pointsHint: "-10 dan 10 gacha (manfiy — jarima)", order: 'Tartib', isActive: 'Faol',
    active: 'Faol', inactive: 'Arxivlangan',
    nameRequired: 'Mezon nomini kiriting', pointsRange: "Ball -10 dan 10 gacha bo'lishi kerak",
    criterionSaved: 'Mezon saqlandi', criterionDeleted: "Mezon o'chirildi",
    criterionArchived: "Mezonda baholar bor — o'chirilmadi, arxivlandi",
    noCriteria: "Mezonlar yo'q", showArchived: 'Arxivlanganlar bilan',
    readOnlyHint: "Mezonlarni faqat rahbariyat tahrirlaydi.",
    selectClass: 'Sinf', selectClassFirst: "Avval sinfni tanlang",
    students: "O'quvchilar", selectStudents: "O'quvchilarni tanlang",
    selectAll: 'Hammasini tanlash', clearAll: 'Tanlovni tozalash',
    criterion: 'Mezon', value: 'Ball (ixtiyoriy)',
    valueHint: "Bo'sh qoldirilsa mezonning o'z bali qo'llanadi",
    note: 'Izoh', date: 'Sana', submit: "Baho qo'yish", saved: "Xulq bahosi qo'yildi",
    studentsRequired: "Kamida bitta o'quvchini tanlang", criterionRequired: 'Mezon yoki ballni kiriting',
    recent: 'Oxirgi baholar', noRecords: "Baholar yo'q",
    colStudent: "O'quvchi", colClass: 'Sinf', colCriterion: 'Mezon', colValue: 'Ball', colNote: 'Izoh', colDate: 'Sana', colBy: 'Kim qo‘ydi',
    deleted: "Baho o'chirildi", noCriterion: 'Mezonsiz',
    student: "O'quvchi", positive: "Rag'bat (+)", negative: 'Jarima (−)', dateFrom: 'Sanadan', dateTo: 'Sanagacha', sortDateDesc: 'Sana (yangi)', sortValueDesc: 'Ball (yuqori)',
    sortDateAsc: 'Sana (eski)', sortValueAsc: 'Ball (past)', sortOrder: "Tartib bo'yicha",
    allClasses: 'Barcha sinflar', allStudents: "Barcha o'quvchilar", allCriteria: 'Barcha mezonlar', allSigns: 'Ijobiy | Salbiy', dateRange: "Sana oralig'i",
    saveError: "Saqlashda xatolik — qayta urinib ko'ring",
  },
  examsPage: {
    add: "Imtihon qo'shish", edit: 'Imtihonni tahrirlash',
    examTitle: 'Imtihon nomi', titlePlaceholder: 'Masalan: Ingliz tili — 1-hafta testi',
    subject: 'Fan', class: 'Sinf', date: 'Sana', maxScore: 'Maksimal ball',
    allSchool: 'Butun maktab', allClasses: 'Barcha sinflar', allSubjects: 'Barcha fanlar',
    scoresCount: 'Kiritilgan ballar',
    titleRequired: 'Imtihon nomini kiriting', maxScoreRange: "Maksimal ball 1 dan 1000 gacha",
    examSaved: 'Imtihon saqlandi', examDeleted: "Imtihon o'chirildi",
    noExams: "Imtihonlar yo'q",
    enterScores: 'Ballarni kiritish', scoresTitle: 'Test ballari',
    selectClassForScores: "Ballarni kiritish uchun sinfni tanlang",
    student: "O'quvchi", score: 'Ball', comment: 'Izoh',
    noStudents: "Bu sinfda o'quvchi yo'q",
    scoresSaved: 'Ballar saqlandi ({{saved}})',
    noPermission: "Test imtihon ballarini faqat manager yoki test oluvchi ustoz kiritadi.",
    scoreRange: 'Ball 0 dan {{max}} gacha',
    testTeacher: 'Test oluvchi ustoz',
    testTeacherHint: 'Bu ustoz test imtihonlarga ball kirita oladi',
    testTeacherUpdated: 'Saqlandi',
    searchPlaceholder: 'Imtihon nomi...', sortDateDesc: 'Sana (yangi)', sortDateAsc: 'Sana (eski)',
    allExams: 'Barcha imtihonlar', ungraded: 'Ballari kiritilmagan', dateRange: "Sana oralig'i", searchStudent: "O'quvchini qidirish...",
    saveError: "Saqlashda xatolik — qayta urinib ko'ring",
    tabList: 'Imtihonlar', tabHistory: 'Tarix',
    classes: 'Sinflar', selectClasses: 'Sinflarni tanlang',
    classesHint: "Bo'sh qoldirilsa — butun maktab imtihoni",
    teacher: "O'tkazuvchi ustoz", allTeachers: 'Barcha ustozlar', noTeacher: 'Biriktirilmagan',
    myExams: 'Mening imtihonlarim',
    tooManyClasses: "Ko'pi bilan {{max}} ta sinf tanlang",
  },
  // T8 — imtihonlar tarixi (natijalar + ball kiritish auditi)
  examHistory: {
    exams: 'Imtihonlar', scores: 'Kiritilgan ballar', avgPercent: "O'rtacha natija",
    empty: "Tarixda imtihon yo'q", scored: "Ball qo'yilgan", result: 'Natija',
    best: 'Eng yuqori', worst: 'Eng past', noScores: 'Ball kiritilmagan',
    enteredBy: 'Kim kiritdi', editedBy: "Kim o'zgartirdi",
    openAudit: 'Ball kiritish tarixi', auditTitle: 'Ball kiritish auditi',
    notEdited: "O'zgartirilmagan",
    sortCreatedDesc: 'Yaratilgan (yangi)', sortUpdatedDesc: "O'zgartirilgan (yangi)",
    sortEnteredDesc: 'Kiritilgan (yangi)', sortScoreDesc: 'Ball (katta)', sortScoreAsc: 'Ball (kichik)',
  },
  schedulePage: {
    lessonNo: 'Nechanchi soat',
    lessonNoHint: "Vaqt avtomatik — Sozlamalardagi dars vaqtidan",
    selectSubject: 'Fanni tanlang', selectTeacher: "O'qituvchini tanlang", lessonAdded: "Dars qo'shildi", assigned: 'Biriktirildi',
    selectClassToStart: 'Boshlash uchun sinfni tanlang', scheduleTab: 'Dars jadvali', assignTab: "O'qituvchi biriktirish", assignTitle: "O'qituvchini biriktirish",
    addLesson: "Dars qo'shish", emptySchedule: "Jadval bo'sh", day: 'Kun', time: 'Vaqt', room: 'Xona', lesson: 'dars', noAssignments: "Biriktirishlar yo'q",
    startTime: 'Boshlanish', endTime: 'Tugash', assign: 'Biriktirish',
    allDays: 'Hammasi', emptyDay: "Bu kunda dars yo'q",
    planningNotice: "{{year}} — faol bo'lmagan o'quv yili: jadval shu yil uchun oldindan kiritiladi, joriy jadvalga ta'sir qilmaydi.",
    noClassesInYear: "Bu o'quv yilida hali sinflar yo'q — jadval kiritishdan avval Sinflar sahifasida sinf yarating.",
  },
  classesPage: {
    searchPlaceholder: 'Sinf nomi...', sortNameAsc: 'Nomi (A-Z)', sortNameDesc: 'Nomi (Z-A)', sortNewest: 'Yangi sinflar', searchTeacher: "O'qituvchini qidiring...",
    academicYear: "O'quv yili", sortStudentsDesc: "O'quvchilar soni (ko'p)",
  },
  subjectsPage: {
    searchPlaceholder: 'Fan nomi yoki kodi...', sortNameAsc: 'Nomi (A-Z)', sortNameDesc: 'Nomi (Z-A)', sortNewest: "Yangi qo'shilganlar",
    nameUz: "Fan nomi (o'zbekcha)", nameRu: 'Ruscha nomi', nameEn: 'Inglizcha nomi',
    icon: 'Ikonka', iconAuto: 'Standart (fan nomiga qarab)',
    iconHint: "Tanlamasangiz — fan nomiga qarab mos ikonka o'zi qo'yiladi",
  },
  // T4 — ikonka kalitlari (backend `SUBJECT_ICONS` bilan bir xil ro'yxat)
  subjectIcon: {
    calculator: 'Kalkulyator', atom: 'Atom', flask: 'Kolba', dna: 'DNK', globe: 'Globus',
    book: 'Kitob', language: 'Til', code: 'Kod', palette: 'Palitra', music: 'Musiqa',
    dumbbell: 'Gantel', hammer: "Bolg'a", brain: 'Miya', chart: 'Diagramma', map: 'Xarita',
    history: 'Tarix', shield: 'Qalqon', heart: 'Yurak', leaf: 'Barg', star: 'Yulduz',
  },
  salaryType: { FIXED: 'Fiks oylik', PER_LESSON: 'Dars uchun', HOURLY: 'Soatbay' },
  legal: {
    section: 'Huquqiy', back: 'Orqaga', updated: 'Oxirgi yangilanish', more: 'Batafsil', accept: 'Tushunarli',
    terms: 'Foydalanish shartlari', privacy: 'Maxfiylik siyosati', cookies: 'Cookie siyosati',
    cookieTitle: 'Cookie va lokal saqlash',
    cookieText: "Tizimga kirganingizni saqlab qolish uchun brauzer xotirasidan (zaruriy) foydalanamiz. Reklama va kuzatuv cookie'lari ishlatilmaydi.",
  },
  deleteAccount: {
    navLabel: "Akkauntni o'chirish",
    title: "{{app}} — akkauntni o'chirish",
    developer: 'Dasturchi: {{dev}}',
    intro: "Bu sahifa orqali {{app}} ilovasidagi akkauntingizni (ota-ona yoki o'qituvchi) o'chirishni so'rashingiz mumkin. Login va parolni sizga maktab bergan.",
    inAppTitle: "Ilovada qanday o'chiriladi",
    inAppSteps: "{{app}} ilovasini oching → Profil → Akkaunt → «Akkauntni o'chirish» → parolni kiriting va tasdiqlang.",
    formTitle: "Ilovasiz so'rov yuborish",
    formHint: "Ilova o'chirilgan yoki ochilmayotgan bo'lsa — login va parolingiz bilan shu yerdan yuboring. Parol akkaunt sizniki ekanini tasdiqlash uchun kerak.",
    login: 'Login',
    password: 'Parol',
    reason: 'Sabab (ixtiyoriy)',
    reasonPlaceholder: "Nega o'chirmoqchisiz? Maktab ma'muriyati ko'radi",
    confirm: "Tushunaman: so'rov yuborilishi bilan akkauntga kirib bo'lmaydi",
    submit: "O'chirish so'rovini yuborish",
    required: 'Majburiy maydon',
    confirmRequired: 'Tasdiqlang',
    successTitle: "So'rov qabul qilindi",
    successText: "Akkauntingiz yopildi. Maktab ma'muriyati so'rovni 30 kun ichida yakunlaydi va ma'lumotlaringiz quyida ko'rsatilgandek o'chiriladi.",
    errWrong: "Login yoki parol noto'g'ri",
    errRole: "Bu hisob turi (maktab xodimi) uchun o'chirish so'rovi maktab ma'muriyati orqali yuboriladi.",
    errLimit: "Juda ko'p urinish. 15 daqiqadan so'ng qayta urinib ko'ring.",
    errGeneric: "Yuborib bo'lmadi. Internetni tekshirib, qayta urinib ko'ring.",
    timingTitle: 'Muddat',
    timingText: "So'rov yuborilishi bilan akkaunt darhol yopiladi: unga kirib bo'lmaydi, bildirishnomalar to'xtaydi. Maktab ma'muriyati so'rovni 30 kun ichida yakunlaydi. Maktab so'rovni sabab ko'rsatib rad etsa, akkaunt avvalgi holatiga qaytadi va sizga sabab bilan xabar keladi.",
    deletedTitle: "Nima o'chiriladi",
    deletedItems: [
      'Login va parol',
      "Ism-familiya, telefon, jins, tug'ilgan sana, Telegram ID",
      'Profil rasmi',
      "Qo'shimcha telefon raqamlari va manzillar",
      'Push-bildirishnoma tokenlari va ilova ichidagi bildirishnomalar',
      'Yordam (support) chatidagi yozishmalar',
    ],
    keptTitle: 'Maktab yozuvi sifatida nima qoladi',
    keptItems: [
      "Farzandingizning baholari, davomati, to'lovlari va shartnomalari (imzolangan shartnomadagi ma'lumotlar bilan) va o'quvchi kartochkasidagi ota-ona kontakti",
      "O'qituvchi bo'lsangiz: qo'ygan baholaringiz, uy vazifalari, dars jadvali, maosh va ish vaqti yozuvlari",
      "Bu yozuvlarda ismingiz o'rniga «O'chirilgan foydalanuvchi» ko'rinadi",
      "Xavfsizlik (audit) jurnali — 90 kundan keyin avtomatik o'chadi; zaxira nusxalar — ular tozalanguncha",
      "Xodimning FACE ID terminalidagi yozuvi — uni maktab ma'muriyati alohida o'chiradi",
    ],
    childNote: "Farzandingiz (o'quvchi) haqidagi ma'lumotni o'chirish yoki tuzatish uchun maktab ma'muriyatiga murojaat qiling.",
    contactTitle: 'Aloqa',
    contactText: "Savollar bo'yicha: {{email}} yoki maktab ma'muriyati.",
    privacyLink: 'Maxfiylik siyosati',
  },
  deletionRequests: {
    title: "Akkauntni o'chirish so'rovlari",
    subtitle: "Ota-ona va o'qituvchilardan — 30 kun ichida yakunlang",
    filterNew: 'Yangi ({{n}})',
    filterAll: 'Barchasi',
    empty: "So'rovlar yo'q",
    loadError: "Ro'yxatni yuklab bo'lmadi",
    retry: 'Qayta urinish',
    status: { NEW: 'Yangi', DONE: 'Bajarildi', REJECTED: 'Rad etildi' },
    source: { APP: 'Ilovadan', WEB: 'Veb-sahifadan' },
    requested: "So'ralgan: {{date}}",
    processed: 'Yakunlandi: {{date}}{{by}}',
    reason: 'Sabab: {{text}}',
    rejectReasonShown: 'Rad etish sababi: {{text}}',
    done: "O'chirish",
    reject: 'Rad etish',
    confirmDoneTitle: "Akkauntni o'chirish",
    confirmDoneText: "{{name}} akkaunti anonimlashtiriladi: login, parol, ism, telefon, rasm, bildirishnomalar va yordam chati o'chadi. Baho, davomat, to'lov, shartnoma, maosh kabi maktab yozuvlari «O'chirilgan foydalanuvchi» nomi bilan qoladi. Bu amalni qaytarib bo'lmaydi.",
    confirmDoneOk: "Ha, o'chirish",
    rejectTitle: "So'rovni rad etish",
    rejectText: "{{name}} akkaunti so'rovdan oldingi holatiga qaytadi va u yana kira oladi. Sabab foydalanuvchiga bildirishnomada ko'rinadi.",
    rejectReason: 'Rad etish sababi (ixtiyoriy)',
    rejectOk: 'Rad etish',
    cancel: 'Bekor qilish',
    doneOkMsg: "Akkaunt o'chirildi (anonimlashtirildi)",
    rejectOkMsg: "So'rov rad etildi, akkaunt tiklandi",
  },
  staffDetail: {
    workDays: 'Ish kunlari',
    workDaysWithHoliday: '{{kun}} kun ({{bayram}} bayram chiqarilgan)',
    perDay: 'Bir kunlik maosh',
    adjustments: "Jarima va rag'bat",
    adjustmentsEmpty: 'Bu oyda tuzatish yo\'q',
    adjustmentsTotal: 'Jami',
    adjustmentAdd: 'Tuzatish qo\'shish',
    adjustmentDate: 'Qaysi kun uchun',
    penalty: 'Jarima',
    bonus: "Rag'bat",
    reason: 'Sabab',
    reasonHint: 'Masalan: 2 soat kech keldi / oylik hisobotni muddatidan oldin topshirdi', notFound: 'Xodim topilmadi', month: 'Oy', salary: 'Maosh', shifts: 'Ish jadvali', logs: 'Kelgan-ketgan', history: 'Tarix', salaryConfig: 'Maosh sozlamasi', salaryType: 'Maosh turi', monthlyAmount: 'Oylik summa', perLesson: "Dars uchun (so'm)", perHour: "Soat uchun (so'm)", dailyHours: 'Kunlik ish soati', dailyHoursHint: "Kuniga ko'pi bilan shuncha soat hisoblanadi, faqat to'liq soatlar olinadi", hoursRule: "Kuniga ko'pi bilan {{n}} soat, daqiqalar hisobga olinmaydi", actualTime: 'haqiqiy vaqt', hm: '{{h}} s {{m}} daq', note: 'Izoh', calculation: 'Hisob-kitob', notConfigured: 'Maosh sozlanmagan', lessons: 'Darslar', hours: 'Soatlar', computed: 'Hisoblangan', paidThisMonth: "Shu oy to'langan", remaining: 'Qoldiq', paySalary: "Maosh to'lash", pay: "To'lash", paid: "Maosh to'landi", amount: 'Summa', weekday: 'Hafta kuni', start: 'Boshlanish', end: 'Tugash', noShifts: "Jadval yo'q", shiftError: "Jadval qo'shishda xatolik", checkIn: 'Keldi', checkOut: 'Ketdi', noLogs: "Loglar yo'q", date: 'Sana', in: 'Kelgan', out: 'Ketgan', worked: 'Ishlagan', h: 'soat', totalPaid: "Jami to'langan", noHistory: "Tarix yo'q", forMonth: 'Oy uchun', fullyPaid: "To'liq to'langan", editLog: 'Yozuvni tahrirlash', overpay: "Diqqat: qoldiqdan ko'p summa", openExcluded: "ochiq yozuv (soatga kirmadi)", plannedHint: "rejadagi darslar — davomat emas", hireDate: 'Ishga kirgan', leaveDate: 'Ishdan ketgan', prorateHint: "to'liq oy", prorated: 'Proratsiya', onlyOpen: "Faqat ochiq (check-out qilinmagan)", year: 'Yil', allYears: 'Barcha yillar', filteredTotal: "Tanlanganlar bo'yicha jami", noMatch: "Filtrga mos yozuv yo'q", payrollWarnNoYear: "Faol o'quv yili tanlanmagan — dars soati hisoblanmadi (0 so'm). «O'quv yili va choraklar» bo'limida yilni faol qiling.", payrollWarnNoClasses: "Faol o'quv yilida ({{name}}) sinf yo'q — dars soati hisoblanmadi (0 so'm). Sinf qo'shing yoki sinflar turgan yilni faol qiling." },
  parentDetail: { account: 'Hisob', login: 'Login', newPassword: 'Yangi parol', passwordHint: "Bo'sh qoldirilsa parol o'zgarmaydi", loginMin: 'Login kamida 3 ta belgi', passwordMin: 'Parol kamida 5 ta belgi', notFound: 'Ota-ona topilmadi', blocked: 'Bloklangan', edit: 'Tahrirlash', father: 'Ota', mother: 'Ona', children: 'Farzandlar', giftsSent: "Sovg'a berdi", giftsReceived: "Sovg'a oldi", messages: 'Xabarlar', subscription: 'Obuna', until: 'gacha', free: 'Oddiy tarif', noChildren: 'Farzand biriktirilmagan', balanceMonth: 'Balans: {{month}}', balanceNone: "Balans ma'lumoti yo'q", contacts: 'Kontaktlar', fullName: 'F.I.Sh.', phone: 'Telefon', gender: 'Jinsi', birthDate: "Tug'ilgan kun", activeAccount: 'Faol hisob', monthsGive: 'oy berish', cancelPremium: 'Premiumni bekor qilish', tabOverview: 'Umumiy', tabPayments: "To'lovlar", child: 'Farzand', paymentsTotal: "Jami to'langan", paymentsCount: "To'lovlar soni", storno: 'Qaytarilgan pul', paymentsUnsupportedTitle: "To'lovlarni ko'rsatib bo'lmadi", paymentsUnsupported: "Server ota-ona bo'yicha filtrni hali qo'llamaydi (backend yangilanishi kerak). Noto'g'ri ma'lumot chiqmasligi uchun ro'yxat yashirildi." },
  att: { PRESENT: 'Keldi', ABSENT: 'Kelmadi', LATE: 'Kechikdi', EXCUSED: 'Sababli', filterStatus: 'Holat', allStatuses: 'Barcha holatlar', sortBy: 'Saralash', sortName: 'Ism (A-Z)', sortStatus: "Holat bo'yicha", noMatch: 'Bu holatga mos oʻquvchi yoʻq', modeMark: 'Belgilash', modeView: 'Tarix', markSubtitle: 'Status tanlanishi bilan avtomatik saqlanadi', viewSubtitle: "Sana oralig'i bo'yicha davomat yozuvlari", allClasses: 'Barcha sinflar', dateRange: "Sana oralig'i", allStudents: "Barcha o'quvchilar", sortDateDesc: 'Sana (yangi)', sortDateAsc: 'Sana (eski)', noRecords: 'Yozuvlar topilmadi', total: 'Jami', student: "O'quvchi", date: 'Sana', status: 'Holat', markedBy: 'Kim oldi', allMarkers: 'Barcha xodimlar', sortMarker: "Kim oldi bo'yicha" },
  notif: {
    total: 'Jami', unread: "O'qilmagan", read: "O'qilgan", allTypes: 'Barcha turlar', allStatuses: 'Barcha holatlar',
    recipient: 'Oluvchi', type: 'Turi', message: 'Xabar', status: 'Holat', date: 'Sana',
    searchPlaceholder: 'Sarlavha, matn yoki oluvchi...',
    scopeMine: 'Menga kelganlar', scopeUsers: 'Foydalanuvchilarga', markAll: "Hammasini o'qish", viewAll: "Barchasini ko'rish", sortNew: 'Yangi', sortOld: 'Eski', sortType: "Tur bo'yicha", sortTitle: 'Sarlavha (A-Z)',
  },
  notifType: {
    ANNOUNCEMENT: "E'lon", ATTENDANCE: 'Davomat', GRADE: 'Baho', HOMEWORK: 'Uy vazifasi',
    PAYMENT: "To'lov", PREMIUM: 'Premium', SUPPORT: 'Support', SYSTEM: 'Tizim',
  },
  login: {
    welcome: 'Xush kelibsiz', subtitle: "Boshqaruv paneliga kirish uchun ma'lumotlaringizni kiriting",
    loginLabel: 'Login', passwordLabel: 'Parol', loginBtn: 'Kirish',
    heroTitle: 'Maktabni boshqarishning zamonaviy usuli',
    heroSubtitle: '{{school}} boshqaruv platformasi — barcha jarayonlar bitta joyda.',
    f1: "O'quvchilar, sinflar va davomatni yagona tizimda", f2: 'Moliya, hisobotlar va real vaqt statistikasi',
    f3: "Ota-ona va o'qituvchilar uchun mobil kabinet", f4: 'Rolga asoslangan xavfsiz ruxsatlar',
    denied: "Ruxsat yo'q", deniedMsg: "Bu panel faqat xodimlar uchun. Ota-ona va o'quvchilar mobil ilovadan foydalanadi.",
    tenantInactive: "Ushbu maktab vaqtincha faol emas. Iltimos, administrator bilan bog'laning.",
    tenantNotFound: "Bunday maktab manzili topilmadi. Manzilni tekshiring.",
    error: 'Kirishda xatolik',
  },
  qurilma: {
    faqatIlovaSarlavha: 'Panel faqat SATA ilovasi orqali ochiladi',
    faqatIlovaMatn: "Boshqaruv paneliga maktab kompyuteridagi SATA ilovasi orqali kiriladi. Ilovani o'rnatish uchun SATA administratoriga murojaat qiling.",
    loginParolBilan: 'Login va parol bilan kirish',
    loginParolIzoh: "O'qituvchilar va platforma administratori uchun",
    havolaEskirgan: 'Havola eskirgan. Panelni SATA ilovasidan qayta oching.',
    ochilmoqda: 'Panel ochilmoqda…',
    xIlovaKerak: 'Panel faqat SATA ilovasi orqali ochiladi',
    xBloklangan: 'Bu kompyuter bloklangan — direktorga murojaat qiling',
    xKutilmoqda: "Qurilma direktor tasdig'ini kutmoqda",
    xRadEtilgan: 'Bu kompyuter rad etilgan — direktorga murojaat qiling',
    xBoshqaMaktab: 'Bu kompyuter boshqa maktabga ulangan',
    xSessiya: 'Panel sessiyasi eskirgan — panelni SATA ilovasidan qayta oching',
    xBirinchi: 'Maktabning birinchi qurilmasini SATA administratori tasdiqlaydi',
    xKalitKutilmoqda: 'Ilova qayta ulanishini kuting',
    xOzgardi: "Qurilma siz ko'rgandan keyin o'zgargan (qayta ulangan yoki holati o'zgargan) — ro'yxat yangilandi, tekshirib qaytadan urinib ko'ring",
    kartaSarlavha: 'Qurilmalar (panel kompyuterlari)',
    kartaIzoh: "Panelga faqat shu ro'yxatda tasdiqlangan kompyuterlardagi SATA ilovasidan kiriladi.",
    bosh: "Hali birorta kompyuter ro'yxatdan o'tmagan",
    colNom: 'Kompyuter', colTerminal: 'Terminal', colIp: 'IP', colFaollik: 'Oxirgi faollik', colYaratilgan: 'Ulangan', colHolat: 'Holat', colMaktab: 'Maktab',
    holat: { KUTILMOQDA: 'Kutilmoqda', TASDIQLANGAN: 'Tasdiqlangan', RAD_ETILGAN: 'Rad etilgan', BLOKLANGAN: 'Bloklangan' },
    amal: { tasdiqlash: 'Tasdiqlash', 'rad-etish': 'Rad etish', bloklash: 'Bloklash', 'blokdan-chiqarish': 'Blokdan chiqarish' },
    shuKompyuter: 'shu kompyuter',
    kalitKutilmoqda: 'Ilova qayta ulanishi kutilmoqda',
    blokdanIzoh: "Kompyuter qayta tasdiq so'raydi",
    tasdiqSarlavha: 'Amalni tasdiqlang',
    tasdiqMatn: "Bu kompyuterdan panelga kirib bo'lmaydi.",
    joriyOgohlantirish: "Siz shu kompyuterdasiz — o'zingizni paneldan chiqarib yuborasiz. Maktabda boshqa tasdiqlangan kompyuter bo'lmasa, qayta tasdiqni faqat SATA administratori bera oladi.",
    bajarildi: 'Bajarildi',
    sozlamaSarlavha: 'Platforma sozlamasi',
    faqatIlovaSwitch: 'Panel faqat SATA ilovasi orqali',
    ochirishOgohlantirish: "Barcha maktab xodimlari brauzerdan kira oladi — faqat favqulodda holatda o'chiring.",
    majburiyOchiq: "Railway env (PANEL_FAQAT_ILOVA_MAJBURIY_OCHIQ) bilan majburan o'chirilgan",
    ulashSarlavha: 'Maktabni ulash kaliti',
    ulashIzoh: "Kalitni maktab kompyuteridagi SATA ilovasining «Ulash» oynasiga kiriting.",
    maktabTanlang: 'Maktabni tanlang',
    kalitYoq: "Bu maktabda FACE ID terminali yo'q — panel uchun ulash kaliti yaratiladi (terminalni keyin maktab o'zi sozlaydi).",
    kalitYarat: 'Ulash kalitini yaratish',
    sozlanmagan: 'sozlanmagan',
    holatFiltr: 'Holat',
  },
  dashboard: {
    welcome: 'Xush kelibsiz', subtitle: '{{school}} — boshqaruv paneli',
    students: "Jami o'quvchilar", active: 'faol', classes: 'Sinflar', teachers: "O'qituvchilar", admissions: 'Ochiq qabullar',
    revenue: 'Shu oy tushumi', revenueSub: "Joriy oy bo'yicha", todayAttendance: 'Bugungi davomat', present: 'Keldi', absent: 'Kelmadi',
    restDay: "Dam olish kuni — davomat olinmaydi",
    qStudent: "O'quvchi qo'shish", qAttendance: 'Davomat olish', qGrade: "Baho qo'yish", qPayment: "To'lov qabul qilish",
    genderStudents: "O'quvchilar jinsi", genderStaff: 'Xodimlar jinsi', genderParents: 'Ota-onalar', boys: "O'g'il bolalar", girls: 'Qizlar', male: 'Erkaklar', female: 'Ayollar', fathers: 'Otalar', mothers: 'Onalar',
  },
  settings: {
    title: 'Sozlamalar', profile: 'Profil', fullName: 'F.I.Sh.', login: 'Login', role: 'Rol', language: 'Til',
    changePassword: "Parolni o'zgartirish", oldPassword: 'Joriy parol', newPassword: 'Yangi parol', confirm: 'Yangi parolni tasdiqlang',
    change: "O'zgartirish", min5: 'Kamida 5 belgi', mismatch: 'Parollar mos emas', changed: "Parol o'zgartirildi",
    avatar: 'Profil rasmi', uploadAvatar: 'Rasm yuklash', removeAvatar: "O'chirish",
    avatarUpdated: 'Profil rasmi yangilandi', avatarRemoved: "Profil rasmi o'chirildi",
    editProfile: 'Tahrirlash', profileSaved: 'Profil saqlandi', nothingChanged: "O'zgarish yo'q",
    nameMin: 'F.I.Sh. kamida {{n}} ta belgi', nameMax: 'F.I.Sh. {{n}} ta belgidan oshmasin', nameLetters: "F.I.Sh. harflardan iborat bo'lsin",
    loginMin: 'Login kamida {{n}} ta belgi', loginDesc: 'Tizimga kirishda ishlatiladi',
    currentPasswordDesc: "Login o'zgarayotgani uchun joriy parolingizni kiriting", currentPasswordRequired: 'Joriy parolni kiriting',
  },
  kiosk: {
    section: 'Kiosk ekrani',
    sectionDesc: "Maktab kirish yo'lagidagi TV ekran uchun maxsus havola",
    linkLabel: 'Kiosk havolasi',
    linkHint: "Havolani TV brauzerida to'liq ekranda oching — reyting, dars jadvali va bannerlar avtomatik almashib turadi.",
    noLink: "Havola hali yaratilmagan. Yaratganingizdan so'ng TV ekranda reyting, dars jadvali va bannerlar ko'rinadi.",
    create: 'Havola yaratish', created: 'Kiosk havolasi yaratildi',
    copy: 'Nusxa olish', copied: 'Nusxa olindi', open: 'Ochish',
    regenerate: 'Yangilash', regenerateTitle: 'Havolani yangilash',
    regenerateWarning: "Yangi havola yaratiladi va eski havola ishlamay qoladi. TV ekranda yangi havolani qayta ochishingiz kerak bo'ladi.",
    regenerated: 'Kiosk havolasi yangilandi',
    disable: "O'chirish", disableTitle: "Kiosk ekranini o'chirish",
    disableWarning: "Havola o'chiriladi va TV ekran ishlamay qoladi. Keyinroq yangi havola yaratishingiz mumkin.",
    disabled: "Kiosk havolasi o'chirildi",
    loadError: "Kiosk havolasi holatini yuklab bo'lmadi.",
    retry: 'Qayta urinish',
  },
  // Maktab support email'i (Tenant.supportEmail) — huquqiy hujjatlardagi "Savollar uchun" qatori
  supportEmail: {
    section: 'Aloqa email (support)',
    sectionDesc: "Hujjatlardagi «Savollar uchun» manzili",
    label: 'Support email',
    placeholder: 'support@maktab.uz',
    hint: "Foydalanish shartlari, Maxfiylik va Cookie siyosatlarida hamda mobil ilovada «Savollar uchun» qatorida shu manzil chiqadi. Bo'sh qoldirilsa, email ko'rsatilmaydi.",
    invalid: "Email formati noto'g'ri (masalan: support@maktab.uz)",
    tooLong: "Email 254 belgidan oshmasligi kerak",
    saved: 'Support email saqlandi',
    cleared: "Support email o'chirildi — hujjatlarda email ko'rsatilmaydi",
    loadError: "Support email'ni yuklab bo'lmadi.",
    retry: 'Qayta urinish',
    current: 'Hozir: {{email}}',
    notSet: "Hozircha kiritilmagan — hujjatlarda email ko'rsatilmaydi.",
  },
  // Shartnoma hujjatidagi MAKTAB tomoni (Tenant.contractRequisites) — to'ldirilmasa
  // shartnoma umuman yaratilmaydi (backend 400 "Maktab rekvizitlari to'ldirilmagan").
  requisites: {
    section: 'Shartnoma rekvizitlari',
    sectionDesc: "Shartnoma hujjatida maktab tomoni sifatida chiqadigan ma'lumotlar.",
    incomplete: "Rekvizitlar to'liq emas",
    incompleteHint: "Majburiy maydonlar to'ldirilmaguncha yangi shartnoma yaratib bo'lmaydi va hujjat generatsiya qilinmaydi.",
    unsaved: 'Qiymatlar hali saqlanmagan',
    unsavedHint: "Quyidagilar — taklif qilingan qiymatlar. Tekshirib chiqing va «Saqlash» tugmasini bosing.",
    optionalSection: 'Ixtiyoriy maydonlar',
    optional: '(ixtiyoriy)',
    required: "Bu maydon to'ldirilishi shart",
    saved: 'Rekvizitlar saqlandi',
    saveFailed: "Rekvizitlarni saqlab bo'lmadi",
    loadError: "Rekvizitlarni yuklab bo'lmadi.",
    retry: 'Qayta urinish',
    f: {
      schoolName: 'Maktab nomi', address: 'Manzil', director: 'Direktor (F.I.Sh.)',
      stir: 'STIR', bank: 'Bank', account: 'Hisob raqami (h/r)', mfo: 'MFO', phone: 'Telefon',
      directorShort: 'Direktor (qisqa shakl)', jurist: 'Yuriskonsult', city: 'Shahar',
    },
    d: {
      schoolName: "Hujjatdagi to'liq nom — masalan: «NURLI MAKTAB» NTM",
      directorShort: "Rekvizitlar blokida ko'rinadi (masalan: A.A. Fathullayev). Bo'sh bo'lsa to'liq F.I.Sh. ishlatiladi.",
      jurist: "Bo'sh bo'lsa hujjatda bu satr umuman chiqmaydi.",
      city: 'Sarlavha ostidagi satr — masalan: Namangan shahri.',
    },
  },
  pages: {
    students: { title: "O'quvchilar", add: "Yangi o'quvchi", search: "Ism bo'yicha qidirish...", empty: "O'quvchilar topilmadi", emptyDesc: "Yangi o'quvchi qo'shing yoki qidiruv so'zini o'zgartiring." },
    classes: { title: 'Sinflar', add: 'Yangi sinf', empty: "Sinflar yo'q. Avval o'quv yili va sinf qo'shing." },
    subjects: { title: 'Fanlar', add: 'Yangi fan' },
    schedule: { title: 'Dars jadvali va biriktirish' },
    attendance: { title: 'Davomat' },
    grades: { title: 'Baholar / elektron jurnal' },
    homework: { title: 'Uy vazifalari' },
    ranking: { title: "O'quvchilar reytingi" },
    behavior: { title: 'Xulq baholari' },
    exams: { title: 'Test imtihonlar' },
    payments: { title: "Moliya / to'lovlar" },
    reports: { title: 'Hisobotlar' },
    expenses: { title: 'Xarajatlar va maosh' },
    admissions: { title: 'Qabul / CRM', add: 'Yangi murojaat' },
    contracts: { title: 'Shartnomalar', empty: 'Shartnoma topilmadi', emptyDesc: "Filtrni o'zgartiring yoki o'quvchi kartochkasidan yangi shartnoma yarating." },
    announcements: { title: "E'lonlar", add: "Yangi e'lon", empty: "E'lonlar yo'q" },
    notifications: { title: 'Bildirishnomalar', empty: "Bildirishnomalar yo'q" },
    stickers: { title: 'Stikerlar', subtitle: 'Ilova avatarlari uchun rasm-stiker paketlari',
      titlePremium: 'Premium stikerlar', subtitlePremium: "Premium ota-onalar avatarlari uchun rasm-stiker paketlari",
      addPack: 'Yangi paket', editPack: 'Paketni tahrirlash', packTitle: 'Paket nomi', order: 'Tartib', titleRequired: 'Nom kiriting', empty: "Paketlar yo'q", emptyDesc: "Birinchi stiker paketini qo'shing.", selectPack: 'Paketni tanlang', upload: 'Stiker yuklash', uploaded: 'Stiker yuklandi', noStickers: "Bu paketda stiker yo'q — rasm yuklang (PNG/WEBP/ICO).", dragHint: 'Tartiblash uchun stikerni sudrab kerakli joyga tashlang', count: 'ta stiker', active: 'Faol', inactive: 'Faol emas', one: 'Stiker' },
    staff: { title: 'Xodimlar va foydalanuvchilar', add: 'Yangi foydalanuvchi' },
  },
  fields: { title: 'Sarlavha', type: 'Turi',
    fullName: 'F.I.Sh.', phone: 'Telefon', class: 'Sinf', subject: 'Fan', parentName: 'Ota-ona F.I.Sh.',
    parentPhone: 'Ota-ona telefoni', status: 'Holat', date: 'Sana', amount: 'Summa', month: 'Oy',
  },
  confirm: { title: "O'chirishni tasdiqlang", msg: "o'chirilsinmi? Bu amalni orqaga qaytarib bo'lmaydi.", ok: "O'chirish", cancel: 'Bekor qilish' },
  genderRole: { father: 'Ota', mother: 'Ona', parent: 'Ota-ona', teacherMale: 'Ustoz', teacher: "O'qituvchi" },
  subjectDetail: { notFound: 'Fan topilmadi', edit: 'Tahrirlash', inSchedule: 'Dars jadvalida', inHomework: 'Uy vazifalarida', deleted: "Fan o'chirildi", deleteHint: "Fanni butunlay o'chirish" },
  homeworkDetail: { notFound: 'Vazifa topilmadi', info: "Ma'lumot", edit: 'Tahrirlash', deleted: "Vazifa o'chirildi", deleteHint: "Vazifani butunlay o'chirish", attachedFile: 'Biriktirilgan fayl (ilovadan)', openFile: 'Ochish', removeFile: 'Faylni olib tashlash' },
  announcementDetail: { notFound: "E'lon topilmadi", createdBy: 'Kim yaratdi', edit: 'Tahrirlash', deleted: "E'lon o'chirildi", deleteHint: "E'lonni butunlay o'chirish" },
  tenantsPage: {
    colQurilmalar: 'Qurilmalar',
    title: 'Maktablar (tenantlar)', totalCount: 'Jami: {{n}}', add: 'Yangi maktab',
    emptyTitle: "Maktab yo'q", emptyDesc: 'Birinchi maktabni (tenant) yarating.',
    searchPlaceholder: 'Nomi yoki subdomen...', statusFilter: 'Holat', active: 'Faol', inactive: 'Faol emas',
    sortNewest: "Yangi qo'shilganlar", sortOldest: 'Eskilari', sortNameAsc: 'Nomi (A-Z)', sortNameDesc: 'Nomi (Z-A)',
    colName: 'Maktab', colSlug: 'Subdomen', colCounts: "Foydalanuvchi / O'quvchi", colUsers: 'Foydalanuvchilar', colStudents: "O'quvchilar",
    colCreated: 'Yaratilgan', colActive: 'Faol',
    createTitle: 'Yangi maktab (tenant)', name: 'Maktab nomi', slug: 'Subdomen (slug)', slugPlaceholder: 'masalan: nurli',
    slugDesc: 'URL: <slug>.domen.com', note: 'Izoh', adminSection: 'Maktab admini (DIRECTOR)',
    adminLogin: 'Admin login', adminPassword: 'Admin parol', adminFullName: 'Admin F.I.Sh.',
    cancel: 'Bekor qilish', create: 'Yaratish', save: 'Saqlash', error: 'Xatolik',
    nameRequired: 'Nomi kerak', slugInvalid: 'Faqat kichik harf, raqam, tire', loginMin: 'Login kamida 3 belgi', passwordMin: 'Parol kamida {{n}} belgi',
    created: 'Maktab yaratildi', saved: 'Saqlandi', deleted: "{{name}} o'chirildi",
    editFallbackTitle: 'Maktab', activeLabel: "Faol (to'xtatilmagan)", activeDesc: "O'chirilsa maktab foydalanuvchilari kira olmaydi",
    dangerZone: 'Xavfli zona',
    deleteWarning: "Maktabni butunlay o'chirish — barcha foydalanuvchi, o'quvchi, to'lov va boshqa ma'lumoti qaytarib bo'lmaydigan tarzda yo'qoladi ({{users}} foydalanuvchi, {{students}} o'quvchi).",
    deleteConfirmHint: 'Tasdiqlash uchun subdomenni yozing:', deleteBtn: "Maktabni butunlay o'chirish",
    slugTooLong: 'Subdomen 63 belgidan oshmasin', slugEdgeDash: 'Subdomen tire bilan boshlanmasin va tugamasin',
    slugReserved: "Bu so'z zaxiralangan (www, admin, app, api, localhost)", domainFallback: 'domen',
    slugChangeTitle: "Subdomen o'zgaradi",
    slugChangeOld: "Eski manzil ({{old}}) ishlamay qoladi — maktab foydalanuvchilari yangi manzildan ({{new}}) kirishi kerak. Eski manzilda ochiq turgan sessiyalar tizimdan chiqariladi.",
    slugChangeContracts: "Yangi shartnoma raqamlari «{{new}}-…» bilan boshlanadi (hozir «{{old}}-…»). Mavjud shartnomalar va fayllar o'zgarmaydi.",
    slugChangeLegacy: "Bu maktab eski shartnoma rekvizitlaridan foydalanmoqda: ular saqlanmagan bo'lsa, hozirgi qiymatlar avtomatik saqlanadi — shartnomalar avvalgidek chiqadi.",
    slugConfirmTitle: "Subdomenni o'zgartirish",
    slugConfirmMsg: "Eski manzil {{old}} ishlamay qoladi, yangi manzil — {{new}}. Davom etasizmi?",
    slugConfirmOk: "Ha, o'zgartirish",
    requisitesSaved: "Maktabning amaldagi shartnoma rekvizitlari saqlandi (Sozlamalar → Shartnoma rekvizitlari).",
  },
  tenantAdmins: {
    add: "Admin qo'shish", addTitle: "Yangi admin (direktor yoki admin)", addSubmit: 'Yaratish',
    added: '{{name}} — admin yaratildi', createdTitle: 'Admin yaratildi',
    role: 'Rol', gender: 'Jinsi', male: 'Erkak', female: 'Ayol', genderRequired: 'Jinsni tanlang',
    newAdminPasswordDesc: 'Kamida {{n}} belgi',
    section: 'Maktab adminlari',
    hint: "Direktor va admin hisoblari. Parolni qayta o'rnatish mumkin — eski parol so'ralmaydi.",
    loadError: "Adminlar ro'yxatini yuklab bo'lmadi", retry: 'Qayta urinish',
    empty: "Bu maktabda direktor yoki admin hisobi yo'q.",
    reset: 'Parol / login',
    formTitle: '{{name}} — kirish ma\'lumotlari',
    loginDesc: "O'zgarsa, admin keyingi kirishda yangi loginni ishlatadi",
    newPassword: 'Yangi parol',
    passwordDesc: "Kamida {{n}} belgi. Bo'sh qoldirilsa parol o'zgarmaydi.",
    sessionsNote: "Parol almashgach adminning hozir ochiq sessiyalari avtomatik yopilmaydi.",
    generate: 'Kuchli parol yaratish', copy: 'Nusxalash', copied: 'Nusxalandi',
    saved: '{{name}} — saqlandi',
    doneTitle: "Kirish ma'lumotlari yangilandi",
    doneHint: "Parolni adminga xavfsiz yo'l bilan yetkazing — u qayta ko'rsatilmaydi.",
    nothingToSave: "Yangi parol kiriting yoki loginni o'zgartiring",
  },
};

const ru: typeof uz = {
  lang: { title: 'Язык', uz: 'Узбекский', ru: 'Русский', en: 'Английский' },
  block: {
    block: 'Заблокировать', unblock: 'Разблокировать', title: 'Блокировка пользователя', blocked: 'Заблокирован',
    reasonLabel: 'Причина блокировки', reasonPlaceholder: 'Укажите причину — она будет показана пользователю',
    hint: 'Заблокированный пользователь не сможет войти. Пользователю приложения причина отправляется в уведомлении.',
  },
  teacherDetail: {
    notFound: 'Учитель не найден', edit: 'Редактировать', fullName: 'Ф.И.О.', phone: 'Телефон', gender: 'Пол',
    male: 'Учитель (муж.)', female: 'Учитель (жен.)', birthDate: 'Дата рождения',
    assignments: 'Назначения (предмет · класс)', noAssignments: 'Нет назначений', contacts: 'Контакты',
    status: 'Статус', salaryLink: 'Зарплата и рабочее время', joined: 'Добавлен',
  },
  // Фото сотрудника — для терминала распознавания лиц (Hikvision)
  staffDelete: {
    button: 'Удалить полностью',
    done: 'Сотрудник удалён',
    blockedTitle: 'Удаление невозможно',
    blockedIntro: '{{name}} связан со следующими записями:',
    blockedHint: 'Их удаление уничтожило бы историю школы. Деактивируйте сотрудника в окне редактирования — доступ закроется, а записи останутся.',
  },
  staffPhoto: {
    upload: 'Загрузить фото', change: 'Заменить фото', remove: 'Удалить фото',
    uploaded: 'Фото загружено', removed: 'Фото удалено',
    stickerNote: 'Установлен стикер — для распознавания лица нужно настоящее фото',
  },
  staffEdit: {
    title: 'Редактирование сотрудника', account: 'Доступ и роль',
    newPassword: 'Новый пароль', passwordHint: 'Оставьте пустым — пароль не изменится',
    roleLocked: 'Свою роль изменить нельзя',
    blockHint: 'Блокировка / разблокировка — в разделе «Статус» карточки',
    noChanges: 'Изменений нет',
  },
  common: {
    reset: 'Сбросить',
    save: 'Сохранить', cancel: 'Отмена', add: 'Добавить', delete: 'Удалить', search: 'Поиск...',
    loading: 'Загрузка...', total: 'Всего', noResults: 'Не найдено', searching: 'Поиск...', actions: 'Действия', selectPlaceholder: 'Выберите', datePlaceholder: 'дд.мм.гггг', error: 'Ошибка',
    noData: 'Нет данных', itemsCount: '{{count}} шт.',
    list: 'Список',
    all: 'Все', unreadOnly: 'Только непрочитанные', dateFrom: 'Дата с', dateTo: 'Дата по', noMatch: 'Нет записей по фильтру',
  },
  guard: { denied: 'Нет доступа', deniedMsg: 'Этот раздел недоступен для вашей роли.', goHome: 'На главную' },
  // Bayroq bilan muzlatilgan bo'lim (lib/features.ts) — components/FeatureFrozen.tsx
  featureFrozen: {
    title: 'Раздел временно отключён',
    desc: 'Модуль Премиум временно заморожен. Раздел включат позже — данные сохранены.',
  },
  contractDownload: {
    title: 'Договор ученика', desc: 'Ваш договор готов. Нажмите кнопку, чтобы скачать.',
    download: 'Скачать', done: 'Договор скачан', doneHint: 'Файл сохранён на вашем устройстве.',
    again: 'Скачать снова', notFound: 'Такая ссылка на договор не найдена.',
    expired: 'Срок действия ссылки истёк — использована максимальное число раз.', error: 'Ошибка загрузки. Попробуйте позже.',
  },
  navGroups: { main: 'Главное', academics: 'Учебный процесс', finance: 'Финансы', management: 'Управление', platform: 'Платформа' },
  nav: {
    qurilmalar: 'Устройства',
    agentlar: 'Агенты FACE ID',
    faceid: 'FACE ID',
    dashboard: 'Панель', students: 'Ученики', parents: 'Родители', teachers: 'Учителя', classes: 'Классы', subjects: 'Предметы',
    schedule: 'Расписание', attendance: 'Посещаемость', grades: 'Оценки', journal: 'Электронный журнал', homework: 'Домашнее задание',
    ranking: 'Рейтинг', behavior: 'Поведение', exams: 'Тестовые экзамены',
    payments: 'Финансы', reports: 'Отчёты', expenses: 'Расходы', payroll: 'Зарплата', admissions: 'Приём / CRM', contracts: 'Договоры', announcements: 'Объявления', banners: 'Баннеры', notifications: 'Уведомления', stickers: 'Стикеры', support: 'Поддержка', premium: 'Премиум', platformSupport: 'Помощь платформы', tenants: 'Школы', saasPremium: 'Премиум', saasGifts: 'Подарки', saasSupport: 'Поддержка',
    audit: 'Аудит и безопасность',
    staff: 'Сотрудники', academicYears: 'Учебный год и четверти', settings: 'Настройки',
  },
  header: { refresh: 'Обновить', search: 'Поиск или переход в раздел...', settings: 'Настройки', logout: 'Выйти', light: 'Светлый режим', dark: 'Тёмный режим' },
  roles: {
    SUPER_ADMIN: 'Супер админ', DIRECTOR: 'Директор', ADMIN: 'Администратор', ACCOUNTANT: 'Бухгалтер',
    TEACHER: 'Учитель', HOMEROOM_TEACHER: 'Классный руководитель', RECEPTION: 'Приёмная', PARENT: 'Родитель', STUDENT: 'Ученик',
  },
  studentStatus: { ACTIVE: 'Учится', INACTIVE: 'Неактивен', ON_LEAVE: 'В отпуске', GRADUATED: 'Выпустился', EXPELLED: 'Отчислен' },
  expenses: { title: 'Расходы', add: 'Добавить расход', added: 'Расход добавлен', empty: 'Нет расходов', income: 'Доход', expenses: 'Расход', net: 'Чистая прибыль', debt: 'Задолженность', debtors: 'должников', byCategory: 'По категориям', allCategories: 'Все категории', category: 'Категория', staff: 'Сотрудник', staffSearch: 'Поиск сотрудника...', note: 'Заметка', amount: 'Сумма', date: 'Дата', forMonth: 'За какой месяц', amountRequired: 'Введите сумму', clickHint: 'Нажмите на категорию для деталей', categoryTotal: 'Итого по категории', records: 'Записей', detailSearch: 'Поиск по заметке или сотруднику...', detailEmpty: 'В этой категории нет расходов', createdBy: 'Добавил', searchPlaceholder: 'Поиск по заметке или сотруднику...', sortCategoryAsc: 'Категория (А-Я)', noMatch: 'Нет расходов по фильтру', allMonths: 'Все месяцы', statsMonth: 'Показатели за {{month}}', statsPeriodDiffers: 'Таблица ниже показывает другой период: {{period}}', rangeFrom: 'с {{date}}', rangeTo: 'по {{date}}', emptyMonthHint: 'За {{month}} расходов не зафиксировано — попробуйте выбрать другой период.', rangeMonthHint: 'При выбранном диапазоне дат фильтр по месяцу не применяется: диапазон работает по дате расхода, а месяц — по тому, к какому месяцу расход относится.', backToMonth: 'Фильтровать по месяцу', statsIgnoresFilters: 'Поиск и фильтр по категории к карточкам не применяются — расчёт за весь месяц', type: 'Тип расхода', typeHint: 'Список типов ведёт администрация', allTypes: 'Все типы', noType: 'Без типа', cashIncomeHint: 'Поступило в кассу за месяц: {{sum}}', methodHint: 'В кассовом отчёте расход делится на наличные и банк' },
  payrollPage: {
    title: 'Зарплата', prevMonth: 'Предыдущий месяц', nextMonth: 'Следующий месяц',
    accrued: 'Начислено', paid: 'Выплачено', remaining: 'Остаток', forecast: 'Ожидается к концу месяца',
    overpaidHint: 'Переплачено: {{sum}}',
    overWithheld: 'удержания больше начисленного', overWithheldHint: 'Удержания больше начисленного: {{sum}}',
    meta: 'Рабочих дней: {{kun}} · допуск {{daq}} мин · рассчитано {{vaqt}}',
    ruleOff: 'Для этого месяца правило рабочего времени не включено — расчёт по-старому (полный оклад)',
    noSalary: 'Зарплата не настроена у сотрудников: {{n}}', toStaff: 'К сотрудникам',
    search: 'Поиск по имени сотрудника...',
    staff: 'Сотрудник', role: 'Роль', monthly: 'Оклад', daily: 'В день', days: 'Дни', came: 'Пришёл', absent: 'Не пришёл',
    lateEarly: 'Опозд./уход', withheld: 'Удержано', adjustment: 'Корректировка',
    lateEarlyValue: '{{kech}} / {{erta}} мин', outsideDays: 'Вне периода работы: {{n}} дн.',
    today: 'сегодня +{{sum}}', overpaid: 'переплата', pay: 'Выдать зарплату', payConfirm: 'Выдать', total: 'Итого',
    empty: 'В этом месяце нет сотрудников на окладе', loadError: 'Не удалось загрузить таблицу зарплат', retry: 'Повторить',
    warnNoShift: 'Нет графика',
    warnNoShiftHint: 'График не задан — дни прихода засчитываются полностью, опоздания и ранний уход не учитываются',
    warnOpenLog: 'Уход не отмечен',
    warnOpenLogHint: 'В прошедшие дни есть записи без ухода — считается, что сотрудник работал до конца смены',
    warnNoLogs: 'Нет записей',
    warnNoLogsHint: 'В этом месяце в рабочие дни нет ни одной отметки прихода — проверьте привязку к FACE ID',
    warnNoWorkdays: 'Дни смены не совпадают с днями зарплаты',
    warnNoWorkdaysHint: 'Смена сотрудника не приходится на рабочие дни для зарплаты — проверьте смену или Настройки → Рабочие дни для зарплаты',
    passedDays: 'Прошедшие дни', expectedDays: 'Ожидаемые дни', absentSum: 'Сумма за пропуски',
    lateMin: 'Опоздания (мин)', earlyMin: 'Ранний уход (мин)', warnings: 'Предупреждения',
  },
  expenseCat: { SALARY: 'Зарплата', RENT: 'Аренда', UTILITY: 'Коммунальные', SUPPLY: 'Оснащение', TAX: 'Налог', MAINTENANCE: 'Ремонт', OTHER: 'Прочее' },
  expenseTypes: {
    title: 'Типы расходов', manage: 'Управление типами', byType: 'По типам',
    name: 'Название', namePlaceholder: 'Например: Интернет', group: 'Группа',
    groupHint: 'В какую категорию попадёт в отчётах',
    order: 'Порядок', usage: 'Использовано', active: 'Активен', inactive: 'Неактивен',
    add: 'Добавить тип', added: 'Тип добавлен', updated: 'Сохранено', deleted: 'Тип удалён',
    nameRequired: 'Введите название типа', edit: 'Изменить', close: 'Закрыть',
    activate: 'Активировать', deactivate: 'Деактивировать',
    deleteBlocked: 'Тип используется в расходах — удалить нельзя, сделайте неактивным',
    empty: 'Типов расходов нет', emptyDesc: 'Добавьте первый тип в поле выше.',
  },
  plans: {
    tab: 'Ежемесячная оплата',
    progress: 'Сумма указана: {{done}} / {{total}} учеников',
    hint: 'Долг считается от этой суммы: ученик без суммы не попадает в список должников.',
    search: 'Поиск ученика...',
    allClasses: 'Все классы',
    onlyMissing: 'Только без суммы',
    discard: 'Отменить',
    save: 'Сохранить ({{count}})',
    saved: 'Суммы сохранены: {{count}}',
    emptyAmount: 'В {{count}} изменённых строках нет суммы — укажите сумму или отмените изменения.',
    student: 'Ученик',
    class: 'Класс',
    monthly: 'Сумма в месяц',
    discount: 'Скидка',
    due: 'К оплате',
    note: 'Примечание',
    noAmount: 'не указана',
  },
  debtStart: {
    section: 'Учёт долгов',
    sectionDesc: 'Месяц перехода школы на систему — более ранние месяцы не считаются долгом',
    label: 'Месяц начала учёта долгов',
    hint: 'Если платежей до этого месяца нет в системе, эти месяцы не попадут в должники.',
    none: 'Без ограничения',
    noneHint: 'Без ограничения — все месяцы учитываются в долгах.',
    saved: 'Месяц начала учёта сохранён',
    cleared: 'Ограничение снято',
    beforeNotice: 'Учёт долгов ведётся с {{month}} — этот месяц не учитывается.',
  },
  payrollRule: {
    section: 'Правило расчёта зарплаты',
    sectionDesc: 'Оклад и почасовая оплата считаются по установленному рабочему времени',
    fromMonth: 'С какого месяца',
    fromMonthHint: 'С этого месяца опоздание и ранний уход уменьшают зарплату, ранний приход и поздний уход не добавляются.',
    offPlaceholder: 'Выключено',
    offHint: 'Выключено — зарплата считается как раньше.',
    grace: 'Допуск',
    graceHint: 'Опоздание или ранний уход до стольких минут не учитываются.',
    min: 'мин',
    saved: 'Правило сохранено',
    off: 'Правило выключено',
    workDays: 'Рабочие дни для зарплаты',
    workDaysHint: 'Дневная ставка оклада считается по этим дням (на учебные дни не влияет)',
    workDaysRequired: 'Выберите хотя бы один день',
  },
  kunlar: {
    monthsTitle: 'По месяцам', monthsSubtitle: 'Сколько дней пришёл, сколько отработал и сколько начислено. Нажмите на строку, чтобы выбрать месяц',
    month: 'Месяц', came: 'Пришёл', absent: 'Не пришёл', worked: 'Отработано', accrued: 'Начислено', paid: 'Выдано', remaining: 'Остаток',
    daysOf: '{{n}} / {{jami}} дн.', extraDays: '+{{n}} в выходные', noOutDays: '{{n}} дн. без ухода', selected: 'выбран',
    title: 'По дням — {{month}}', subtitle: 'Когда пришёл, когда ушёл, сколько отработал и сколько начислено за день',
    date: 'Дата', status: 'Статус', in: 'Пришёл', out: 'Ушёл', workedCol: 'Отработал', shift: 'Рабочее время', dayPay: 'За день', adj: 'Бонус / штраф',
    s_KELDI: 'Пришёл', s_ISHDA: 'На работе', s_KELMADI: 'Не пришёл', s_KUTILMOQDA: 'Ожидается', s_DAM: 'Выходной', s_TASHQARI: 'Вне периода работы',
    noOut: 'Уход не отмечен', setOut: 'Указать время ухода', late: 'опоздал {{n}} мин', early: 'ушёл раньше {{n}} мин',
    soFar: 'на данный момент', notCounted: 'не учитывается', noPerDay: 'При этом типе оплаты начисление по дням не ведётся',
    showRest: 'Показывать выходные', total: 'Итого', totalDays: 'пришёл {{n}} дн.',
    roundHint: 'Сумма по дням может отличаться от месячной на несколько сумов — округление один раз за месяц',
    noOutHint: 'Прошедших дней без отметки ухода: {{n}}. Считается до конца смены (без смены — полный день) — укажите точное время',
    outTitle: 'Указать время ухода', outDay: 'День: {{day}}', outCame: 'Пришёл: {{time}}', outTime: 'Время ухода', outSave: 'Сохранить',
    outSaved: 'Время ухода сохранено', outAfterIn: 'Время ухода должно быть позже прихода', h: '{{h}} ч {{m}} мин',
  },
  ishVaqti: {
    title: 'Дни по рабочему времени',
    subtitle: 'Опоздание и ранний уход уменьшают оплату, ранний приход и поздний уход не добавляются',
    day: 'Дата', shift: 'Рабочее время', in: 'Пришёл', out: 'Ушёл', late: 'Опоздание', early: 'Ранний уход',
    extra: 'Сверх', counted: 'Начислено', min: 'мин', bonus: 'Бонус',
    absent: 'Не пришёл', noOut: 'не отмечен', pending: 'ожидается', soFar: 'на данный момент', inProgress: 'смена идёт',
    bonusReason: 'За работу сверх времени (+{{n}} мин)',
    workDays: 'Рабочие дни сотрудника',
    noShift: 'Рабочее время не задано — опоздания не учитываются. Укажите его во вкладке «График».',
    noShiftFixed: 'График не задан — дни прихода засчитываются полностью, опоздания и ранний уход не учитываются',
    outsidePeriod: 'Вне периода работы: {{n}} раб. дн. не учтено (см. даты приёма/увольнения)',
    openCounted: 'открытая запись (считается до конца рабочего времени)',
    openPlain: 'открытая запись',
  },
  cashbook: {
    tab: 'Кассовый отчёт', title: 'Кассовый отчёт', subtitle: 'Финансовые показатели за выбранный день', refresh: 'Обновить отчёт', date: 'Дата',
    dayIncome: 'Приход за день', dayExpense: 'Расход за день', dayNet: 'Остаток за день', totalCash: 'Общая касса',
    netHint: 'Приход − Расход', totalHint: 'Наличные + Банк, на конец дня', vsPrev: '{{pct}}% (к прошлому дню)', prevZero: 'В прошлый день: 0 сум', same: 'Как в прошлый день',
    cashBox: 'Наличные (касса)', bank: 'Банк', bankSub: 'карта, перевод', shuKun: 'за день', income: 'Приход', expense: 'Расход', rest: 'Остаток',
    cashLeft: 'Остаток наличных', bankLeft: 'Остаток в банке', leftHint: 'на конец дня, всего',
    chart: 'Приход и расход — {{year}}, по месяцам',
    details: 'Детали за выбранный день', colType: 'Тип', colSum: 'Сумма (сум)', colDate: 'Дата', colNote: 'Примечание', total: 'Итого',
    incCash: 'Приход (наличные)', incBank: 'Приход (банк)', expCash: 'Расход (наличные)', expBank: 'Расход (банк)',
    payCount: 'Платежей: {{count}}', expCount: 'Расходов: {{count}}', reversals: 'Возвратов: {{count}}', noRows: 'Нет записей',
    debtTitle: 'Задолженность за прошлый месяц — {{month}}', colStudent: 'Ученик', colClass: 'Класс', colDebt: 'Долг (сум)', monthsDebt: 'мес.: {{count}}',
    debtTotal: 'Общая задолженность', debtCount: 'Учеников: {{count}}', debtNone: 'За прошлый месяц должников нет', seeAll: 'Смотреть все',
    monthsHint: 'Примечание — за сколько месяцев с {{from}} оплата неполная',
    shareTitle: 'Доля наличных и банка (за день)', cashIn: 'Приход наличными', cashOut: 'Расход наличными', bankIn: 'Приход через банк', bankOut: 'Расход через банк',
    shareHintIn: '{{pct}}% прихода', shareHintOut: '{{pct}}% расхода',
    summary: 'Итог', sumIncome: 'Приход за день: {{sum}}', sumExpense: 'Расход за день: {{sum}}', sumNet: 'Остаток за день: {{sum}}', sumCash: 'Общая касса: {{sum}} (наличные {{cash}} + банк {{bank}})', sumDebt: 'Долг за прошлый месяц: {{sum}} (учеников: {{count}})',
    howTitle: 'Как считается',
    how1: 'Приход — платежи, принятые в этот день (за какой бы месяц они ни были). Возвраты вычитаются.',
    how2: 'Расход — расходы, внесённые в разделе «Расходы» с этой датой.',
    how3: 'Наличные — способ «Наличные»; Банк — карта, перевод и прочее.',
    how4: 'Общая касса — весь приход минус весь расход с даты начала кассы до конца выбранного дня.',
    startButton: 'Начало кассы', startTitle: 'С какого дня ведётся касса',
    startDesc: 'Платежи и расходы до этого дня не попадают в кассовый отчёт (приход, расход, остаток, график). Записи не удаляются — балансы учеников и задолженность не меняются.',
    startLabel: 'Дата начала', startClear: 'Считать всю историю', startSaved: 'Дата начала кассы сохранена', startFrom: 'с {{date}}',
  },
  balances: {
    tab: 'Балансы', tabPayments: 'Платежи', due: 'План', overpaid: 'Переплата', status: 'Статус',
    byStatus: 'По статусам', clickHint: 'Нажмите на статус, чтобы отфильтровать',
    allStatuses: 'Все статусы', searchPlaceholder: 'Ученик или класс...',
    empty: 'Нет данных по балансам', noPlan: 'Нет плана оплаты',
    balanceHint: 'Баланс: {{value}}',
    filteredSummary: '{{status}}: {{count}} учеников · долг {{debt}} · оплачено {{paid}}',
    sortOverpaidDesc: 'Переплата (большая)',
    discount: 'Скидка', discountHint: 'В сумме плана скидка УЖЕ вычтена (месячная сумма − скидка)',
  },
  balanceStatus: { PAID: 'Оплачено полностью', PARTIAL: 'Оплачено частично', DEBT: 'Должник', OVERPAID: 'Переплата' },
  days: { '1': 'Понедельник', '2': 'Вторник', '3': 'Среда', '4': 'Четверг', '5': 'Пятница', '6': 'Суббота', '7': 'Воскресенье' },
  monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
  monthsFull: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  charts: { income: 'Доход', count: 'Ученики', monthIncome: 'Доход за месяц', cashIncome: 'Поступления в кассу' },
  currency: { som: 'сум', thousand: 'тыс.', million: 'млн', billion: 'млрд' },
  timeAgo: { justNow: 'только что', min: '{{n}} мин назад', hour: '{{n}} ч назад', day: '{{n}} дн назад' },
  reports: {
    byClass: 'Ученики по классам', students: 'Ученики', monthlyRevenue: 'Доход по месяцам за {{year}}', revenueHint: 'Доход за месяц — оплачено за этот месяц. Поступления в кассу — деньги, полученные в течение месяца. При предоплате за несколько месяцев они различаются.',
    noData: 'Нет данных', debtors: 'Должники', totalDebt: 'Общий долг', found: 'Найдено',
    count: '{{count}} шт.', searchDebtor: 'Ученик или класс...', noDebtors: 'Должников нет',
    class: 'Класс', plan: 'План', paidCol: 'Оплачено', debtCol: 'Долг',
    sortDebtDesc: 'Долг (больше)', sortDebtAsc: 'Долг (меньше)', sortNameAsc: 'Имя (А-Я)', sortNameDesc: 'Имя (Я-А)',
    sortClassAsc: 'Класс (А-Я)', sortDueDesc: 'План (больше)', sortPaidDesc: 'Оплачено (больше)',
    year: 'Год', noMatch: 'Нет должников по фильтру',
  },
  qc: {
    selectPlaceholder: 'Выберите', nothingFound: 'Ничего не найдено — добавьте новый', addNew: 'Добавить новый', searchPlaceholder: 'Поиск...',
    gender: 'Пол', male: 'Мужской', female: 'Женский',
    yearNameRequired: 'Введите название (например, 2025-2026)', yearAdded: 'Учебный год добавлен', academicYear: 'Учебный год', save: 'Сохранить',
    fullNameRequired: 'Введите Ф.И.О.', loginMinLength: 'Логин — минимум 3 символа', passwordMinLength: 'Пароль — минимум 5 символов', genderRequired: 'Выберите пол',
    teacherAdded: 'Учитель добавлен', fullName: 'Ф.И.О.', login: 'Логин', password: 'Пароль', phone: 'Телефон',
    parentCreated: 'Аккаунт родителя создан', parentFullName: 'Ф.И.О. родителя',
    subjectNameRequired: 'Введите название предмета', subjectAdded: 'Предмет добавлен', subjectName: 'Название предмета', subjectNamePlaceholder: 'Математика', code: 'Код',
    classNameRequired: 'Введите название класса', academicYearRequired: 'Выберите учебный год', classAdded: 'Класс добавлен', className: 'Название класса', homeroomTeacher: 'Классный руководитель',
    newAcademicYear: 'Новый учебный год', newTeacher: 'Новый учитель',
  },
  contactsMgr: {
    saved: 'Сохранено', deleted: 'Удалено', phones: 'Телефоны', add: 'Добавить', noPhones: 'Телефоны не добавлены',
    primaryPhone: 'Основной номер', makePrimary: 'Сделать основным', primary: 'основной',
    addresses: 'Адреса', noAddresses: 'Адреса не добавлены', primaryAddress: 'Основной адрес',
    phone: 'Телефон', address: 'Адрес', labelName: 'Название (например: Отец, Дом, Работа)', number: 'Номер', cancel: 'Отмена', save: 'Сохранить',
  },
  multiContact: {
    phones: 'Телефонные номера', labelPlaceholder: 'Метка (Работа, Дом...)', primary: 'Основной', addPhone: 'Добавить номер', primaryHint: '◉ — основной номер',
    addresses: 'Адреса', labelShort: 'Метка', address: 'Адрес', addAddress: 'Добавить адрес',
  },
  staffPage: {
    payrollWarnTitle: 'Расчёт зарплаты неполный',
    fullName: 'Ф.И.О.', login: 'Логин', password: 'Пароль', role: 'Роль', phone: 'Телефон', status: 'Статус', active: 'Активен',
    user: 'Пользователь', create: 'Создать', birthDate: 'Дата рождения', birthDateOptional: 'Дата рождения (необязательно)', datePlaceholder: 'дд.мм.гггг',
    searchPlaceholder: 'Имя или логин...', sortNewest: 'Новые', sortNameAsc: 'Имя (А-Я)', sortRole: 'Роль',
    saved: 'Сохранено', created: 'Пользователь создан',
    fullNameRequired: 'Введите Ф.И.О.', loginMin: 'Логин — минимум 3 символа', passwordMin: 'Пароль — минимум 5 символов', genderRequired: 'Выберите пол',
    specialty: 'Специализация',
    specialtyHint: 'Конкретная работа внутри роли — видна рядом с именем',
    specialtyPlaceholder: 'Математика, КПП, Психолог…',
    notifyTitle: 'Отправить уведомление', notifyHint: 'Этому сотруднику будет отправлено личное уведомление (например, поздравление с днём рождения).',
    notifySubject: 'Заголовок', notifyBody: 'Текст', send: 'Отправить', notifySent: 'Уведомление отправлено',
    blocked: 'Заблокирован',
    empty: 'Сотрудники не найдены', emptyDesc: 'Измените поиск или фильтр.',
  },
  teachersPage: {
    add: 'Новый учитель',
    title: 'Учителя', login: 'Логин', role: 'Роль', allRoles: 'Все', active: 'Активен',
    searchPlaceholder: 'Имя или логин...', sortNameAsc: 'Имя (А-Я)', sortNameDesc: 'Имя (Я-А)', sortNewest: 'Новые', sortRole: 'Роль',
    status: 'Статус', blocked: 'Заблокирован',
    exportCsv: 'Экспорт (CSV)',
    exportHint: 'Файл списка для загрузки в терминал распознавания лиц (Hikvision)',
  },
  studentsPage: {
    sortNameAsc: 'Имя (А-Я)', sortNameDesc: 'Имя (Я-А)', sortNewest: 'Недавно добавленные', sortAdmissionDate: 'Дата зачисления',
    colParentPhone: 'Тел. родителя', fromAdmission: 'Выбрать из заявок (необязательно)',
    fromAdmissionDesc: 'При выборе кандидата данные заполнятся автоматически', fromAdmissionPlaceholder: 'Кандидат из списка заявок',
    admissionNotice: 'Данные взяты из заявки. После создания кандидат будет отмечен как «зачислен».',
    orManual: 'или введите данные вручную', newClass: 'Новый класс', birthDate: 'Дата рождения',
    parentAccount: 'Аккаунт родителя (выбрать или создать)', parentSearchPlaceholder: 'Поиск по имени или телефону...',
    newParent: 'Новый родитель', parentNameNoAccount: 'Ф.И.О. родителя (без аккаунта)',
    created: 'Ученик добавлен', deleted: 'Удалено',
    validateFullName: 'Введите Ф.И.О.', validateClass: 'Выберите класс (обязательно)', validateGender: 'Выберите пол',
  },
  studentDetailPage: { accountTitle: 'Аккаунт для входа', newPassword: 'Новый пароль', passwordHint: 'Оставьте пустым — пароль не изменится', loginUpdated: 'Аккаунт обновлён',
    deleteImpactTitle: 'Внимание — необратимо',
    deleteImpactIntro: 'Вместе с {{name}} будет удалено:',
    deleteImpactWarn: 'Это действие нельзя отменить.',
    deleteAnyway: 'Всё равно удалить',
    impactContracts: 'Договоры ({{n}}) не удалятся, но останутся без владельца.',
    impact_tolovlar: 'Платежи',
    impact_davomat: 'Записи посещаемости',
    impact_baholar: 'Оценки',
    impact_chorak: 'Четвертные оценки',
    impact_testlar: 'Баллы тестов',
    impact_xulq: 'Оценки поведения',
    impact_reja: 'План оплаты',
        createLogin: "Создать логин",
        hasLogin: "Кабинет: {{login}}",
        loginCreated: "Кабинет ученика создан",
        studentLoginTitle: "Создание кабинета ученика",
        studentLoginHint: "С этим логином ученик войдёт в приложение и увидит свои оценки и посещаемость. Ф.И.О. и пол берутся из карточки.",
    notFound: 'Ученик не найден', backToList: 'Список учеников', noClass: 'Без класса', edit: 'Редактировать',
    newParent: 'Новый родитель', linkExisting: 'Привязать существующего', tuitionPlan: 'План оплаты', parent: 'Родитель',
    accountChildren: 'аккаунт · детей: {{n}}', otherChildren: 'Другие дети:', monthlyTuition: 'Ежемесячная оплата',
    balanceTitle: 'Баланс за текущий месяц', balanceEmpty: 'За этот месяц данных по балансу нет — не заведён ни план оплаты, ни платёж.',
    tabGrades: 'Оценки', tabAttendance: 'Посещаемость', tabPayments: 'Платежи', tabContacts: 'Контакты',
    noGrades: 'Оценок нет', colGrade: 'Оценка', noAttendance: 'Записей о посещаемости нет', noPayments: 'Платежей нет',
    parentAccountTitle: 'Аккаунт кабинета родителя', parentAccountHint: 'Для входа родителя в мобильный кабинет создаются логин и пароль.',
    login: 'Логин', password: 'Пароль', create: 'Создать',
    linkParentTitle: 'Привязать существующего родителя', linkParentHint: 'Привяжите к этому ученику родителя, чей другой ребёнок уже есть в системе.',
    childrenCount: 'детей: {{n}}', link: 'Привязать', editTitle: 'Редактировать ученика', selectClass: 'Выберите класс',
    monthlyAmount: 'Ежемесячная оплата (сум)', discount: 'Скидка (сум)', final: 'Итого',
    parentLinked: 'Родитель привязан', saved: 'Сохранено', parentCreated: 'Аккаунт родителя создан', planSaved: 'План оплаты сохранён',
    validateFullName: 'Введите Ф.И.О.', validateLogin: 'Логин — минимум 3 символа', validatePassword: 'Пароль — минимум 5 символов', validateGender: 'Выберите пол',
    deleted: 'Ученик удалён', deleteHint: 'Полностью удалить ученика. Это действие необратимо.',
    photo: 'Фото', uploadPhoto: 'Загрузить фото', changePhoto: 'Изменить фото', removePhoto: 'Удалить фото',
    photoUpdated: 'Фото обновлено', photoRemoved: 'Фото удалено',
    limitedNote: 'Показаны последние {{n}} записей', openFull: 'Открыть полную страницу',
    year: 'Год', filteredTotal: 'Итого по выбранным', noMatch: 'Нет записей по фильтру',
    note: 'Заметка', mainPhoneHint: 'Основной номер — он показывается в списке учеников',
    contactsHint: 'Дополнительные телефоны и адреса добавляются в разделе «Контакты».',
  },
  homeworkPage: {
    add: 'Добавить задание', searchPlaceholder: 'Название задания...', sortNew: 'Новые задания', sortDueSoon: 'Срок (ближайшие)', sortTitleAsc: 'Название (А-Я)',
    class: 'Класс', selectClass: 'Выберите класс', empty: 'Домашних заданий нет', subject: 'Предмет', task: 'Задание', due: 'Срок',
    modalTitle: 'Добавить домашнее задание', newSubject: 'Новый предмет', titleField: 'Название', description: 'Описание', dueDate: 'Срок сдачи',
    fileUrl: 'Ссылка на файл (необязательно)', subjectRequired: 'Выберите предмет', titleRequired: 'Введите название', created: 'Домашнее задание добавлено',
    mineOnly: 'Только мои',
    teacher: 'Кто задал', teacherDisabledHint: 'Включено «Только мои»',
    dueRange: 'Период срока', dueRangeHint: 'Без срока не показываются',
    overdueOnly: 'Просроченные', activeOnly: 'Активные', overdueHint: 'Срок сдачи истёк',
    noDue: 'Без срока',
  },
  admissionsPage: {
    stageNew: 'Новая', stageContacted: 'Связались', stageTest: 'Тест', stageInterview: 'Собеседование',
    statusOpen: 'Открыта', statusAccepted: 'Принят', statusRejected: 'Отклонён', statusEnrolled: 'Зачислен',
    filterEnrolled: 'Зачислен', filterRejected: 'Отказ', searchPlaceholder: 'Кандидат или телефон...', sortNew: 'Новые заявки', sortNameAsc: 'Имя (А-Я)',
    stage: 'Этап', status: 'Статус', empty: 'Заявок нет', applicant: 'Кандидат', age: 'Возраст', source: 'Источник', ageYears: '{{age}} лет',
    modalTitle: 'Новая заявка', applicantName: 'Ф.И.О. кандидата (ученика)', birthDate: 'Дата рождения', birthDatePlaceholder: 'дд.мм.гггг',
    sourcePlaceholder: 'Instagram, рекомендация...', note: 'Заметка', notePlaceholder: 'Дополнительная информация, наблюдения...',
    applicantRequired: 'Введите имя кандидата', phoneRequired: 'Введите телефон', created: 'Заявка добавлена',
    enroll: 'Зачислить в ученики', enrollTitle: 'Зачислить в ученики',
    enrollDesc: 'Данные кандидата заполнены — выберите класс и пол, затем сохраните.',
    enrolled: 'Ученик зачислен', enrollValidateName: 'Ф.И.О. не менее 3 букв',
    enrollValidateClass: 'Выберите класс', enrollValidateGender: 'Выберите пол',
    alreadyEnrolled: 'Зачислен',
  },
  classDetail: {
    name: 'Название класса', nameRequired: 'Название класса обязательно', academicYear: 'Учебный год',
    homeroomTeacher: 'Классный руководитель', homeroomTeacherPlaceholder: 'Выберите учителя', noTeachers: 'Учитель не найден',
    studentsCount: 'Ученики', groupsCount: 'Группы', students: 'Ученики', noStudents: 'Учеников нет',
    groups: 'Группы', noGroups: 'Групп нет', edit: 'Редактирование', saved: 'Сохранено',
    deleted: 'Класс удалён', deleteHint: 'Удаление класса необратимо', notFound: 'Класс не найден',
    changeStatus: 'Изменить статус', statusUpdated: 'Статус обновлён',
    changeStatusConfirm: '{{name}} — изменить статус на «{{status}}»?',
    statusHint: 'Нажмите на статус, чтобы изменить',
  },
  bannerDetail: {
    notFound: 'Баннер не найден', preview: 'Просмотр', active: 'Активен', inactive: 'Неактивен',
    createdBy: 'Создал', edit: 'Редактирование', deleteHint: 'Полностью удалить баннер. Это действие необратимо.',
  },
  bannerTemplate: {
    HERO: { label: 'Герой с фото', desc: 'Фото/градиент + скрим + CTA' },
    SOLID: { label: 'Сплошной цвет', desc: 'Цвет/градиент + иконка + текст' },
    GRADIENT: { label: 'Праздничный градиент', desc: 'Градиент + декоративные круги' },
    SPLIT: { label: 'Сплит (медиа + текст)', desc: 'Слева медиа, справа текст' },
    MINIMAL: { label: 'Минимальное объявление', desc: 'Лёгкая карточка + цветная линия' },
    TICKET: { label: 'Билет (премиум)', desc: 'Стиль билета + печать' },
  },
  bannersPage: {
    title: 'Баннеры', subtitle: 'Главная страница приложения — шаблон + 3 языка + конструктор light/dark', add: 'Новый баннер',
    empty: 'Баннеров нет', emptyDesc: 'Создайте первый баннер — он появится на главной странице приложения.',
    preview: 'Вид', templateTitle: 'Шаблон / Заголовок', audience: 'Аудитория', active: 'Активен',
    confirmDelete: 'Удалить баннер?', editTitle: 'Редактировать баннер', createTitle: 'Новый баннер — конструктор', template: 'Шаблон',
    content: 'Контент (для каждого языка отдельно)', fieldTitle: 'Заголовок', fieldBody: 'Текст', fieldCta: 'Кнопка (CTA)', fieldEyebrow: 'Метка (eyebrow)',
    fallbackHint: 'Если оставить пустым — будет использован узбекский текст.', design: 'Дизайн (светлая/тёмная отдельно)',
    alignLeft: 'Слева', alignCenter: 'По центру', scrim: 'Тёмный градиент', emoji: 'Эмодзи / иконка', themeLight: 'Светлая', themeDark: 'Тёмная',
    gradientBg: 'Градиентный фон', bgColor: 'Цвет фона', gradient1: 'Градиент 1', gradient2: 'Градиент 2', ticketBg: 'Фон билета',
    accentColor: 'Акцентный цвет (CTA/линия/печать)', textLight: 'Белый текст', textDark: 'Чёрный текст',
    uploadImage: 'Загрузить изображение', removeImage: 'Удалить изображение', imageUploadFailed: 'Не удалось загрузить изображение',
    audAll: 'Всем', audParents: 'Родители', audFathers: 'Отцы', audMothers: 'Матери', audTeachers: 'Учителя',
    audTeachersMale: 'Учителя (муж.)', audTeachersFemale: 'Учителя (жен.)', audMales: 'Все мужчины', audFemales: 'Все женщины',
    audCustom: 'Выбранные пользователи', roleFather: 'Отец', roleMother: 'Мать', roleTeacherMale: 'Учитель',
    users: 'Пользователи', usersDesc: 'Баннер увидят только выбранные', usersPlaceholder: 'Имя или телефон...',
    linkScreen: 'Экран (при нажатии)', linkUrl: 'Внешняя ссылка', startsAt: 'Начало', endsAt: 'Окончание', optional: 'необязательно', screenProfile: 'Профиль',
    order: 'Порядок', activeLabel: 'Активен (виден в приложении)', livePreview: 'Живой предпросмотр', saved: 'Сохранено', deleted: 'Удалено',
    kioskLabel: 'Показывать на киоск-экране', kioskDesc: 'Баннер также будет показываться на TV-экране в школе', kioskBadge: 'Киоск',
    kioskAllOnly: 'На TV-экране показываются только баннеры с аудиторией «Всем»',
    kioskBadgeInactive: 'Киоск (не показывается)',
    kioskClearedWarn: 'При сохранении отметка киоска будет снята — на TV-экране показываются только баннеры с аудиторией «Всем». Если отметка нужна, верните аудиторию «Всем» до сохранения',
    linkScreenFrozen: 'Этот экран временно отключён — баннер НЕ появится в приложении. Выберите другой экран или оставьте ссылку пустой.',
  },
  platformSupportPage: {
    subtitle: 'Прямая переписка с суперадмином системы', emptyHint: 'Есть вопрос или проблема — напишите суперадмину платформы.',
    messagePlaceholder: 'Напишите сообщение...', send: 'Отправить',
  },
  saasSupportPage: {
    title: 'Поддержка — админы школ', subtitle: 'Переписка с админами школ', emptyTitle: 'Нет сообщений',
    emptyDesc: 'Появятся здесь, когда админы школ напишут.', youPrefix: 'Вы: ', selectSchool: 'Выберите школу',
    replyPlaceholder: 'Напишите ответ...', send: 'Отправить',
    search: 'Название школы...', unreadOnly: 'Только непрочитанные',
  },
  saasGiftsPage: {
    title: 'Подарки — все школы', searchPlaceholder: 'Имя или телефон...', emptyTitle: 'Нет подарков',
    emptyDesc: 'Премиум-подарки пока не отправлялись.', school: 'Школа', from: 'От кого', to: 'Кому', duration: 'Срок', anonymous: 'аноним', months: '{{n}} мес.',
    tenant: 'Школа', sortDateDesc: 'Дата (новые)', sortDateAsc: 'Дата (старые)', sortMonthsDesc: 'Срок (больше)',
  },
  saasPremiumPage: {
    title: 'Премиум — все школы', subtitle: 'Контроль оплат только у суперадмина', premiumUpdated: 'Премиум обновлён',
    searchPlaceholder: 'Имя или телефон...', school: 'Школа', allSchools: 'Все школы', all: 'Все', regular: 'Обычный',
    sortNameAsc: 'Имя (А-Я)', sortPremiumDesc: 'Премиум (дольше)', sortPremiumAsc: 'Премиум (скоро истекает)', sortNewest: 'Новые',
  },
  layout: { search: 'Поиск' },
  contractGen: {
    tooltip: "Создать и отправить договор", modalTitle: 'Договор с родителями', contractNumber: 'Номер договора',
    contractNumberAuto: 'Оставьте пустым — номер выдаст сервер автоматически',
    contractNumberPlaceholder: 'Автоматически',
    contractDate: 'Дата договора', studentName: 'Ф.И.О. ученика', parentName: 'Ф.И.О. родителя (или замещающего лица)',
    parentAddress: 'Адрес проживания родителя', durationMonths: 'Срок обучения (мес.)', passport: 'Серия и номер паспорта',
    jshshir: 'ЖШШИР (необязательно)', jshshirPlaceholder: '14 цифр',
    selectFromPhones: 'Выбрать из номеров родителя', selectPhone: 'Выберите номер',
    phoneLabel: "Телефон родителя", phoneLabelExtra: 'Дополнительный',
    parentFillsHint: 'Необязательно — родитель заполнит сам по ссылке',
    identitySection: 'Данные, удостоверяющие личность (необязательно)',
    identityHint: 'Ф.И.О., адрес, паспорт и ПИНФЛ родитель заполняет САМ по ссылке и подтверждает при подписании — школе вводить их не нужно.',
    parentNameOptional: 'Необязательно — если оставить пустым, родитель укажет сам при подписании',
    identityFilled: 'Заполнено: {{count}}',
    attachPhone: 'Привязать новый номер к родителю',
    attachPhoneHint: "Номер будет добавлен в контакты родителя. Если снять галочку, номер останется только в договоре.",
    phoneAttached: 'Новый номер добавлен в контакты родителя.',
    phoneAttachFailed: 'Не удалось привязать новый номер к родителю — проверьте контакты вручную. Договор всё равно создан.',
    fromDate: 'Срок договора (с)', toDate: 'Срок договора (по)', createAndSend: "Создать и отправить",
    parentNameTooShort: 'Ф.И.О. должно содержать не менее 5 символов',
    addressTooShort: 'Адрес должен содержать не менее 5 символов',
    passportInvalid: 'Неверный формат паспорта (например: AB 1234567)',
    jshshirInvalid: 'ЖШШИР должен состоять из 14 цифр',
    parentPhoneInvalid: 'Введите номер телефона полностью',
    paymentRequired: 'Ежемесячная оплата должна быть положительным числом',
    paymentTooBig: 'Слишком большая сумма — проверьте значение',
    monthsInvalid: 'Количество учебных месяцев — от 1 до 12',
    fromDateRequired: 'Выберите дату начала', toDateRequired: 'Выберите дату окончания',
    toDateBeforeFrom: 'Дата окончания должна быть позже даты начала',
    numberTaken: 'Договор с таким номером уже существует — введите другой номер или оставьте поле пустым',
    numberIssued: 'Номер договора: {{number}}',
    requisitesTitle: 'Реквизиты школы не заполнены',
    requisitesHint: 'Без реквизитов школы документ договора не формируется. Заполните их в разделе «Настройки».',
    requisitesHintNoAccess: 'Без реквизитов школы документ договора не формируется. Заполнить их может только администрация школы (директор или админ) — обратитесь к ним.',
    requisitesLink: 'Настройки — реквизиты школы',
    openContract: 'Открыть договор',
    createdNotified: "Договор создан и отправлен родителю в приложение", createdNoApp: "Договор создан (родителя нет в приложении — поделитесь ссылкой)",
    create: 'Создать договор',
    linkReady: 'Ссылка готова', notified: "Родителю отправлено уведомление в приложении — он просмотрит и подпишет договор там.", notNotified: "К ученику не привязан аккаунт родителя — уведомление не отправлено. Поделитесь ссылкой ниже с родителем сами.",
    noParentWarn: "К ученику не привязан аккаунт родителя — уведомление в приложение не придёт. После создания договора поделитесь ссылкой с родителем сами.",
    copied: 'Скопировано', copy: 'Копировать', linkNote: 'По ссылке родитель читает договор, вводит свои данные и подписывает онлайн. Если у родителя есть мобильное приложение, договор появится и там.', close: 'Закрыть',
  },
  contractList: {
    tab: 'Договоры', empty: 'Договоры не созданы', number: 'Номер', created: 'Создан',
    student: 'Ученик',
    statusSENT: 'Отправлен', statusVIEWED: 'Просмотрен', statusSIGNED: 'Подтверждён', statusREJECTED: 'Отклонён', statusCANCELLED: 'Отменён',
    expired: 'Срок истёк',
    expiredHint: 'Срок действия ссылки истёк — родитель не сможет подписать. Отправьте повторно (будет новая ссылка и новый срок).',
    expiresAt: 'Срок действия ссылки', viewedAt: 'Дата открытия родителем', notViewed: 'Ещё не открыт',
    answeredAt: 'Дата ответа', waitingDays: 'ожидает {{n}} дн.',
    signedAt: 'Дата подтверждения', signer: 'Подписал', signature: 'Подпись', signatureNone: 'Подписи нет',
    signedVia: 'Способ подписания', viaApp: 'Мобильное приложение', viaToken: "Открытая ссылка", rejectedVia: 'Способ отклонения',
    rejectedAt: 'Дата отклонения', rejectReason: 'Причина отклонения', parentData: 'Данные, введённые родителем',
    cancelledAt: 'Дата отмены', cancelReason: 'Причина отмены', cancelledBy: 'Кто отменил', createdBy: 'Кто создал',
    terms: 'Условия договора', period: 'Срок действия',
    compareTitle: 'Данные школы ↔ данные родителя', field: 'Поле', schoolValue: 'Школа', parentValue: 'Родитель', changed: 'изменено',
    auditTitle: 'Аудит', device: 'Устройство / браузер',
    frozenCopy: 'Замороженная копия', frozenYes: 'Сохранена ({{at}})', frozenNo: 'Не сохранена — документ формируется заново каждый раз',
    downloadsLeft: "Осталось скачиваний (открытая ссылка)",
    downloadsLeftHint: "Лимит относится ТОЛЬКО к открытой ссылке. Для родителя в приложении и для архива школы ограничений нет.",
    details: 'Подробнее', detailsTitle: 'Детали договора',
    link: 'Ссылка для родителя', openLink: 'Открыть ссылку', address: 'Адрес', notFilled: 'Родитель ещё не заполнил данные',
    openLinkWarn: 'Ссылка предназначена родителю. Подпись вместо родителя не имеет юридической силы — открывайте ссылку только для проверки или чтобы поделиться ею.',
    loadError: 'Не удалось загрузить договоры.', detailLoadError: 'Не удалось загрузить данные договора.', retry: 'Повторить',
    download: 'Скачать DOCX', downloadFailed: 'Не удалось скачать документ',
    resend: 'Отправить повторно', resendTitle: 'Повторная отправка договора',
    resendHint: "Будут созданы новая ссылка и новый срок, родителю придёт повторное уведомление в приложении. СТАРАЯ ССЫЛКА перестанет работать. Отклонённый договор вернётся в статус «Отправлен».",
    resendNewLink: 'Новая ссылка готова', resendNotified: "Родителю отправлено уведомление в приложении.",
    resendNotNotified: "Аккаунт родителя не привязан — поделитесь новой ссылкой ниже с родителем сами.",
    resendDone: 'Договор отправлен повторно', resendDoneNoApp: "Новая ссылка создана (родителя нет в приложении)",
    resendFailed: 'Не удалось отправить повторно',
    cancelAction: 'Отменить', cancelTitle: 'Отмена договора',
    cancelHint: 'После отмены ссылка родителя перестаёт работать НЕМЕДЛЕННО, причина показывается родителю. Отменить это действие нельзя — при необходимости создайте новый договор.',
    cancelReasonLabel: 'Причина отмены', cancelReasonPlaceholder: 'Укажите причину — она будет показана родителю',
    cancelReasonRequired: 'Укажите причину (не менее 3 символов)', cancelDone: 'Договор отменён', cancelFailed: 'Не удалось отменить',
  },
  contractsPage: {
    emptyFiltered: 'Результаты скрыты фильтром',
    emptyFilteredDesc: 'Применены фильтры: {{list}}. Очистите их, чтобы увидеть все договоры.',
    search: 'Номер, ученик или Ф.И.О. родителя...',
    exportCsv: 'Скачать CSV (все страницы)',
    exportAllHint: 'Выгружаются ВСЕ договоры по текущему фильтру, а не только открытая страница. При большом списке это займёт время.',
    exportTruncated: 'Слишком много строк: выгружены только первые {{n}} из {{total}}. Сузьте фильтр.',
    exportFailed: 'Экспорт не выполнен — попробуйте ещё раз',
    pendingQuick: 'Ожидают ответа',
    filterExpiry: 'Срок', expiredOnly: 'Срок истёк', notExpired: 'Срок не истёк',
    studentFilter: 'По ученику',
    colWaiting: 'Ожидание (дней)', stale: 'более {{n}} дн.',
    colLastSent: 'Последняя отправка', lastSentAt: 'Отсчёт с даты последней отправки: {{at}}',
    sortNewest: 'Новые договоры', sortLongestWaiting: 'Дольше всех ждут',
    sortNumberDesc: 'Номер (убыв.)', sortNumberAsc: 'Номер (возр.)',
    sortSigned: 'Дата подписания', sortExpiringSoon: 'Скоро истекают', sortStatus: 'Статус',
    activeFilters: 'Активные фильтры', clearAll: 'Очистить всё', removeFilter: 'Убрать фильтр',
    searchChip: 'Поиск: {{q}}',
  },
  paymentsPage: {
    selectStudent: 'Выберите ученика', paymentAccepted: 'Платёж принят', totalRevenue: 'Общий доход', paymentsCount: 'Количество платежей',
    searchPlaceholder: 'Имя ученика или примечание...', sortAmountDesc: 'Сумма (больше)', sortAmountAsc: 'Сумма (меньше)',
    method: 'Способ', methodCash: 'Наличные', methodCard: 'Карта', methodTransfer: 'Перевод', methodOther: 'Прочее',
    studentSearchPlaceholder: 'Поиск по имени...', amountSom: 'Сумма (сум)', paymentMethod: 'Способ оплаты',
    dateFrom: 'Дата с', dateTo: 'Дата по', dateTimePlaceholder: 'дд.мм.гггг чч:мм',
    forMonth: 'За какой месяц', classFilter: 'Класс',
    forMonthRequired: 'Укажите, за какой месяц платёж — без месяца он не спишется с долга и не попадёт в отчёт о доходах',
    noMatch: 'Нет платежей по фильтру',
    forMonthRangeHint: '«За какой месяц» и диапазон дат применяются ВМЕСТЕ: месяц — к какому месяцу относится платёж, диапазон — когда платёж принят. Если они не совпадают, список будет пустым.',
    clearRange: 'Очистить диапазон дат',
    monthCount: 'За сколько месяцев', monthsN: '{{count}} мес.', notePlaceholder: 'Например: предоплата за 4 месяца',
    splitPreview: '{{from}} — {{to}}: сумма делится по месяцам, ≈ {{each}} за месяц. Родителю выдаётся один чек.',
    edit: 'Редактировать', editTitle: 'Редактирование платежа', note: 'Примечание', editSaved: 'Платёж изменён',
    editReason: 'Причина изменения', editReasonPlaceholder: 'Например: кассир ошибся в сумме', editReasonRequired: 'Укажите причину',
    editFinancialHint: 'Так как изменены сумма, месяц, способ или дата, старый платёж будет закрыт как «возврат» и создан исправленный новый платёж. Старый чек станет недействительным — будет выдан новый.',
    badgeStorno: 'Возврат', badgeReversed: 'Возвращён',
  },
  receipt: {
    title: 'Чек об оплате', no: 'Чек № {{no}}', school: 'Школа', date: 'Дата', student: 'Ученик', class: 'Класс',
    forMonth: 'За какой месяц', method: 'Способ оплаты', note: 'Примечание', issuedBy: 'Принял',
    thanks: 'Спасибо за оплату!', printedAt: 'Напечатано: {{at}}',
    print: 'Печать', close: 'Закрыть', open: 'Чек', notFound: 'Чек не найден',
  },
  faceLink: {
    none: 'Не привязан', manage: 'Привязка FACE ID', title: 'Привязка к терминалу FACE ID',
    pickHint: 'Выберите запись, которая есть в терминале, но ни к кому не привязана. ★ — имя похоже на этого сотрудника.',
    pickPlaceholder: 'Выберите запись терминала', noFree: 'Свободных записей нет', link: 'Привязать', or: 'или',
    enrollHint: 'Если сотрудника нет в терминале — запишите его как новую запись. Затем он регистрирует лицо у терминала.',
    enroll: 'Записать в терминал', unlink: 'Отвязать',
    linked: 'Привязано', linkedRestored: 'Привязано — восстановлена посещаемость за {{count}} дн.', unlinked: 'Отвязано',
    enrollQueued: 'Поставлено в очередь — №{{no}}. Будет записано в терминал, когда запустится агент',
    pendingHint: 'В очереди — агент ещё не записал в терминал', okHint: 'Привязан, лицо есть в терминале — посещаемость пишется автоматически.',
    noFaceHint: 'Привязан, но лицо ещё не зарегистрировано — сотрудник должен зарегистрировать лицо у терминала.',
  },
  faceid: {
    pickStaff: 'Выберите сотрудника', linked: 'Связано',
    setHttpHost: 'Подключить терминал к серверу',
    setHttpHostHint: 'Нажимается один раз. После этого устройство само отправляет каждый проход на сервер — в школе ничего не должно быть включено.',
    subtitle: 'Терминал распознавания лиц — посещаемость и управление',
    autonomyNote: 'Эта страница НЕ обязана быть открыта для сбора посещаемости. Терминал сам отправляет каждый проход на сервер: если сотрудник прошёл в 07:12, запись придёт с временем 07:12 — неважно, кто и когда открыл панель.',
    connectTitle: 'Подключение к терминалу',
    connectHint: 'Локальный адрес устройства и пароль администратора. Хранятся только на сервере.',
    defaultName: 'Главный вход',
    settings: 'Настройки',
    name: 'Название', host: 'IP-адрес', port: 'Порт', username: 'Логин', password: 'Пароль',
    passwordKeep: 'Оставьте пустым — пароль не изменится',
    nameRequired: 'Введите название', hostRequired: 'Введите IP-адрес', passwordRequired: 'Введите пароль',
    chooseTerminal: 'Терминал',
    loadError: 'Не удалось загрузить данные терминала — попробуйте ещё раз.',
    status: 'Состояние', online: 'На связи', offline: 'Нет связи',
    lastSeen: 'Последняя связь', lastSync: 'Последняя синхронизация',
    peopleCount: 'На устройстве', eventCount: 'События',
    enabled: 'Терминал включён',
    enabledHint: 'Если выключить — данные с устройства не принимаются',
    attendanceEnabled: 'Посещаемость по лицу',
    attendanceEnabledHint: 'Если выключить — события сохраняются, но в посещаемость не пишутся; переходите на ручной режим',
    syncPeople: 'Синхронизировать людей', syncEvents: 'Забрать события', ping: 'Проверить связь',
    syncHint: 'Эти действия выполняет агент внутри школы — он возьмёт задачу из очереди при запуске.',
    taskCancel: 'Отменить',
    taskCancelled: 'Задача отменена',
    agentLastSeen: 'Агент последний раз работал {{time}}',
    agentsTitle: "Агенты (школьные компьютеры)",
    agentsHint: "Агент — небольшая программа, которая передаёт команды панели на терминал. Установите её на 2–3 компьютера в школьной сети: очередь выполнит тот, что включён.",
    agentsEmpty: "Агент ещё не установлен ни на один компьютер — команды будут копиться в очереди.",
    agentComputer: "Компьютер",
    agentState: "Статус",
    agentTerminal: "Терминал",
    agentVersion: "Версия",
    agentSeen: "Последняя связь",
    agentOnline: "Онлайн",
    agentOffline: "Офлайн",
    terminalVisible: "Виден",
    terminalHidden: "Не виден",
    terminalUnknown: "Неизвестно",
    terminalHiddenHint: "Компьютер не в школьной сети или терминал выключен — этот агент не получает команды",
    appDownload: "Скачать SATA Agent (Windows)",
    appVersion: "Версия {{v}}",
    appNotReleased: "Установщик SATA Agent ещё не выпущен — обратитесь к администратору SATA.",
    appLinkError: "Не удалось получить ссылку на установщик.",
    appStep1: "На школьном компьютере (Windows 10/11) скачайте и установите программу.",
    appStep2: "В программе введите ключ агента (ниже) и нажмите «Ulash» (подключить).",
    appStep3: "После этого при запуске программы панель открывается сама. Первый компьютер школы подтверждает администратор SATA, следующие — директор (FACE ID → Устройства).",
    agentKeyWarn: "Ключ агента — это ключ школьного терминала: не отправляйте его за пределы школы.",
    appKeyStaffOnly: "Ключ агента выдаёт директор или администратор.",
    queued: 'В очереди {{count}} задач(и) — они выполнятся при запуске агента в школе. Новый сотрудник попадёт в память терминала после этого.',
    taskQueued: 'Задача поставлена в очередь', taskAlready: 'Такая задача уже в очереди',
    peopleTitle: 'Люди на устройстве', noPeople: 'Ещё не синхронизировано — нажмите «Синхронизировать людей»',
    unlinkedWarn: 'Не связаны с сотрудником ERP: {{count}} — для них посещаемость не пишется',
    employeeNo: 'Номер', deviceName: 'Имя на устройстве', face: 'Лицо', erpUser: 'Сотрудник ERP',
    faceYes: 'есть', faceNo: 'нет', notLinked: 'не связан',
    tasksTitle: 'Задачи',
    noTerminalAsk: 'Терминал ещё не добавлен. Его добавляет директор или администратор.',
    keysTitle: 'Ключи подключения',
    keysHint: 'Первый вводится в настройку «HTTP Listening» устройства, второй — в агент.',
    ingestUrl: 'Адрес событий', agentKey: 'Ключ агента',
    remove: 'Удалить терминал', removed: 'Терминал удалён',
  },
  agent: {
    holat: {
      eskiVersiya: 'Старая версия', aloqaYoq: 'Нет связи', toxtatilgan: 'Остановлен', ishlayapti: 'Работает',
      terminalYoq: 'Терминал не виден', terminalSozlanmagan: 'Терминал не настроен', serverYoq: 'Проблема с сервером',
      kalitXato: 'Неверный ключ', tekshirilmoqda: 'Проверяется',
    },
    davomiylik: { daq: '{{n}} мин', soat: '{{n}} ч', kun: '{{n}} дн' },
    eskiIzoh: 'Не отправляет состояние — обновите SATA Agent до 0.1.3',
    tur: { QAYTA_ISHGA_TUSHIR: 'Перезапустить', LOG: 'Получить лог', YANGILA: 'Обновить сейчас', TOXTAT: 'Остановить', DAVOM: 'Продолжить' },
    buyruqHolat: { KUTILMOQDA: 'Ожидает', YUBORILDI: 'Отправлена', BAJARILDI: 'Выполнена', XATO: 'Ошибка', MUDDATI_OTDI: 'Истекла' },
    maktab: 'Школа', terminal: 'Терминал', versiya: 'Версия', os: 'Система', ip: 'IP',
    ishgaTushgan: 'Запущен', oxirgiAloqa: 'Последняя связь', oxirgiXato: 'Последняя ошибка',
    band: 'Выполняет команду',
    buyruqlar: 'Команды',
    yangilangIzoh: 'Приложение на этом компьютере устарело и не принимает команды из панели. Обновите SATA Agent до 0.1.3.',
    faqatStaff: 'Команды отдаёт директор или администратор.',
    maktabsiz: 'Терминал не привязан к школе — команды этому компьютеру недоступны.',
    tasdiqSarlavha: 'Подтвердите команду',
    tasdiqQayta: 'Приложение перезапустится: дождётся окончания текущей задачи (до 1 минуты).',
    tasdiqToxtat: 'Посещаемость и команды FACE ID на этом компьютере выполняться не будут.',
    buyruqYuborildi: 'Команда отправлена — компьютер получит её в течение 15 секунд',
    xTakror: 'Предыдущая команда ещё не выполнена — дождитесь результата.',
    vazifalar: 'Последние задачи', vazifaYoq: 'Этот компьютер ещё не выполнял задачи',
    tarix: 'История команд', tarixYoq: 'Команд ещё не было',
    colTur: 'Тип', colHolat: 'Статус', colVaqt: 'Время', colKim: 'Кто', colNatija: 'Результат', colMaktab: 'Школа',
    log: 'Лог', logYoq: 'Лог ещё не получен', logBosh: 'Лог пуст', logKutilmoqda: 'Ожидаем лог — компьютер получит команду в течение 15 секунд…',
    nusxaOl: 'Копировать', nusxaOlindi: 'Скопировано',
    yuklanmadi: 'Не удалось загрузить данные компьютера — они не показываются, чтобы не выводить устаревшее состояние.',
    qatorniBosing: 'Нажмите на строку — состояние, задачи, лог и команды',
    sahifaIzoh: 'Компьютеры всех школ, замеченные за последние 30 дней. Проблемные — сверху.',
    jami: 'Всего: {{n}}', muammoli: 'Проблемных: {{n}}',
    bosh: 'За последние 30 дней не замечено ни одного компьютера',
    royxatYuklanmadi: 'Не удалось загрузить список компьютеров — он не показывается, чтобы не выводить устаревшие состояния.',
    qaytaUrinish: 'Повторить',
  },
  staffAttendance: {
    title: 'Посещаемость сотрудников', date: 'Дата', staff: 'Сотрудник', role: 'Должность',
    in: 'Пришёл', out: 'Ушёл', markIn: 'Пришёл', markOut: 'Ушёл', done: 'Завершено',
    manual: 'Вручную',
    summary: 'пришли: {{kelgan}} / {{jami}}',
    searchPlaceholder: 'Имя или должность...',
    undoOut: 'Отменить уход (время прихода останется)',
    restDay: 'Выходной день — посещаемость не отмечается',
    undone: 'Уход отменён',
    found: 'найдено {{topilgan}} из {{jami}}',
    empty: 'Активных сотрудников нет',
    addTitle: 'Отметить посещаемость', editTitle: 'Изменить посещаемость',
    markWithTime: 'Отметить со временем', edit: 'Изменить',
    saved: 'Сохранено', deleted: 'Запись удалена', delete: 'Удалить', deleteConfirm: 'Точно удалить?',
    outBeforeIn: 'Уход должен быть позже прихода',
    outHint: 'Если время ухода пустое — сотрудник считается ещё на работе.',
    cellHint: 'Нажмите на ячейку, чтобы отметить или исправить приход/уход за этот день',
    range: 'Период', thisWeek: 'Эта неделя', thisMonth: 'Этот месяц', lastMonth: 'Прошлый месяц',
    modeDay: 'По дням', modeMonth: 'Отчёт', month: 'Месяц',
    daysIn: 'Пришёл (дн.)', daysOut: 'Не пришёл', hours: 'Часы',
    monthSummary: 'рабочих дней: {{ish}}, прошло: {{otgan}}',
    legend: 'Зелёный — пришёл, красный — не пришёл в рабочий день, серый — выходной, • — ещё не ушёл',
    faceNote: 'Когда терминал распознавания лиц работает, записи появляются здесь сами. Ручная отметка — для дней, когда терминал недоступен: обе записи идут в одну таблицу и не конфликтуют.',
  },
  audit: {
    pageDesc: 'Кто, что, когда и с какого адреса изменил',
    logTitle: 'Журнал действий',
    blockedTitle: 'Заблокированные адреса',
    blockedHint: 'Запросы с этих адресов отклоняются',
    blockedEmpty: 'Заблокированных адресов нет',
    blockAdd: 'Заблокировать адрес',
    blockWarn: 'Внимание: вся школа может быть за одним внешним адресом — блокировка отключит всех. На терминал посещаемости не влияет.',
    block: 'Заблокировать',
    unblock: 'Разблокировать',
    blocked: 'Адрес заблокирован',
    unblocked: 'Блокировка снята',
    ip: 'Адрес (IP)',
    reason: 'Причина',
    until: 'До',
    forever: 'Бессрочно',
    hits: 'Отклонено',
    auto: 'Автоматически',
    hours: 'Сколько часов',
    hoursHint: '0 или пусто — бессрочно',
    when: 'Время',
    who: 'Кто',
    school: 'Школа',
    what: 'Действие',
    status: 'Результат',
    path: 'Путь',
    method: 'Тип',
    from: 'С',
    to: 'По',
    empty: 'Записей не найдено',
    anon: 'Неизвестно',
    last24: 'За 24 часа',
    actions: 'изменений',
    rejected: 'Отклонено',
    rejectedHint: 'ошибки и заблокированные попытки',
    topAccount: 'Самый активный аккаунт',
    status2: 'Успешно (2xx)',
    status4: 'Отклонено (4xx)',
    status5: 'Ошибка сервера (5xx)',
    allSchools: 'Все школы',
    noTenant: 'Платформа (без школы)',
  },
  lessonTimes: {
    section: 'Время уроков',
    sectionDesc: 'Часы в расписании считаются из этих настроек',
    start: 'Первый урок',
    duration: 'Урок (мин)',
    break: 'Перемена (мин)',
    note: 'n-й урок = начало + (n-1) × (урок + перемена)',
  },
  workDays: {
    section: 'Рабочие дни и праздники',
    sectionDesc: 'Учебные дни и дни посещаемости. Дневная ставка оклада берётся из «Правило расчёта зарплаты → Рабочие дни для зарплаты»',
    mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс',
    thisMonth: 'В {{oy}}: {{kun}} рабочих дней',
    holidaysExcluded: 'исключено праздников: {{n}}',
    holidays: 'Праздники и выходные даты',
    holidaysEmpty: 'В {{yil}} году отмеченных дат нет',
    date: 'Дата',
    name: 'Название',
    namePlaceholder: 'Навруз, День независимости...',
    note: 'Эта настройка влияет на:',
    affects: 'посещаемость учеников и сотрудников',
  },
  backup: {
    connectedTo: 'Подключён чат:',
    hour: 'Время', hourHelp: 'По Ташкенту',
    exactAt: 'Точное время: {{time}}',
    tokenConnected: 'Бот подключён',
    tokenReplace: 'Подключить другого бота',
    section: 'Резервная копия',
    openHint: 'Ежедневная копия через Telegram — откройте для настройки',
    on: 'Включено',
    warning: 'ВНИМАНИЕ: при неверном chat_id ВСЕ данные школы уйдут в чужой канал. Тщательно проверьте канал и бота.',
    token: 'Токен бота', tokenSet: 'задан', tokenNone: 'не задан',
    tokenKeep: 'Оставьте пустым — токен не изменится',
    tokenHelp: 'Получается у @BotFather. Бот должен быть админом канала.',
    tokenBad: 'Неверный формат токена (123456:ABC-...)',
    chatId: 'Chat ID', chatHelp: 'Номер канала (-100...) или @имя_канала',
    chatBad: 'Должно быть число или @канал',
    daily: 'Каждый день', dailyHint: 'Вечером по ташкентскому времени',
    testSend: 'Отправить сейчас', sent: 'Отправлено',
    remove: 'Удалить настройку', removed: 'Настройка резервной копии удалена',
    lastAt: 'Последняя',
    scopeNote: 'В файле ТОЛЬКО данные этой школы — пароли и ключи не попадают. Имя:',
  },
  export: {
    tooltip: 'Выгрузить ВЕСЬ список по текущему фильтру в Excel',
    empty: 'Нет данных для выгрузки',
    done: 'Выгружено строк: {{rows}}',
    doneSheets: '{{rows}} строк, разбито на {{sheets}} листов (по кварталам)',
  },
  pager: {
    range: '{{from}}–{{to}} из {{total}}',
    perPage: 'Строк на странице', page: 'стр.',
  },
  parentsPage: {
      add: 'Добавить родителя', addHint: 'После создания откроется карточка — детей привязываете там.',
    searchPlaceholder: 'Имя или телефон...', sortPremium: 'Срок премиума', regular: 'Обычный', giftsSentReceived: 'Подарки (отпр./получ.)',
  },
  announcementsPage: {
    bodyRequired: 'Введите текст', selectScreen: 'Выберите экран', fullUrlRequired: 'Введите полный URL (https://...)', posted: 'Объявление опубликовано',
    searchPlaceholder: 'Заголовок или текст...', sortNew: 'Новые объявления', audienceTo: 'Кому', classNamed: 'Класс: {{name}}', appNamed: 'Приложение: {{screen}}',
    titleUz: 'Заголовок (узбекский)', bodyUz: 'Текст (узбекский)', translations: 'Переводы (необязательно — ru/en)',
    titleRu: 'Заголовок (русский)', bodyRu: 'Текст (русский)', titleEn: 'Заголовок (английский)', bodyEn: 'Текст (английский)',
    whichClass: 'Какой класс', linkOptional: 'Ссылка (необязательно)', linkNone: 'Без ссылки', linkApp: 'Экран внутри приложения', linkUrl: 'Внешняя ссылка',
    appScreenLabel: 'Экран приложения', selectScreenPlaceholder: 'Выберите экран', url: 'URL', post: 'Опубликовать',
    class: 'Класс',
  },
  supportPage: {
    back: 'Назад',
    title: 'Поддержка — чат с пользователями', searchPlaceholder: 'Имя или телефон...', noMessages: 'Нет сообщений',
    emptyDesc: 'Здесь появятся сообщения от пользователей.', youPrefix: 'Вы: ', selectThread: 'Выберите чат', replyPlaceholder: 'Напишите ответ...',
    unreadOnly: 'Только непрочитанные',
    noMatch: 'Диалоги не найдены', noMatchDesc: 'Измените поиск или фильтр.',
  },
  premiumPage: {
    title: 'Премиум-подарки', subManage: 'управление подпиской на странице «Родители»', searchPlaceholder: 'Отправитель или получатель...', sortMonthsDesc: 'Срок (больше)',
    anonymity: 'Анонимность', anonymous: 'Анонимно', open: 'Открыто', from: 'От кого', to: 'Кому', duration: 'Срок', greeting: 'Поздравление', sentAnon: 'отправлено анонимно', months: '{{n}} мес.',
    emptyTitle: 'Подарков нет', emptyDesc: 'Здесь появятся Премиум-подарки, которые родители дарят друг другу.',
    errorTitle: 'Не удалось загрузить данные', errorDesc: 'Нет доступа к списку Премиум-подарков или сервер не ответил.',
  },
  attPage: {
    tabStudents: 'Ученики', tabStaff: 'Сотрудники',
    saveError: 'Ошибка сохранения — попробуйте ещё раз', searchStudent: 'Поиск ученика', namePlaceholder: 'Имя...',
    selectClassToMark: 'Выберите класс, чтобы отметить посещаемость', selectDateToMark: 'Выберите дату', noStudentsInClass: 'В этом классе нет учеников', saved: 'Сохранено',
    restDay: 'Выходной день — посещаемость не отмечается',
    loadError: 'Не удалось загрузить посещаемость — список скрыт, так как статусы могут быть неверными.', retry: 'Повторить',
  },
  gradesPage: {
    selectStudent: 'Выберите ученика', selectSubject: 'Выберите предмет', gradeRange: 'Оценка от 1 до 5', gradeAdded: 'Оценка выставлена',
    addGrade: 'Поставить оценку', searchPlaceholder: 'Имя ученика...', sortValueDesc: 'Оценка (высокая)', sortValueAsc: 'Оценка (низкая)',
    selectClassToView: 'Выберите класс, чтобы посмотреть оценки', noGrades: 'Оценок нет', grade: 'Оценка', term: 'Четверть', gradeValue: 'Оценка (1-5)',
    period: 'Период', periodAll: 'Все', periodDay: 'День', periodWeek: 'Неделя', periodMonth: 'Месяц', allSubjects: 'Все предметы',
    student: 'Ученик', dateFrom: 'Дата с', dateTo: 'Дата по', termN: '{{n}}-я четверть',
    teacher: 'Учитель',
    actions: 'Действия', edit: 'Изменить оценку', editSaved: 'Оценка обновлена',
    deleteGrade: 'Удалить оценку', deleted: 'Оценка удалена',
    comment: 'Комментарий', date: 'Дата', selectTerm: 'Выберите четверть',
    noTermSet: 'Не привязана к четверти',
    onlyOwnGrade: 'Эту оценку поставил другой учитель — изменить нельзя',
    termsError: 'Список четвертей не загрузился — показан прежний список',
    termsHint: 'Четверти настраиваются в разделе «Учебный год и четверти»',
  },
  terms: {
    title: 'Учебный год и четверти',
    subtitle: 'Четверть привязана к учебному году — при выставлении оценки четверть определяется по дате автоматически.',
    tabYears: 'Учебные годы', tabTerms: 'Четверти', retry: 'Повторить',
    yearsTitle: 'Учебные годы', addYear: 'Новый учебный год', editYear: 'Изменить учебный год',
    yearName: 'Название', yearNameHint: 'Например: 2026-2027', yearStart: 'Начало', yearEnd: 'Окончание',
    yearColumn: 'Учебный год', selectYear: 'Выберите учебный год',
    makeActive: 'Сделать активным', active: 'Активный',
    activeHint: 'Активным может быть только ОДИН учебный год — при активации другого текущий отключается автоматически.',
    nameRequired: 'Введите название',
    yearCreated: 'Учебный год добавлен', yearUpdated: 'Учебный год обновлён', yearDeleted: 'Учебный год удалён',
    yearActivated: '{{name}} — теперь активный учебный год',
    yearsEmpty: 'Учебных годов нет',
    yearsEmptyDesc: 'Добавьте первый учебный год — к нему привяжутся классы, четверти и электронный журнал.',
    yearsLoadError: 'Не удалось загрузить учебные годы',
    yearInUse: 'К этому учебному году привязаны классы — сначала перенесите или удалите их.',
    noActiveYear: 'Активный учебный год не выбран',
    noActiveYearDesc: 'Журнал, четверти и отчёты работают по активному году — выберите его кнопкой «Сделать активным».',
    activeNoClasses: 'В активном учебном году ({{name}}) нет ни одного класса',
    activeNoClassesDesc: 'Классы могли остаться в другом учебном году. Добавьте класс в разделе «Классы» или сделайте активным тот год, где они есть.',
    goToClasses: 'Перейти к классам',
    termsTitle: 'Четверти', addTerm: 'Новая четверть', editTerm: 'Изменить четверть',
    termName: 'Название четверти', termIndex: 'Порядок', termIndexHint: 'От 1 до 4 — для сортировки и итогов четверти',
    termStart: 'Начало', termEnd: 'Окончание', currentTerm: 'Текущая',
    termCreated: 'Четверть добавлена', termUpdated: 'Четверть обновлена', termDeleted: 'Четверть удалена',
    termsEmpty: 'Четверти не добавлены',
    termsEmptyDesc: 'Без четвертей не работают электронный журнал, итоги четверти и отчёт по оценкам. Начните с кнопки «Новая четверть».',
    termsLoadError: 'Не удалось загрузить четверти',
    termsNeedYear: 'Сначала добавьте учебный год — четверть привязывается к году.',
    termOverlap: 'Даты четверти пересекаются с другой четвертью либо этот порядок уже занят.',
    termInUse: 'К этой четверти привязаны оценки — сначала перенесите или удалите их.',
    datesRequired: 'Выберите даты начала и окончания',
    endAfterStart: 'Дата окончания должна быть позже даты начала',
  },
  journal: {
    periodAvg: 'Средний за период',
    periodGrade: 'Оценка за период',
    period: 'Период',
    period7: 'Последние 7 дней',
    period14: 'Последние 14 дней',
    period30: 'Последние 30 дней',
    periodTerm: 'Вся четверть',
    periodCustom: 'Выбрать даты',
    showAll: 'Показать всю четверть',
    dateFrom: 'С даты',
    dateTo: 'По дату',
    dateFilterNote: 'Фильтр по дате меняет только отображение — средний балл и предложенная оценка считаются за всю четверть.',
    pageTitle: 'Электронный журнал',
    pageSubtitle: 'Выберите класс, предмет и четверть — журнал, массовые оценки, итоги четверти и отчёт работают по этому срезу.',
    title: 'Журнал',
    tabMatrix: 'Журнал', tabBulk: 'Массовые оценки', tabTerm: 'Итоги четверти', tabReport: 'Отчёт',
    student: 'Ученик', avg: 'Средняя', termGrade: 'Оценка за четверть',
    selectFilters: 'Выберите класс, предмет и четверть',
    scrollHint: 'Таблица широкая — прокрутите её по горизонтали, чтобы увидеть даты.',
    loadError: 'Не удалось загрузить журнал',
    empty: 'В этой четверти по этому предмету оценок нет',
    emptyDesc: 'Поставьте оценки всему классу в разделе «Массовые оценки» или нажмите на ячейку журнала.',
    noStudents: 'В этом классе нет учеников',
    noStudentsDesc: 'Сначала добавьте ученика в разделе «Ученики» и привяжите его к этому классу.',
    cellEmpty: 'В этот день оценок нет',
    addGrade: 'Добавить оценку',
    termNotSet: 'Не выставлена',
    suggestion: 'Предложение системы: {{n}}',
    noTerms: 'Четверти не настроены',
    noTermsDesc: 'Электронный журнал без четвертей не работает — сначала заведите четверти учебного года.',
    goToTerms: 'Настроить четверти',
    setupNoClasses: 'Классов нет',
    setupNoClassesDesc: 'Журнал открывается по классу — сначала добавьте класс.',
    setupNoSubjects: 'Предметов нет',
    setupNoSubjectsDesc: 'Оценка ставится по предмету — сначала добавьте предмет.',
    goToSubjects: 'Перейти к предметам',
    goToYears: 'Добавить учебный год', goToClasses: 'Перейти к классам',
    selectFiltersDesc: 'Выберите класс и предмет в панели выше — журнал откроется по этому срезу.',
    termGradeStale: 'Оценка за четверть зафиксирована; после неё добавлены новые оценки — текущее предложение: {{n}}',
    askAdmin: 'У вас нет доступа к этому разделу — попросите администратора настроить.',
    stepYears: '1. Учебный год', stepTerms: '2. Четверти', stepClasses: '3. Классы', stepSubjects: '4. Предметы',
    setupNoYears: 'Учебных годов нет',
    setupNoYearsDesc: 'Всё начинается с учебного года — четверти, классы и журнал привязаны к нему.',
    setupNoTerms: 'Четвертей нет',
    setupNoTermsDesc: 'Оценка привязывается к четверти — заведите четверти учебного года.',
  },
  bulkGrades: {
    title: 'Массовое выставление оценок',
    desc: 'Выберите дату и заполните весь список на одном экране. Ученикам с пустым полем оценка не ставится.',
    date: 'Дата', value: 'Оценка', comment: 'Комментарий', commentPlaceholder: 'Необязательный комментарий',
    save: 'Сохранить оценки',
    saved: 'Сохранено оценок: {{saved}}',
    savedSkipped: 'Сохранено оценок: {{saved}}, пропущено: {{skipped}}',
    nothingToSave: 'Отметьте хотя бы одну оценку',
    selectFilters: 'Сначала выберите класс и предмет',
    filled: 'Заполнено: {{n}}', fillAll: 'Всем {{n}}',
    clear: 'Очистить', clearOne: 'Убрать оценку',
    loadError: 'Не удалось загрузить список учеников',
    appendHint: 'Сохранение ДОБАВЛЯЕТ оценки, а не заменяет прежние — в один день может быть несколько оценок. Двойное сохранение создаст две оценки.',
  },
  termSummary: {
    title: 'Итоги четверти',
    desc: 'Система считает среднее по текущим оценкам и ПРЕДЛАГАЕТ значение — итоговую оценку ставит учитель, и она сохраняется зафиксированной.',
    gradeCount: 'Количество оценок', suggested: 'Предложение', finalGrade: 'Оценка за четверть',
    confirm: 'Подтвердить', confirmAll: 'Применить предложение ко всем',
    saved: 'Оценки за четверть сохранены',
    cancelGrade: 'Отменить оценку за четверть', cancelled: 'Оценка за четверть отменена',
    changed: 'Отличается от предложения', changedHint: 'Система предлагала {{n}}',
    alreadySet: 'Выставлена', pending: 'Не подтверждена',
    noSuggestion: 'Предложения нет — в этой четверти текущих оценок не было',
    nothingToSave: 'Отметьте хотя бы одну оценку за четверть',
    empty: 'Данных нет',
    emptyDesc: 'По выбранному классу, предмету и четверти учеников не найдено.',
    loadError: 'Не удалось загрузить оценки за четверть',
    needTerm: 'Для итогов четверти нужно выбрать класс, предмет и четверть — все три.',
    notAssigned: 'Этот предмет вам не назначен',
    notAssignedDesc: 'Оценку за четверть можно ставить только по назначенному вам предмету — быть классным руководителем недостаточно. Попросите администратора добавить назначение в разделе «Расписание и назначения».',
    stale: 'Предложение устарело',
    staleHint: 'При записи предложение было {{old}}, сейчас {{now}} — после оценки за четверть добавлены новые оценки.',
  },
  gradeReport: {
    title: 'Отчёт по оценкам',
    gradeCount: 'Количество оценок', avg: 'Средняя', termGrade: 'Оценка за четверть',
    summaryAvg: 'Общее среднее', graded: 'Оценено', gradedHint: 'С оценкой за четверть / всего учеников',
    excellent: 'Отлично (5)', good: 'Хорошо (4)', satisfactory: 'Удовлетворительно (3)', poor: 'Неудовлетворительно (2)',
    empty: 'Данных для отчёта нет',
    emptyDesc: 'По выбранному классу, предмету и четверти оценок не найдено.',
    loadError: 'Не удалось загрузить отчёт',
    summaryAvgHint: 'По оценкам за четверть (не по текущим)',
  },
  rankingPage: {
    scopeClass: 'Внутри класса', scopeParallel: 'Параллель', scopeSchool: 'Вся школа',
    schoolHint: 'Класс не выбран — показан рейтинг по всей школе.',
    scopeNeedsClass: 'Для охвата «Внутри класса» и «Параллель» сначала выберите класс.',
    periodInfo: 'Период расчёта: последние {{days}} дн.',
    weightsInfo: 'Предметы {{grades}}% · Посещаемость {{attendance}}% · Поведение {{behavior}}% · Тесты {{exams}}% · Домашние задания {{homework}}%',
    colRank: '#', colStudent: 'Ф.И.О.', colClass: 'Класс', colBall: 'Итоговый балл',
    colGrades: 'Предметы', colAttendance: 'Посещаемость', colBehavior: 'Поведение', colExams: 'Тесты', colHomework: 'Домашние задания',
    colAdjust: 'Корректировка',
    tipCount: 'Записей: {{count}}', tipAvg: 'Среднее: {{avg}}', tipNoData: 'Нет данных по этому направлению',
    avgGrade: 'Средняя оценка', gradeCount: 'Количество оценок',
    empty: 'Нет данных для рейтинга', totalStudents: 'Всего учеников: {{count}}',
    settings: 'Настройки', settingsTitle: 'Настройки рейтинга',
    weightGrades: 'Вес предметов', weightAttendance: 'Вес посещаемости', weightBehavior: 'Вес поведения',
    weightExams: 'Вес тестов', weightHomework: 'Вес домашних заданий', periodDays: 'Период расчёта (дней)',
    weightsSum: 'Сумма весов: {{sum}}',
    normalizeHint: 'Сумма не обязана быть равной 100 — система нормализует веса автоматически.',
    settingsSaved: 'Настройки сохранены',
    adjust: 'Корректировка', adjustTitle: 'Ручная корректировка (бонус / штраф)',
    delta: 'Баллы (+ бонус / − штраф)', deltaHint: 'От -100 до 100, не может быть 0',
    deltaRequired: 'Баллы должны быть целым числом, отличным от 0 (-100..100)',
    reason: 'Причина', reasonPlaceholder: 'Например: победитель олимпиады',
    adjustAdded: 'Корректировка добавлена', adjustDeleted: 'Корректировка удалена',
    adjustList: 'Текущие корректировки', noAdjust: 'Корректировок нет',
    search: 'Имя ученика...', period7: 'Последние 7 дней', period30: 'Последние 30 дней', period90: 'Последние 90 дней', limitWarning: 'Показаны только первые {{n}} учеников', showLimit: 'Сколько показать',
    shownOf: 'Показано {{shown}} / {{total}}',
    saveError: 'Ошибка сохранения — попробуйте ещё раз',
  },
  behaviorPage: {
    tabCriteria: 'Критерии', tabGrade: 'Выставить оценку',
    addCriterion: 'Добавить критерий', editCriterion: 'Изменить критерий',
    criterionName: 'Название критерия', criterionNamePlaceholder: 'Например: активно работал на уроке',
    points: 'Баллы', pointsHint: 'От -10 до 10 (отрицательные — штраф)', order: 'Порядок', isActive: 'Активен',
    active: 'Активен', inactive: 'В архиве',
    nameRequired: 'Введите название критерия', pointsRange: 'Баллы должны быть от -10 до 10',
    criterionSaved: 'Критерий сохранён', criterionDeleted: 'Критерий удалён',
    criterionArchived: 'По критерию есть оценки — он не удалён, а перемещён в архив',
    noCriteria: 'Критериев нет', showArchived: 'Показать архив',
    readOnlyHint: 'Критерии редактирует только руководство.',
    selectClass: 'Класс', selectClassFirst: 'Сначала выберите класс',
    students: 'Ученики', selectStudents: 'Выберите учеников',
    selectAll: 'Выбрать всех', clearAll: 'Очистить выбор',
    criterion: 'Критерий', value: 'Баллы (необязательно)',
    valueHint: 'Если оставить пустым, применяются баллы критерия',
    note: 'Заметка', date: 'Дата', submit: 'Выставить', saved: 'Оценка поведения выставлена',
    studentsRequired: 'Выберите хотя бы одного ученика', criterionRequired: 'Укажите критерий или баллы',
    recent: 'Последние оценки', noRecords: 'Оценок нет',
    colStudent: 'Ученик', colClass: 'Класс', colCriterion: 'Критерий', colValue: 'Баллы', colNote: 'Заметка', colDate: 'Дата', colBy: 'Кто выставил',
    deleted: 'Оценка удалена', noCriterion: 'Без критерия',
    student: 'Ученик', positive: 'Поощрение (+)', negative: 'Штраф (−)', dateFrom: 'Дата с', dateTo: 'Дата по', sortDateDesc: 'Дата (новые)', sortValueDesc: 'Баллы (больше)',
    sortDateAsc: 'Дата (старые)', sortValueAsc: 'Баллы (меньше)', sortOrder: 'По порядку',
    allClasses: 'Все классы', allStudents: 'Все ученики', allCriteria: 'Все критерии', allSigns: 'Плюс | Минус', dateRange: 'Период дат',
    saveError: 'Ошибка сохранения — попробуйте ещё раз',
  },
  examsPage: {
    add: 'Добавить экзамен', edit: 'Изменить экзамен',
    examTitle: 'Название экзамена', titlePlaceholder: 'Например: Английский — тест 1-й недели',
    subject: 'Предмет', class: 'Класс', date: 'Дата', maxScore: 'Максимальный балл',
    allSchool: 'Вся школа', allClasses: 'Все классы', allSubjects: 'Все предметы',
    scoresCount: 'Внесено баллов',
    titleRequired: 'Введите название экзамена', maxScoreRange: 'Максимальный балл от 1 до 1000',
    examSaved: 'Экзамен сохранён', examDeleted: 'Экзамен удалён',
    noExams: 'Экзаменов нет',
    enterScores: 'Внести баллы', scoresTitle: 'Баллы теста',
    selectClassForScores: 'Выберите класс, чтобы внести баллы',
    student: 'Ученик', score: 'Балл', comment: 'Комментарий',
    noStudents: 'В этом классе нет учеников',
    scoresSaved: 'Баллы сохранены ({{saved}})',
    noPermission: 'Баллы тестовых экзаменов вносит только руководство или преподаватель-экзаменатор.',
    scoreRange: 'Балл от 0 до {{max}}',
    testTeacher: 'Преподаватель-экзаменатор',
    testTeacherHint: 'Этот преподаватель может вносить баллы тестовых экзаменов',
    testTeacherUpdated: 'Сохранено',
    searchPlaceholder: 'Название экзамена...', sortDateDesc: 'Дата (новые)', sortDateAsc: 'Дата (старые)',
    allExams: 'Все экзамены', ungraded: 'Баллы не внесены', dateRange: 'Период дат', searchStudent: 'Поиск ученика...',
    saveError: 'Ошибка сохранения — попробуйте ещё раз',
    tabList: 'Экзамены', tabHistory: 'История',
    classes: 'Классы', selectClasses: 'Выберите классы',
    classesHint: 'Если оставить пустым — общешкольный экзамен',
    teacher: 'Экзаменатор', allTeachers: 'Все преподаватели', noTeacher: 'Не назначен',
    myExams: 'Мои экзамены',
    tooManyClasses: 'Выберите не более {{max}} классов',
  },
  examHistory: {
    exams: 'Экзамены', scores: 'Внесено баллов', avgPercent: 'Средний результат',
    empty: 'В истории нет экзаменов', scored: 'Оценено', result: 'Результат',
    best: 'Лучший', worst: 'Худший', noScores: 'Баллы не внесены',
    enteredBy: 'Кто внёс', editedBy: 'Кто изменил',
    openAudit: 'История внесения баллов', auditTitle: 'Аудит внесения баллов',
    notEdited: 'Не изменялось',
    sortCreatedDesc: 'Создан (новые)', sortUpdatedDesc: 'Изменён (новые)',
    sortEnteredDesc: 'Внесён (новые)', sortScoreDesc: 'Балл (большой)', sortScoreAsc: 'Балл (малый)',
  },
  schedulePage: {
    lessonNo: 'Какой урок',
    lessonNoHint: 'Время считается автоматически — из настроек расписания',
    selectSubject: 'Выберите предмет', selectTeacher: 'Выберите учителя', lessonAdded: 'Урок добавлен', assigned: 'Назначено',
    selectClassToStart: 'Выберите класс, чтобы начать', scheduleTab: 'Расписание', assignTab: 'Назначение учителя', assignTitle: 'Назначить учителя',
    addLesson: 'Добавить урок', emptySchedule: 'Расписание пусто', day: 'День', time: 'Время', room: 'Кабинет', lesson: 'урок', noAssignments: 'Назначений нет',
    startTime: 'Начало', endTime: 'Конец', assign: 'Назначить',
    allDays: 'Все', emptyDay: 'В этот день уроков нет',
    planningNotice: '{{year}} — не активный учебный год: расписание вводится заранее для этого года и не влияет на текущее.',
    noClassesInYear: 'В этом учебном году пока нет классов — сначала создайте их на странице «Классы».',
  },
  classesPage: {
    searchPlaceholder: 'Название класса...', sortNameAsc: 'Название (А-Я)', sortNameDesc: 'Название (Я-А)', sortNewest: 'Новые классы', searchTeacher: 'Поиск учителя...',
    academicYear: 'Учебный год', sortStudentsDesc: 'Число учеников (больше)',
  },
  subjectsPage: {
    searchPlaceholder: 'Название или код предмета...', sortNameAsc: 'Название (А-Я)', sortNameDesc: 'Название (Я-А)', sortNewest: 'Недавно добавленные',
    nameUz: 'Название предмета (узбекский)', nameRu: 'Название на русском', nameEn: 'Название на английском',
    icon: 'Иконка', iconAuto: 'По умолчанию (по названию предмета)',
    iconHint: 'Если не выбрать — иконка подберётся автоматически по названию предмета',
  },
  subjectIcon: {
    calculator: 'Калькулятор', atom: 'Атом', flask: 'Колба', dna: 'ДНК', globe: 'Глобус',
    book: 'Книга', language: 'Язык', code: 'Код', palette: 'Палитра', music: 'Музыка',
    dumbbell: 'Гантель', hammer: 'Молоток', brain: 'Мозг', chart: 'Диаграмма', map: 'Карта',
    history: 'История', shield: 'Щит', heart: 'Сердце', leaf: 'Лист', star: 'Звезда',
  },
  salaryType: { FIXED: 'Фикс. оклад', PER_LESSON: 'За урок', HOURLY: 'Почасовая' },
  legal: {
    section: 'Правовая информация', back: 'Назад', updated: 'Последнее обновление', more: 'Подробнее', accept: 'Понятно',
    terms: 'Условия использования', privacy: 'Политика конфиденциальности', cookies: 'Политика cookie',
    cookieTitle: 'Cookie и локальное хранилище',
    cookieText: 'Мы используем хранилище браузера (необходимое), чтобы вы оставались в системе. Рекламные и трекинговые cookie не используются.',
  },
  deleteAccount: {
    navLabel: 'Удаление аккаунта',
    title: '{{app}} — удаление аккаунта',
    developer: 'Разработчик: {{dev}}',
    intro: 'На этой странице можно запросить удаление вашего аккаунта (родителя или учителя) в приложении {{app}}. Логин и пароль вам выдала школа.',
    inAppTitle: 'Как удалить в приложении',
    inAppSteps: 'Откройте приложение {{app}} → Профиль → Аккаунт → «Удалить аккаунт» → введите пароль и подтвердите.',
    formTitle: 'Запрос без приложения',
    formHint: 'Если приложение удалено или не открывается — отправьте запрос отсюда с вашим логином и паролем. Пароль нужен, чтобы подтвердить, что аккаунт ваш.',
    login: 'Логин',
    password: 'Пароль',
    reason: 'Причина (необязательно)',
    reasonPlaceholder: 'Почему вы хотите удалить аккаунт? Увидит администрация школы',
    confirm: 'Понимаю: после отправки запроса войти в аккаунт будет нельзя',
    submit: 'Отправить запрос на удаление',
    required: 'Обязательное поле',
    confirmRequired: 'Подтвердите',
    successTitle: 'Запрос принят',
    successText: 'Ваш аккаунт закрыт. Администрация школы завершит запрос в течение 30 дней, и ваши данные будут удалены, как указано ниже.',
    errWrong: 'Неверный логин или пароль',
    errRole: 'Для этого типа аккаунта (сотрудник школы) запрос на удаление отправляется через администрацию школы.',
    errLimit: 'Слишком много попыток. Повторите через 15 минут.',
    errGeneric: 'Не удалось отправить. Проверьте интернет и попробуйте снова.',
    timingTitle: 'Сроки',
    timingText: 'Сразу после отправки запроса аккаунт закрывается: войти нельзя, уведомления прекращаются. Администрация школы завершает запрос в течение 30 дней. Если школа отклонит запрос с указанием причины, аккаунт вернётся в прежнее состояние, а вы получите сообщение с причиной.',
    deletedTitle: 'Что удаляется',
    deletedItems: [
      'Логин и пароль',
      'Имя и фамилия, телефон, пол, дата рождения, Telegram ID',
      'Фото профиля',
      'Дополнительные телефоны и адреса',
      'Токены push-уведомлений и уведомления в приложении',
      'Переписка в чате поддержки',
    ],
    keptTitle: 'Что остаётся как записи школы',
    keptItems: [
      'Оценки, посещаемость, платежи и договоры вашего ребёнка (с данными подписанного договора) и контакт родителя в карточке ученика',
      'Если вы учитель: выставленные оценки, домашние задания, расписание, записи о зарплате и рабочем времени',
      'В этих записях вместо вашего имени будет «O‘chirilgan foydalanuvchi» (удалённый пользователь)',
      'Журнал безопасности (аудит) — удаляется автоматически через 90 дней; резервные копии — до их очистки',
      'Запись сотрудника в терминале FACE ID — её отдельно удаляет администрация школы',
    ],
    childNote: 'Чтобы удалить или исправить данные вашего ребёнка (ученика), обратитесь в администрацию школы.',
    contactTitle: 'Контакты',
    contactText: 'По вопросам: {{email}} или администрация школы.',
    privacyLink: 'Политика конфиденциальности',
  },
  deletionRequests: {
    title: 'Запросы на удаление аккаунта',
    subtitle: 'От родителей и учителей — завершите в течение 30 дней',
    filterNew: 'Новые ({{n}})',
    filterAll: 'Все',
    empty: 'Запросов нет',
    loadError: 'Не удалось загрузить список',
    retry: 'Повторить',
    status: { NEW: 'Новый', DONE: 'Выполнен', REJECTED: 'Отклонён' },
    source: { APP: 'Из приложения', WEB: 'С веб-страницы' },
    requested: 'Запрошено: {{date}}',
    processed: 'Завершено: {{date}}{{by}}',
    reason: 'Причина: {{text}}',
    rejectReasonShown: 'Причина отказа: {{text}}',
    done: 'Удалить',
    reject: 'Отклонить',
    confirmDoneTitle: 'Удаление аккаунта',
    confirmDoneText: 'Аккаунт {{name}} будет анонимизирован: удалятся логин, пароль, имя, телефон, фото, уведомления и чат поддержки. Записи школы (оценки, посещаемость, платежи, договоры, зарплата) останутся с именем «O‘chirilgan foydalanuvchi» (удалённый пользователь). Действие необратимо.',
    confirmDoneOk: 'Да, удалить',
    rejectTitle: 'Отклонить запрос',
    rejectText: 'Аккаунт {{name}} вернётся в состояние до запроса, и пользователь снова сможет войти. Причина будет видна пользователю в уведомлении.',
    rejectReason: 'Причина отказа (необязательно)',
    rejectOk: 'Отклонить',
    cancel: 'Отмена',
    doneOkMsg: 'Аккаунт удалён (анонимизирован)',
    rejectOkMsg: 'Запрос отклонён, аккаунт восстановлен',
  },
  staffDetail: {
    workDays: 'Рабочих дней',
    workDaysWithHoliday: '{{kun}} дн. (праздников исключено: {{bayram}})',
    perDay: 'Зарплата за день',
    adjustments: 'Штрафы и премии',
    adjustmentsEmpty: 'В этом месяце корректировок нет',
    adjustmentsTotal: 'Итого',
    adjustmentAdd: 'Добавить корректировку',
    adjustmentDate: 'За какой день',
    penalty: 'Штраф',
    bonus: 'Премия',
    reason: 'Причина',
    reasonHint: 'Например: опоздал на 2 часа / сдал отчёт досрочно', notFound: 'Сотрудник не найден', month: 'Месяц', salary: 'Зарплата', shifts: 'График', logs: 'Приход-уход', history: 'История', salaryConfig: 'Настройка зарплаты', salaryType: 'Тип зарплаты', monthlyAmount: 'Оклад в месяц', perLesson: 'За урок (сум)', perHour: 'За час (сум)', dailyHours: 'Рабочих часов в день', dailyHoursHint: 'Больше этого в день не засчитывается, учитываются только полные часы', hoursRule: 'Не более {{n}} ч в день, минуты не учитываются', actualTime: 'фактически', hm: '{{h}} ч {{m}} мин', note: 'Заметка', calculation: 'Расчёт', notConfigured: 'Зарплата не настроена', lessons: 'Уроки', hours: 'Часы', computed: 'Начислено', paidThisMonth: 'Выплачено за месяц', remaining: 'Остаток', paySalary: 'Выплатить зарплату', pay: 'Выплатить', paid: 'Зарплата выплачена', amount: 'Сумма', weekday: 'День недели', start: 'Начало', end: 'Конец', noShifts: 'Нет графика', shiftError: 'Ошибка добавления', checkIn: 'Пришёл', checkOut: 'Ушёл', noLogs: 'Нет записей', date: 'Дата', in: 'Приход', out: 'Уход', worked: 'Отработано', h: 'ч', totalPaid: 'Всего выплачено', noHistory: 'Нет истории', forMonth: 'За месяц', fullyPaid: 'Полностью выплачено', editLog: 'Редактировать запись', overpay: 'Внимание: больше остатка', openExcluded: 'открытая запись (не в часах)', plannedHint: 'по расписанию, не по факту', hireDate: 'Принят', leaveDate: 'Уволен', prorateHint: 'полный месяц', prorated: 'Пропорция', onlyOpen: 'Только открытые (без check-out)', year: 'Год', allYears: 'Все годы', filteredTotal: 'Итого по выбранным', noMatch: 'Нет записей по фильтру', payrollWarnNoYear: 'Активный учебный год не выбран — уроки не посчитаны (0 сум). Сделайте год активным в разделе «Учебный год и четверти».', payrollWarnNoClasses: 'В активном учебном году ({{name}}) нет классов — уроки не посчитаны (0 сум). Добавьте класс или сделайте активным тот год, где они есть.' },
  parentDetail: { account: 'Аккаунт', login: 'Логин', newPassword: 'Новый пароль', passwordHint: 'Оставьте пустым — пароль не изменится', loginMin: 'Логин минимум 3 символа', passwordMin: 'Пароль минимум 5 символов', notFound: 'Родитель не найден', blocked: 'Заблокирован', edit: 'Изменить', father: 'Отец', mother: 'Мать', children: 'Дети', giftsSent: 'Подарил', giftsReceived: 'Получил', messages: 'Сообщения', subscription: 'Подписка', until: 'до', free: 'Обычный тариф', noChildren: 'Дети не привязаны', balanceMonth: 'Баланс: {{month}}', balanceNone: 'Нет данных по балансу', contacts: 'Контакты', fullName: 'Ф.И.О.', phone: 'Телефон', gender: 'Пол', birthDate: 'Дата рождения', activeAccount: 'Активный аккаунт', monthsGive: 'мес. выдать', cancelPremium: 'Отменить Премиум', tabOverview: 'Общее', tabPayments: 'Платежи', child: 'Ребёнок', paymentsTotal: 'Всего оплачено', paymentsCount: 'Количество платежей', storno: 'Возврат', paymentsUnsupportedTitle: 'Не удалось показать платежи', paymentsUnsupported: 'Сервер ещё не поддерживает фильтр по родителю (нужно обновить бэкенд). Список скрыт, чтобы не показать неверные данные.' },
  att: { PRESENT: 'Присутствовал', ABSENT: 'Отсутствовал', LATE: 'Опоздал', EXCUSED: 'Уваж. причина', filterStatus: 'Статус', allStatuses: 'Все статусы', sortBy: 'Сортировка', sortName: 'Имя (А-Я)', sortStatus: 'По статусу', noMatch: 'Нет учеников с этим статусом', modeMark: 'Отметка', modeView: 'История', markSubtitle: 'Сохраняется автоматически при выборе статуса', viewSubtitle: 'Записи посещаемости за период', allClasses: 'Все классы', dateRange: 'Период', allStudents: 'Все ученики', sortDateDesc: 'Дата (новые)', sortDateAsc: 'Дата (старые)', noRecords: 'Записи не найдены', total: 'Всего', student: 'Ученик', date: 'Дата', status: 'Статус', markedBy: 'Кто отметил', allMarkers: 'Все сотрудники', sortMarker: 'По отметившему' },
  notif: {
    total: 'Всего', unread: 'Непрочитанные', read: 'Прочитанные', allTypes: 'Все типы', allStatuses: 'Все статусы',
    recipient: 'Получатель', type: 'Тип', message: 'Сообщение', status: 'Статус', date: 'Дата',
    searchPlaceholder: 'Заголовок, текст или получатель...',
    scopeMine: 'Мне', scopeUsers: 'Пользователям', markAll: 'Прочитать все', viewAll: 'Посмотреть все', sortNew: 'Новые', sortOld: 'Старые', sortType: 'По типу', sortTitle: 'Заголовок (A-Z)',
  },
  notifType: {
    ANNOUNCEMENT: 'Объявление', ATTENDANCE: 'Посещаемость', GRADE: 'Оценка', HOMEWORK: 'Домашнее задание',
    PAYMENT: 'Оплата', PREMIUM: 'Премиум', SUPPORT: 'Поддержка', SYSTEM: 'Система',
  },
  login: {
    welcome: 'Добро пожаловать', subtitle: 'Введите данные для входа в панель управления',
    loginLabel: 'Логин', passwordLabel: 'Пароль', loginBtn: 'Войти',
    heroTitle: 'Современный способ управления школой',
    heroSubtitle: 'Платформа управления {{school}} — все процессы в одном месте.',
    f1: 'Ученики, классы и посещаемость в одной системе', f2: 'Финансы, отчёты и статистика в реальном времени',
    f3: 'Мобильный кабинет для родителей и учителей', f4: 'Безопасные права на основе ролей',
    denied: 'Нет доступа', deniedMsg: 'Эта панель только для сотрудников. Родители и ученики используют мобильное приложение.',
    tenantInactive: 'Эта школа временно неактивна. Пожалуйста, свяжитесь с администратором.',
    tenantNotFound: 'Такой адрес школы не найден. Проверьте адрес.',
    error: 'Ошибка входа',
  },
  qurilma: {
    faqatIlovaSarlavha: 'Панель открывается только через приложение SATA',
    faqatIlovaMatn: 'Вход в панель управления — только через приложение SATA на школьном компьютере. Для установки приложения обратитесь к администратору SATA.',
    loginParolBilan: 'Вход по логину и паролю',
    loginParolIzoh: 'Для учителей и администратора платформы',
    havolaEskirgan: 'Ссылка устарела. Откройте панель заново из приложения SATA.',
    ochilmoqda: 'Панель открывается…',
    xIlovaKerak: 'Панель открывается только через приложение SATA',
    xBloklangan: 'Этот компьютер заблокирован — обратитесь к директору',
    xKutilmoqda: 'Устройство ожидает подтверждения директора',
    xRadEtilgan: 'Этот компьютер отклонён — обратитесь к директору',
    xBoshqaMaktab: 'Этот компьютер подключён к другой школе',
    xSessiya: 'Сессия панели устарела — откройте панель заново из приложения SATA',
    xBirinchi: 'Первое устройство школы подтверждает администратор SATA',
    xKalitKutilmoqda: 'Дождитесь повторного подключения приложения',
    xOzgardi: 'Устройство изменилось после того, как вы его увидели (переподключилось или сменило статус) — список обновлён, проверьте и попробуйте снова',
    kartaSarlavha: 'Устройства (компьютеры панели)',
    kartaIzoh: 'Вход в панель возможен только из приложения SATA на подтверждённых компьютерах из этого списка.',
    bosh: 'Пока ни один компьютер не зарегистрирован',
    colNom: 'Компьютер', colTerminal: 'Терминал', colIp: 'IP', colFaollik: 'Последняя активность', colYaratilgan: 'Подключён', colHolat: 'Статус', colMaktab: 'Школа',
    holat: { KUTILMOQDA: 'Ожидает', TASDIQLANGAN: 'Подтверждён', RAD_ETILGAN: 'Отклонён', BLOKLANGAN: 'Заблокирован' },
    amal: { tasdiqlash: 'Подтвердить', 'rad-etish': 'Отклонить', bloklash: 'Заблокировать', 'blokdan-chiqarish': 'Разблокировать' },
    shuKompyuter: 'этот компьютер',
    kalitKutilmoqda: 'Ожидается повторное подключение приложения',
    blokdanIzoh: 'Компьютер снова запросит подтверждение',
    tasdiqSarlavha: 'Подтвердите действие',
    tasdiqMatn: 'С этого компьютера нельзя будет войти в панель.',
    joriyOgohlantirish: 'Вы работаете на этом компьютере — вы выйдете из панели. Если в школе нет другого подтверждённого компьютера, повторно подтвердить сможет только администратор SATA.',
    bajarildi: 'Выполнено',
    sozlamaSarlavha: 'Настройка платформы',
    faqatIlovaSwitch: 'Панель только через приложение SATA',
    ochirishOgohlantirish: 'Все сотрудники школ смогут входить из браузера — отключайте только в экстренном случае.',
    majburiyOchiq: 'Принудительно отключено переменной Railway (PANEL_FAQAT_ILOVA_MAJBURIY_OCHIQ)',
    ulashSarlavha: 'Ключ подключения школы',
    ulashIzoh: 'Введите ключ в окне «Подключить» приложения SATA на школьном компьютере.',
    maktabTanlang: 'Выберите школу',
    kalitYoq: 'В этой школе нет терминала FACE ID — будет создан ключ подключения для панели (терминал школа настроит позже).',
    kalitYarat: 'Создать ключ подключения',
    sozlanmagan: 'не настроен',
    holatFiltr: 'Статус',
  },
  dashboard: {
    welcome: 'Добро пожаловать', subtitle: '{{school}} — панель управления',
    students: 'Всего учеников', active: 'активных', classes: 'Классы', teachers: 'Учителя', admissions: 'Открытые заявки',
    revenue: 'Доход за месяц', revenueSub: 'За текущий месяц', todayAttendance: 'Посещаемость сегодня', present: 'Пришли', absent: 'Отсутствуют',
    restDay: 'Выходной — посещаемость не отмечается',
    qStudent: 'Добавить ученика', qAttendance: 'Отметить посещаемость', qGrade: 'Поставить оценку', qPayment: 'Принять платёж',
    genderStudents: 'Ученики по полу', genderStaff: 'Сотрудники по полу', genderParents: 'Родители', boys: 'Мальчики', girls: 'Девочки', male: 'Мужчины', female: 'Женщины', fathers: 'Отцы', mothers: 'Матери',
  },
  settings: {
    title: 'Настройки', profile: 'Профиль', fullName: 'Ф.И.О.', login: 'Логин', role: 'Роль', language: 'Язык',
    changePassword: 'Смена пароля', oldPassword: 'Текущий пароль', newPassword: 'Новый пароль', confirm: 'Подтвердите новый пароль',
    change: 'Изменить', min5: 'Минимум 5 символов', mismatch: 'Пароли не совпадают', changed: 'Пароль изменён',
    avatar: 'Фото профиля', uploadAvatar: 'Загрузить фото', removeAvatar: 'Удалить',
    avatarUpdated: 'Фото профиля обновлено', avatarRemoved: 'Фото профиля удалено',
    editProfile: 'Изменить', profileSaved: 'Профиль сохранён', nothingChanged: 'Изменений нет',
    nameMin: 'Ф.И.О. — минимум {{n}} символа', nameMax: 'Ф.И.О. — не более {{n}} символов', nameLetters: 'Ф.И.О. должно содержать буквы',
    loginMin: 'Логин — минимум {{n}} символа', loginDesc: 'Используется для входа в систему',
    currentPasswordDesc: 'Логин меняется — введите текущий пароль', currentPasswordRequired: 'Введите текущий пароль',
  },
  kiosk: {
    section: 'Киоск-экран',
    sectionDesc: 'Специальная ссылка для TV-экрана в холле школы',
    linkLabel: 'Ссылка на киоск',
    linkHint: 'Откройте ссылку в браузере телевизора в полноэкранном режиме — рейтинг, расписание и баннеры будут меняться автоматически.',
    noLink: 'Ссылка ещё не создана. После создания на TV-экране появятся рейтинг, расписание и баннеры.',
    create: 'Создать ссылку', created: 'Ссылка на киоск создана',
    copy: 'Копировать', copied: 'Скопировано', open: 'Открыть',
    regenerate: 'Обновить', regenerateTitle: 'Обновление ссылки',
    regenerateWarning: 'Будет создана новая ссылка, а старая перестанет работать. На TV-экране придётся открыть новую ссылку заново.',
    regenerated: 'Ссылка на киоск обновлена',
    disable: 'Удалить', disableTitle: 'Отключение киоск-экрана',
    disableWarning: 'Ссылка будет удалена, и TV-экран перестанет работать. Позже вы сможете создать новую ссылку.',
    disabled: 'Ссылка на киоск удалена',
    loadError: 'Не удалось загрузить состояние ссылки на киоск.',
    retry: 'Повторить',
  },
  supportEmail: {
    section: 'Контактный email (поддержка)',
    sectionDesc: 'Адрес «По вопросам» в правовых документах',
    label: 'Email поддержки',
    placeholder: 'support@school.uz',
    hint: 'Этот адрес указывается в Условиях использования, Политике конфиденциальности и Политике cookie, а также в мобильном приложении в строке «Вопросы». Если оставить поле пустым, email не показывается.',
    invalid: 'Неверный формат email (например: support@school.uz)',
    tooLong: 'Email не должен превышать 254 символа',
    saved: 'Email поддержки сохранён',
    cleared: 'Email поддержки удалён — в документах email не показывается',
    loadError: 'Не удалось загрузить email поддержки.',
    retry: 'Повторить',
    current: 'Сейчас: {{email}}',
    notSet: 'Пока не указан — в документах email не показывается.',
  },
  requisites: {
    section: 'Реквизиты договора',
    sectionDesc: 'Данные, которые указываются в договоре как сторона «Школа».',
    incomplete: 'Реквизиты заполнены не полностью',
    incompleteHint: 'Пока обязательные поля не заполнены, новый договор создать нельзя и документ не формируется.',
    unsaved: 'Значения ещё не сохранены',
    unsavedHint: 'Ниже — предложенные значения. Проверьте их и нажмите «Сохранить».',
    optionalSection: 'Необязательные поля',
    optional: '(необязательно)',
    required: 'Это поле обязательно',
    saved: 'Реквизиты сохранены',
    saveFailed: 'Не удалось сохранить реквизиты',
    loadError: 'Не удалось загрузить реквизиты.',
    retry: 'Повторить',
    f: {
      schoolName: 'Название школы', address: 'Адрес', director: 'Директор (Ф.И.О.)',
      stir: 'ИНН (СТИР)', bank: 'Банк', account: 'Расчётный счёт', mfo: 'МФО', phone: 'Телефон',
      directorShort: 'Директор (краткая форма)', jurist: 'Юрисконсульт', city: 'Город',
    },
    d: {
      schoolName: 'Полное название как в документе — например: «NURLI MAKTAB» NTM',
      directorShort: 'Показывается в блоке реквизитов (например: A.A. Fathullayev). Если пусто — берётся полное Ф.И.О.',
      jurist: 'Если пусто — эта строка в документе не выводится.',
      city: 'Строка под заголовком — например: город Наманган.',
    },
  },
  pages: {
    students: { title: 'Ученики', add: 'Новый ученик', search: 'Поиск по имени...', empty: 'Ученики не найдены', emptyDesc: 'Добавьте ученика или измените запрос поиска.' },
    classes: { title: 'Классы', add: 'Новый класс', empty: 'Нет классов. Сначала добавьте учебный год и класс.' },
    subjects: { title: 'Предметы', add: 'Новый предмет' },
    schedule: { title: 'Расписание и назначения' },
    attendance: { title: 'Посещаемость' },
    grades: { title: 'Оценки / электронный журнал' },
    homework: { title: 'Домашние задания' },
    ranking: { title: 'Рейтинг учеников' },
    behavior: { title: 'Оценки поведения' },
    exams: { title: 'Тестовые экзамены' },
    payments: { title: 'Финансы / платежи' },
    reports: { title: 'Отчёты' },
    expenses: { title: 'Расходы и зарплата' },
    admissions: { title: 'Приём / CRM', add: 'Новая заявка' },
    contracts: { title: 'Договоры', empty: 'Договоры не найдены', emptyDesc: 'Измените фильтр или создайте новый договор из карточки ученика.' },
    announcements: { title: 'Объявления', add: 'Новое объявление', empty: 'Нет объявлений' },
    notifications: { title: 'Уведомления', empty: 'Нет уведомлений' },
    stickers: { title: 'Стикеры', subtitle: 'Пакеты стикеров-картинок для аватаров в приложении',
      titlePremium: 'Премиум-стикеры', subtitlePremium: 'Пакеты стикеров-картинок для аватаров премиум-родителей',
      addPack: 'Новый пакет', editPack: 'Изменить пакет', packTitle: 'Название пакета', order: 'Порядок', titleRequired: 'Введите название', empty: 'Пакетов нет', emptyDesc: 'Добавьте первый пакет стикеров.', selectPack: 'Выберите пакет', upload: 'Загрузить стикер', uploaded: 'Стикер загружен', noStickers: 'В пакете нет стикеров — загрузите изображение (PNG/WEBP/ICO).', dragHint: 'Перетащите стикер, чтобы изменить порядок', count: 'стикеров', active: 'Активен', inactive: 'Неактивен', one: 'Стикер' },
    staff: { title: 'Сотрудники и пользователи', add: 'Новый пользователь' },
  },
  fields: { title: 'Заголовок', type: 'Тип',
    fullName: 'Ф.И.О.', phone: 'Телефон', class: 'Класс', subject: 'Предмет', parentName: 'Ф.И.О. родителя',
    parentPhone: 'Телефон родителя', status: 'Статус', date: 'Дата', amount: 'Сумма', month: 'Месяц',
  },
  confirm: { title: 'Подтвердите удаление', msg: 'будет удалён? Это действие необратимо.', ok: 'Удалить', cancel: 'Отмена' },
  genderRole: { father: 'Отец', mother: 'Мать', parent: 'Родитель', teacherMale: 'Учитель', teacher: 'Учитель' },
  subjectDetail: { notFound: 'Предмет не найден', edit: 'Редактирование', inSchedule: 'В расписании', inHomework: 'В заданиях', deleted: 'Предмет удалён', deleteHint: 'Удалить предмет полностью' },
  homeworkDetail: { notFound: 'Задание не найдено', info: 'Информация', edit: 'Редактирование', deleted: 'Задание удалено', deleteHint: 'Удалить задание полностью', attachedFile: 'Прикреплённый файл (из приложения)', openFile: 'Открыть', removeFile: 'Убрать файл' },
  announcementDetail: { notFound: 'Объявление не найдено', createdBy: 'Кем создано', edit: 'Редактирование', deleted: 'Объявление удалено', deleteHint: 'Удалить объявление полностью' },
  tenantsPage: {
    colQurilmalar: 'Устройства',
    title: 'Школы (тенанты)', totalCount: 'Всего: {{n}}', add: 'Новая школа',
    emptyTitle: 'Школ нет', emptyDesc: 'Создайте первую школу (тенант).',
    searchPlaceholder: 'Название или субдомен...', statusFilter: 'Статус', active: 'Активна', inactive: 'Неактивна',
    sortNewest: 'Новые', sortOldest: 'Старые', sortNameAsc: 'Название (А-Я)', sortNameDesc: 'Название (Я-А)',
    colName: 'Школа', colSlug: 'Субдомен', colCounts: 'Пользователи / Ученики', colUsers: 'Пользователи', colStudents: 'Ученики',
    colCreated: 'Создана', colActive: 'Активна',
    createTitle: 'Новая школа (тенант)', name: 'Название школы', slug: 'Субдомен (slug)', slugPlaceholder: 'например: nurli',
    slugDesc: 'URL: <slug>.domen.com', note: 'Заметка', adminSection: 'Админ школы (DIRECTOR)',
    adminLogin: 'Логин админа', adminPassword: 'Пароль админа', adminFullName: 'Ф.И.О. админа',
    cancel: 'Отмена', create: 'Создать', save: 'Сохранить', error: 'Ошибка',
    nameRequired: 'Введите название', slugInvalid: 'Только строчные буквы, цифры, дефис', loginMin: 'Логин — минимум 3 символа', passwordMin: 'Пароль — минимум {{n}} символов',
    created: 'Школа создана', saved: 'Сохранено', deleted: '{{name}} удалена',
    editFallbackTitle: 'Школа', activeLabel: 'Активна (не приостановлена)', activeDesc: 'Если выключить, пользователи школы не смогут войти',
    dangerZone: 'Опасная зона',
    deleteWarning: 'Полное удаление школы — все пользователи, ученики, платежи и другие данные будут безвозвратно потеряны ({{users}} польз., {{students}} учеников).',
    deleteConfirmHint: 'Для подтверждения введите субдомен:', deleteBtn: 'Полностью удалить школу',
    slugTooLong: 'Субдомен — не более 63 символов', slugEdgeDash: 'Субдомен не должен начинаться или заканчиваться дефисом',
    slugReserved: 'Это слово зарезервировано (www, admin, app, api, localhost)', domainFallback: 'domen',
    slugChangeTitle: 'Субдомен изменится',
    slugChangeOld: 'Старый адрес ({{old}}) перестанет работать — пользователи школы должны входить по новому адресу ({{new}}). Открытые на старом адресе сессии будут завершены.',
    slugChangeContracts: 'Новые номера договоров начнутся с «{{new}}-…» (сейчас «{{old}}-…»). Существующие договоры и файлы не изменятся.',
    slugChangeLegacy: 'Эта школа использует старые реквизиты договора: если они не сохранены, текущие значения будут сохранены автоматически — договоры продолжат формироваться как раньше.',
    slugConfirmTitle: 'Изменение субдомена',
    slugConfirmMsg: 'Старый адрес {{old}} перестанет работать, новый адрес — {{new}}. Продолжить?',
    slugConfirmOk: 'Да, изменить',
    requisitesSaved: 'Действующие реквизиты договора школы сохранены (Настройки → Реквизиты договора).',
  },
  tenantAdmins: {
    add: 'Добавить админа', addTitle: 'Новый админ (директор или админ)', addSubmit: 'Создать',
    added: '{{name}} — админ создан', createdTitle: 'Админ создан',
    role: 'Роль', gender: 'Пол', male: 'Мужской', female: 'Женский', genderRequired: 'Выберите пол',
    newAdminPasswordDesc: 'Минимум {{n}} символов',
    section: 'Администраторы школы',
    hint: 'Аккаунты директора и администраторов. Пароль можно сбросить — старый пароль не требуется.',
    loadError: 'Не удалось загрузить список администраторов', retry: 'Повторить',
    empty: 'В этой школе нет аккаунта директора или администратора.',
    reset: 'Пароль / логин',
    formTitle: '{{name}} — данные для входа',
    loginDesc: 'Если изменить, при следующем входе нужен новый логин',
    newPassword: 'Новый пароль',
    passwordDesc: 'Минимум {{n}} символов. Оставьте пустым — пароль не изменится.',
    sessionsNote: 'После смены пароля открытые сейчас сессии администратора автоматически не закрываются.',
    generate: 'Сгенерировать надёжный пароль', copy: 'Копировать', copied: 'Скопировано',
    saved: '{{name}} — сохранено',
    doneTitle: 'Данные для входа обновлены',
    doneHint: 'Передайте пароль администратору безопасным способом — повторно он не показывается.',
    nothingToSave: 'Введите новый пароль или измените логин',
  },
};

const en: typeof uz = {
  lang: { title: 'Language', uz: 'Uzbek', ru: 'Russian', en: 'English' },
  block: {
    block: 'Block', unblock: 'Unblock', title: 'Block user', blocked: 'Blocked',
    reasonLabel: 'Block reason', reasonPlaceholder: 'Enter a reason — it will be shown to the user',
    hint: 'A blocked user cannot sign in. App users receive the reason via a notification.',
  },
  teacherDetail: {
    notFound: 'Teacher not found', edit: 'Edit', fullName: 'Full name', phone: 'Phone', gender: 'Gender',
    male: 'Teacher (male)', female: 'Teacher (female)', birthDate: 'Birth date',
    assignments: 'Assignments (subject · class)', noAssignments: 'No assignments', contacts: 'Contacts',
    status: 'Status', salaryLink: 'Salary & work time', joined: 'Joined',
  },
  // Staff photo — for the face recognition terminal (Hikvision)
  staffDelete: {
    button: 'Delete permanently',
    done: 'Staff member deleted',
    blockedTitle: 'Cannot delete',
    blockedIntro: '{{name}} is linked to these records:',
    blockedHint: 'Removing them would destroy school history. Deactivate the staff member in the edit dialog instead — access is revoked, records stay.',
  },
  staffPhoto: {
    upload: 'Upload photo', change: 'Change photo', remove: 'Remove photo',
    uploaded: 'Photo uploaded', removed: 'Photo removed',
    stickerNote: 'Sticker avatar set — face recognition needs a real photo',
  },
  staffEdit: {
    title: 'Edit staff member', account: 'Access & role',
    newPassword: 'New password', passwordHint: 'Leave empty to keep the current password',
    roleLocked: 'You cannot change your own role',
    blockHint: 'Blocking / unblocking is in the "Status" section of the card',
    noChanges: 'No changes',
  },
  common: {
    reset: 'Reset',
    save: 'Save', cancel: 'Cancel', add: 'Add', delete: 'Delete', search: 'Search...',
    loading: 'Loading...', total: 'Total', noResults: 'Not found', searching: 'Searching...', actions: 'Actions', selectPlaceholder: 'Select', datePlaceholder: 'dd.mm.yyyy', error: 'Error',
    noData: 'No data', itemsCount: '{{count}} total',
    list: 'List',
    all: 'All', unreadOnly: 'Unread only', dateFrom: 'Date from', dateTo: 'Date to', noMatch: 'No records match the filter',
  },
  guard: { denied: 'Access denied', deniedMsg: 'This section is not available for your role.', goHome: 'Go home' },
  // Bayroq bilan muzlatilgan bo'lim (lib/features.ts) — components/FeatureFrozen.tsx
  featureFrozen: {
    title: 'Section temporarily disabled',
    desc: 'The Premium module is temporarily frozen. This section will be re-enabled later — your data is kept.',
  },
  contractDownload: {
    title: 'Student contract', desc: 'Your contract is ready. Tap the button to download.',
    download: 'Download', done: 'Contract downloaded', doneHint: 'The file has been saved to your device.',
    again: 'Download again', notFound: 'This contract link was not found.',
    expired: 'This link has expired — it was used the maximum number of times.', error: 'Download error. Please try again later.',
  },
  navGroups: { main: 'Main', academics: 'Academics', finance: 'Finance', management: 'Management', platform: 'Platform' },
  nav: {
    qurilmalar: 'Devices',
    agentlar: 'FACE ID agents',
    faceid: 'FACE ID',
    dashboard: 'Dashboard', students: 'Students', parents: 'Parents', teachers: 'Teachers', classes: 'Classes', subjects: 'Subjects',
    schedule: 'Schedule', attendance: 'Attendance', grades: 'Grades', journal: 'Electronic journal', homework: 'Homework',
    ranking: 'Ranking', behavior: 'Behavior', exams: 'Test exams',
    payments: 'Finance', reports: 'Reports', expenses: 'Expenses', payroll: 'Payroll', admissions: 'Admissions / CRM', contracts: 'Contracts', announcements: 'Announcements', banners: 'Banners', notifications: 'Notifications', stickers: 'Stickers', support: 'Support', premium: 'Premium', platformSupport: 'Platform help', tenants: 'Schools', saasPremium: 'Premium', saasGifts: 'Gifts', saasSupport: 'Support',
    audit: 'Audit & security',
    staff: 'Staff', academicYears: 'Academic year and terms', settings: 'Settings',
  },
  header: { refresh: 'Refresh', search: 'Search or go to a section...', settings: 'Settings', logout: 'Log out', light: 'Light mode', dark: 'Dark mode' },
  roles: {
    SUPER_ADMIN: 'Super admin', DIRECTOR: 'Director', ADMIN: 'Administrator', ACCOUNTANT: 'Accountant',
    TEACHER: 'Teacher', HOMEROOM_TEACHER: 'Homeroom teacher', RECEPTION: 'Reception', PARENT: 'Parent', STUDENT: 'Student',
  },
  studentStatus: { ACTIVE: 'Active', INACTIVE: 'Inactive', ON_LEAVE: 'On leave', GRADUATED: 'Graduated', EXPELLED: 'Expelled' },
  expenses: { title: 'Expenses', add: 'Add expense', added: 'Expense added', empty: 'No expenses', income: 'Income', expenses: 'Expenses', net: 'Net profit', debt: 'Debt', debtors: 'debtors', byCategory: 'By category', allCategories: 'All categories', category: 'Category', staff: 'Staff', staffSearch: 'Search staff...', note: 'Note', amount: 'Amount', date: 'Date', forMonth: 'For month', amountRequired: 'Enter amount', clickHint: 'Click a category for details', categoryTotal: 'Category total', records: 'Records', detailSearch: 'Search by note or staff...', detailEmpty: 'No expenses in this category', createdBy: 'Added by', searchPlaceholder: 'Search by note or staff...', sortCategoryAsc: 'Category (A-Z)', noMatch: 'No expenses match the filter', allMonths: 'All months', statsMonth: 'Figures for {{month}}', statsPeriodDiffers: 'The table below shows a different period: {{period}}', rangeFrom: 'from {{date}}', rangeTo: 'until {{date}}', emptyMonthHint: 'No expenses recorded for {{month}} — try another period.', rangeMonthHint: 'While a date range is selected the month filter is not applied: the range filters by the date spent, the month by which month the expense belongs to.', backToMonth: 'Filter by month', statsIgnoresFilters: 'Search and category filters do not apply to the cards — figures cover the whole month', type: 'Expense type', typeHint: 'The list of types is managed by the administration', allTypes: 'All types', noType: 'No type', cashIncomeHint: 'Cash received this month: {{sum}}', methodHint: 'The cash report splits expenses into cash and bank' },
  payrollPage: {
    title: 'Payroll', prevMonth: 'Previous month', nextMonth: 'Next month',
    accrued: 'Accrued', paid: 'Paid', remaining: 'Remaining', forecast: 'Expected by month end',
    overpaidHint: 'Overpaid: {{sum}}',
    overWithheld: 'deductions exceed earnings', overWithheldHint: 'Deductions exceed earnings: {{sum}}',
    meta: 'Working days: {{kun}} · grace {{daq}} min · calculated {{vaqt}}',
    ruleOff: 'The working-time rule is not enabled for this month — calculated the old way (full salary)',
    noSalary: 'Salary not set for {{n}} staff', toStaff: 'Go to staff',
    search: 'Search by staff name...',
    staff: 'Staff', role: 'Role', monthly: 'Salary', daily: 'Per day', days: 'Days', came: 'Present', absent: 'Absent',
    lateEarly: 'Late/early', withheld: 'Withheld', adjustment: 'Adjustment',
    lateEarlyValue: '{{kech}} / {{erta}} min', outsideDays: 'Outside employment period: {{n}} days',
    today: 'today +{{sum}}', overpaid: 'overpaid', pay: 'Pay salary', payConfirm: 'Pay', total: 'Total',
    empty: 'No salaried staff this month', loadError: 'Could not load the payroll table', retry: 'Retry',
    warnNoShift: 'No shift',
    warnNoShiftHint: 'Working hours not set — days present count in full, late arrival and early leave are not counted',
    warnOpenLog: 'Leave not marked',
    warnOpenLogHint: 'Past days have records without a leave time — counted as worked until the end of the shift',
    warnNoLogs: 'No records',
    warnNoLogsHint: 'No check-in records on work days this month — check the FACE ID link',
    warnNoWorkdays: "Shift days don't match payroll days",
    warnNoWorkdaysHint: "The employee's shift does not fall on payroll working days — check the shift or Settings → Payroll working days",
    passedDays: 'Days passed', expectedDays: 'Expected days', absentSum: 'Absence amount',
    lateMin: 'Late (min)', earlyMin: 'Early leave (min)', warnings: 'Warnings',
  },
  expenseCat: { SALARY: 'Salary', RENT: 'Rent', UTILITY: 'Utilities', SUPPLY: 'Supplies', TAX: 'Tax', MAINTENANCE: 'Maintenance', OTHER: 'Other' },
  expenseTypes: {
    title: 'Expense types', manage: 'Manage types', byType: 'By type',
    name: 'Name', namePlaceholder: 'For example: Internet', group: 'Group',
    groupHint: 'Which category it falls into in reports',
    order: 'Order', usage: 'Used', active: 'Active', inactive: 'Inactive',
    add: 'Add type', added: 'Type added', updated: 'Saved', deleted: 'Type deleted',
    nameRequired: 'Enter a type name', edit: 'Edit', close: 'Close',
    activate: 'Activate', deactivate: 'Deactivate',
    deleteBlocked: 'This type is used by expenses — it cannot be deleted, deactivate it instead',
    empty: 'No expense types', emptyDesc: 'Add the first type in the field above.',
  },
  plans: {
    tab: 'Monthly fees',
    progress: 'Monthly fee set: {{done}} / {{total}} students',
    hint: 'Debt is calculated from this fee: a student without a fee never appears among debtors.',
    search: 'Search student...',
    allClasses: 'All classes',
    onlyMissing: 'Only without fee',
    discard: 'Discard',
    save: 'Save ({{count}})',
    saved: 'Fees saved: {{count}}',
    emptyAmount: '{{count}} changed rows have no monthly fee — enter it or discard the change.',
    student: 'Student',
    class: 'Class',
    monthly: 'Monthly fee',
    discount: 'Discount',
    due: 'To pay',
    note: 'Note',
    noAmount: 'not set',
  },
  debtStart: {
    section: 'Debt tracking',
    sectionDesc: 'The month the school moved to the system — earlier months are not counted as debt',
    label: 'Debt tracking starts from',
    hint: 'If payments before this month are not in the system, those months will not show debtors.',
    none: 'No limit',
    noneHint: 'No limit — all months count towards debt.',
    saved: 'Debt tracking start month saved',
    cleared: 'Limit removed',
    beforeNotice: 'Debt tracking starts from {{month}} — this month is not counted.',
  },
  payrollRule: {
    section: 'Payroll rule',
    sectionDesc: 'Monthly and hourly pay is calculated by the scheduled working time',
    fromMonth: 'Starting month',
    fromMonthHint: 'From this month late arrival and early leave reduce pay; early arrival and late leave add nothing.',
    offPlaceholder: 'Off',
    offHint: 'Off — pay is calculated as before.',
    grace: 'Grace period',
    graceHint: 'Lateness or early leave up to this many minutes is forgiven.',
    min: 'min',
    saved: 'Payroll rule saved',
    off: 'Payroll rule turned off',
    workDays: 'Payroll working days',
    workDaysHint: 'The daily rate of a monthly salary is based on these days (does not affect school days)',
    workDaysRequired: 'Select at least one day',
  },
  kunlar: {
    monthsTitle: 'By month', monthsSubtitle: 'Days present, hours worked and salary accrued per month. Click a row to select the month',
    month: 'Month', came: 'Present', absent: 'Absent', worked: 'Time worked', accrued: 'Accrued', paid: 'Paid', remaining: 'Remaining',
    daysOf: '{{n}} / {{jami}} days', extraDays: '+{{n}} on days off', noOutDays: '{{n}} days without check-out', selected: 'selected',
    title: 'By day — {{month}}', subtitle: 'When they came, when they left, hours worked and pay for the day',
    date: 'Date', status: 'Status', in: 'In', out: 'Out', workedCol: 'Worked', shift: 'Work hours', dayPay: 'Day pay', adj: 'Bonus / penalty',
    s_KELDI: 'Present', s_ISHDA: 'At work', s_KELMADI: 'Absent', s_KUTILMOQDA: 'Expected', s_DAM: 'Day off', s_TASHQARI: 'Outside employment',
    noOut: 'No check-out', setOut: 'Enter check-out time', late: 'late {{n}} min', early: 'left early {{n}} min',
    soFar: 'so far', notCounted: 'not counted', noPerDay: 'This salary type is not calculated per day',
    showRest: 'Show days off', total: 'Total', totalDays: '{{n}} days present',
    roundHint: 'The sum of day pay may differ from the monthly figure by a few soums — rounding is done once per month',
    noOutHint: 'Past days without check-out: {{n}}. Counted until end of shift (no shift — full day) — enter the actual time',
    outTitle: 'Enter check-out time', outDay: 'Day: {{day}}', outCame: 'Came at: {{time}}', outTime: 'Check-out time', outSave: 'Save',
    outSaved: 'Check-out time saved', outAfterIn: 'Check-out must be after check-in', h: '{{h}} h {{m}} min',
  },
  ishVaqti: {
    title: 'Days by working time',
    subtitle: 'Late arrival and early leave reduce pay; early arrival and late leave add nothing',
    day: 'Date', shift: 'Working time', in: 'In', out: 'Out', late: 'Late', early: 'Early leave',
    extra: 'Extra', counted: 'Counted', min: 'min', bonus: 'Bonus',
    absent: 'Absent', noOut: 'not marked', pending: 'pending', soFar: 'so far', inProgress: 'in progress',
    bonusReason: 'For staying late (+{{n}} min)',
    workDays: "Employee's work days",
    noShift: 'No working time set — lateness is not counted. Set it in the "Schedule" tab.',
    noShiftFixed: 'No shift set — days present count in full, late arrival and early leave are not counted',
    outsidePeriod: 'Outside the employment period: {{n}} work days not counted (see hire/leave dates)',
    openCounted: 'open log (counted until the end of working time)',
    openPlain: 'open log',
  },
  cashbook: {
    tab: 'Cash report', title: 'Cash report', subtitle: 'Financial figures for the selected day', refresh: 'Refresh report', date: 'Date',
    dayIncome: 'Income for the day', dayExpense: 'Expenses for the day', dayNet: 'Net for the day', totalCash: 'Total cash',
    netHint: 'Income − Expenses', totalHint: 'Cash + Bank, at end of day', vsPrev: '{{pct}}% (vs previous day)', prevZero: 'Previous day: 0 UZS', same: 'Same as previous day',
    cashBox: 'Cash (till)', bank: 'Bank', bankSub: 'card, transfer', shuKun: 'this day', income: 'Income', expense: 'Expenses', rest: 'Net',
    cashLeft: 'Cash balance', bankLeft: 'Bank balance', leftHint: 'at end of day, total',
    chart: 'Income and expenses — {{year}}, by month',
    details: 'Details for the selected day', colType: 'Type', colSum: 'Amount (UZS)', colDate: 'Date', colNote: 'Note', total: 'Total',
    incCash: 'Income (cash)', incBank: 'Income (bank)', expCash: 'Expenses (cash)', expBank: 'Expenses (bank)',
    payCount: '{{count}} payments', expCount: '{{count}} expenses', reversals: '{{count}} refunds', noRows: 'No records',
    debtTitle: 'Last month debt — {{month}}', colStudent: 'Student', colClass: 'Class', colDebt: 'Debt (UZS)', monthsDebt: '{{count}} mo',
    debtTotal: 'Total debt', debtCount: '{{count}} students', debtNone: 'No debtors for last month', seeAll: 'See all',
    monthsHint: 'Note — for how many months since {{from}} the payment is incomplete',
    shareTitle: 'Cash vs bank share (this day)', cashIn: 'Cash income', cashOut: 'Cash expenses', bankIn: 'Bank income', bankOut: 'Bank expenses',
    shareHintIn: '{{pct}}% of income', shareHintOut: '{{pct}}% of expenses',
    summary: 'Summary', sumIncome: 'Income for the day: {{sum}}', sumExpense: 'Expenses for the day: {{sum}}', sumNet: 'Net for the day: {{sum}}', sumCash: 'Total cash: {{sum}} (cash {{cash}} + bank {{bank}})', sumDebt: 'Last month debt: {{sum}} ({{count}} students)',
    howTitle: 'How it is calculated',
    how1: 'Income — payments received on this day (whatever month they are for). Refunds are subtracted.',
    how2: 'Expenses — expenses entered in the Expenses section with this date.',
    how3: 'Cash — the "Cash" method; Bank — card, transfer and other methods.',
    how4: 'Total cash — all income minus all expenses from the cash start date up to the end of the selected day.',
    startButton: 'Cash start date', startTitle: 'Which day the cash book starts from',
    startDesc: 'Payments and expenses before this day are left out of the cash report (income, expenses, balance, chart). Records are not deleted — student balances and debts stay the same.',
    startLabel: 'Start date', startClear: 'Count the whole history', startSaved: 'Cash start date saved', startFrom: 'since {{date}}',
  },
  balances: {
    tab: 'Balances', tabPayments: 'Payments', due: 'Plan', overpaid: 'Overpaid', status: 'Status',
    byStatus: 'By status', clickHint: 'Click a status to filter',
    allStatuses: 'All statuses', searchPlaceholder: 'Student or class...',
    empty: 'No balance data', noPlan: 'No tuition plan',
    balanceHint: 'Balance: {{value}}',
    filteredSummary: '{{status}}: {{count}} students · debt {{debt}} · paid {{paid}}',
    sortOverpaidDesc: 'Overpaid (largest)',
    discount: 'Discount', discountHint: 'The plan amount ALREADY has the discount deducted (monthly − discount)',
  },
  balanceStatus: { PAID: 'Paid in full', PARTIAL: 'Partially paid', DEBT: 'In debt', OVERPAID: 'Overpaid' },
  days: { '1': 'Monday', '2': 'Tuesday', '3': 'Wednesday', '4': 'Thursday', '5': 'Friday', '6': 'Saturday', '7': 'Sunday' },
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  monthsFull: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  charts: { income: 'Income', count: 'Students', monthIncome: 'Revenue for month', cashIncome: 'Cash received' },
  currency: { som: 'UZS', thousand: 'K', million: 'M', billion: 'B' },
  timeAgo: { justNow: 'just now', min: '{{n}} min ago', hour: '{{n}} h ago', day: '{{n}} d ago' },
  reports: {
    byClass: 'Students by class', students: 'Students', monthlyRevenue: 'Monthly revenue {{year}}', revenueHint: 'Revenue for month — paid for that month. Cash received — money taken in during that month. They differ when several months are prepaid.',
    noData: 'No data', debtors: 'Debtors', totalDebt: 'Total debt', found: 'Found',
    count: '{{count}}', searchDebtor: 'Student or class...', noDebtors: 'No debtors',
    class: 'Class', plan: 'Plan', paidCol: 'Paid', debtCol: 'Debt',
    sortDebtDesc: 'Debt (high)', sortDebtAsc: 'Debt (low)', sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)',
    sortClassAsc: 'Class (A-Z)', sortDueDesc: 'Plan (high)', sortPaidDesc: 'Paid (high)',
    year: 'Year', noMatch: 'No debtors match the filter',
  },
  qc: {
    selectPlaceholder: 'Select', nothingFound: 'Nothing found — add a new one', addNew: 'Add new', searchPlaceholder: 'Search...',
    gender: 'Gender', male: 'Male', female: 'Female',
    yearNameRequired: 'Enter a name (e.g. 2025-2026)', yearAdded: 'Academic year added', academicYear: 'Academic year', save: 'Save',
    fullNameRequired: 'Enter full name', loginMinLength: 'Login must be at least 3 characters', passwordMinLength: 'Password must be at least 5 characters', genderRequired: 'Select gender',
    teacherAdded: 'Teacher added', fullName: 'Full name', login: 'Login', password: 'Password', phone: 'Phone',
    parentCreated: 'Parent account created', parentFullName: 'Parent full name',
    subjectNameRequired: 'Enter subject name', subjectAdded: 'Subject added', subjectName: 'Subject name', subjectNamePlaceholder: 'Mathematics', code: 'Code',
    classNameRequired: 'Enter class name', academicYearRequired: 'Select academic year', classAdded: 'Class added', className: 'Class name', homeroomTeacher: 'Homeroom teacher',
    newAcademicYear: 'New academic year', newTeacher: 'New teacher',
  },
  contactsMgr: {
    saved: 'Saved', deleted: 'Deleted', phones: 'Phones', add: 'Add', noPhones: 'No phones added',
    primaryPhone: 'Primary number', makePrimary: 'Make primary', primary: 'primary',
    addresses: 'Addresses', noAddresses: 'No addresses added', primaryAddress: 'Primary address',
    phone: 'Phone', address: 'Address', labelName: 'Label (e.g. Father, Home, Work)', number: 'Number', cancel: 'Cancel', save: 'Save',
  },
  multiContact: {
    phones: 'Phone numbers', labelPlaceholder: 'Label (Work, Home...)', primary: 'Primary', addPhone: 'Add number', primaryHint: '◉ — primary number',
    addresses: 'Addresses', labelShort: 'Label', address: 'Address', addAddress: 'Add address',
  },
  staffPage: {
    payrollWarnTitle: 'Payroll calculation is incomplete',
    fullName: 'Full name', login: 'Login', password: 'Password', role: 'Role', phone: 'Phone', status: 'Status', active: 'Active',
    user: 'User', create: 'Create', birthDate: 'Birth date', birthDateOptional: 'Birth date (optional)', datePlaceholder: 'dd.mm.yyyy',
    searchPlaceholder: 'Name or login...', sortNewest: 'Recently added', sortNameAsc: 'Name (A-Z)', sortRole: 'Role',
    saved: 'Saved', created: 'User created',
    fullNameRequired: 'Enter full name', loginMin: 'Login must be at least 3 characters', passwordMin: 'Password must be at least 5 characters', genderRequired: 'Select gender',
    specialty: 'Specialty',
    specialtyHint: 'The concrete job within the role — shown next to the name',
    specialtyPlaceholder: 'Mathematics, Gate, Psychologist…',
    notifyTitle: 'Send notification', notifyHint: 'A personal notification (e.g. a birthday greeting) will be sent to this staff member.',
    notifySubject: 'Title', notifyBody: 'Message', send: 'Send', notifySent: 'Notification sent',
    blocked: 'Blocked',
    empty: 'No staff found', emptyDesc: 'Change the search query or filter.',
  },
  teachersPage: {
    add: 'New teacher',
    title: 'Teachers', login: 'Login', role: 'Role', allRoles: 'All', active: 'Active',
    searchPlaceholder: 'Name or login...', sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)', sortNewest: 'Recently added', sortRole: 'Role',
    status: 'Status', blocked: 'Blocked',
    exportCsv: 'Export (CSV)',
    exportHint: 'Roster file to load into the face recognition terminal (Hikvision)',
  },
  studentsPage: {
    sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)', sortNewest: 'Recently added', sortAdmissionDate: 'Admission date',
    colParentPhone: 'Parent phone', fromAdmission: 'Select from admissions (optional)',
    fromAdmissionDesc: 'Selecting an applicant fills the fields automatically', fromAdmissionPlaceholder: 'Applicant from admissions list',
    admissionNotice: 'Data taken from the admission. Once created, the applicant will be marked as "enrolled".',
    orManual: 'or enter the details manually', newClass: 'New class', birthDate: 'Date of birth',
    parentAccount: 'Parent account (select or create)', parentSearchPlaceholder: 'Search by name or phone...',
    newParent: 'New parent', parentNameNoAccount: 'Parent full name (no account)',
    created: 'Student added', deleted: 'Deleted',
    validateFullName: 'Enter the full name', validateClass: 'Select a class (required)', validateGender: 'Select a gender',
  },
  studentDetailPage: { accountTitle: 'Login account', newPassword: 'New password', passwordHint: 'Leave empty to keep the current password', loginUpdated: 'Account updated',
    deleteImpactTitle: 'Warning — cannot be undone',
    deleteImpactIntro: 'Deleting {{name}} will also remove:',
    deleteImpactWarn: 'This action cannot be undone.',
    deleteAnyway: 'Delete anyway',
    impactContracts: 'Contracts ({{n}}) will remain but lose their owner.',
    impact_tolovlar: 'Payments',
    impact_davomat: 'Attendance records',
    impact_baholar: 'Grades',
    impact_chorak: 'Term grades',
    impact_testlar: 'Test scores',
    impact_xulq: 'Behavior scores',
    impact_reja: 'Tuition plan',
        createLogin: "Create login",
        hasLogin: "Account: {{login}}",
        loginCreated: "Student account created",
        studentLoginTitle: "Create student account",
        studentLoginHint: "With this login the student signs in to the app and sees their own grades and attendance. Name and gender come from the record.",
    notFound: 'Student not found', backToList: 'Students list', noClass: 'No class', edit: 'Edit',
    newParent: 'New parent', linkExisting: 'Link existing', tuitionPlan: 'Tuition plan', parent: 'Parent',
    accountChildren: 'account · {{n}} children', otherChildren: 'Other children:', monthlyTuition: 'Monthly tuition',
    balanceTitle: 'Current month balance', balanceEmpty: 'No balance data for this month — neither a tuition plan nor a payment is recorded.',
    tabGrades: 'Grades', tabAttendance: 'Attendance', tabPayments: 'Payments', tabContacts: 'Contacts',
    noGrades: 'No grades', colGrade: 'Grade', noAttendance: 'No attendance records', noPayments: 'No payments',
    parentAccountTitle: 'Parent portal account', parentAccountHint: 'A login and password are created so the parent can access the mobile portal.',
    login: 'Login', password: 'Password', create: 'Create',
    linkParentTitle: 'Link an existing parent', linkParentHint: 'Link a parent whose other child is already in the system to this student.',
    childrenCount: '{{n}} children', link: 'Link', editTitle: 'Edit student', selectClass: 'Select a class',
    monthlyAmount: 'Monthly tuition (UZS)', discount: 'Discount (UZS)', final: 'Total',
    parentLinked: 'Parent linked', saved: 'Saved', parentCreated: 'Parent account created', planSaved: 'Tuition plan saved',
    validateFullName: 'Enter the full name', validateLogin: 'Login must be at least 3 characters', validatePassword: 'Password must be at least 5 characters', validateGender: 'Select a gender',
    deleted: 'Student deleted', deleteHint: 'Permanently delete this student. This action cannot be undone.',
    photo: 'Photo', uploadPhoto: 'Upload photo', changePhoto: 'Change photo', removePhoto: 'Remove photo',
    photoUpdated: 'Photo updated', photoRemoved: 'Photo removed',
    limitedNote: 'Showing the latest {{n}} records', openFull: 'Open full page',
    year: 'Year', filteredTotal: 'Total for selection', noMatch: 'No records match the filter',
    note: 'Note', mainPhoneHint: 'Main number — the one shown in the student list',
    contactsHint: 'Additional phones and addresses are added in the "Contacts" tab.',
  },
  homeworkPage: {
    add: 'Add homework', searchPlaceholder: 'Homework title...', sortNew: 'Newest first', sortDueSoon: 'Due date (soonest)', sortTitleAsc: 'Title (A-Z)',
    class: 'Class', selectClass: 'Select a class', empty: 'No homework yet', subject: 'Subject', task: 'Task', due: 'Due',
    modalTitle: 'Add homework', newSubject: 'New subject', titleField: 'Title', description: 'Description', dueDate: 'Due date',
    fileUrl: 'File link (optional)', subjectRequired: 'Select a subject', titleRequired: 'Enter a title', created: 'Homework added',
    mineOnly: 'Mine only',
    teacher: 'Assigned by', teacherDisabledHint: '"Mine only" is on',
    dueRange: 'Due date range', dueRangeHint: 'Tasks without a due date are hidden',
    overdueOnly: 'Overdue', activeOnly: 'Active', overdueHint: 'The due date has passed',
    noDue: 'No due date',
  },
  admissionsPage: {
    stageNew: 'New', stageContacted: 'Contacted', stageTest: 'Test', stageInterview: 'Interview',
    statusOpen: 'Open', statusAccepted: 'Accepted', statusRejected: 'Rejected', statusEnrolled: 'Enrolled',
    filterEnrolled: 'Enrolled', filterRejected: 'Rejected', searchPlaceholder: 'Applicant or phone...', sortNew: 'Newest applications', sortNameAsc: 'Name (A-Z)',
    stage: 'Stage', status: 'Status', empty: 'No applications', applicant: 'Applicant', age: 'Age', source: 'Source', ageYears: '{{age}} yrs',
    modalTitle: 'New application', applicantName: 'Applicant (student) full name', birthDate: 'Date of birth', birthDatePlaceholder: 'dd.mm.yyyy',
    sourcePlaceholder: 'Instagram, referral...', note: 'Note', notePlaceholder: 'Additional info, observations...',
    applicantRequired: "Enter the applicant's name", phoneRequired: 'Enter a phone number', created: 'Application added',
    enroll: 'Convert to student', enrollTitle: 'Convert to student',
    enrollDesc: 'Applicant details are filled in — pick a class and gender, then save.',
    enrolled: 'Student enrolled', enrollValidateName: 'Full name at least 3 letters',
    enrollValidateClass: 'Select a class', enrollValidateGender: 'Select a gender',
    alreadyEnrolled: 'Enrolled',
  },
  classDetail: {
    name: 'Class name', nameRequired: 'Class name is required', academicYear: 'Academic year',
    homeroomTeacher: 'Homeroom teacher', homeroomTeacherPlaceholder: 'Select a teacher', noTeachers: 'No teacher found',
    studentsCount: 'Students', groupsCount: 'Groups', students: 'Students', noStudents: 'No students',
    groups: 'Groups', noGroups: 'No groups', edit: 'Edit', saved: 'Saved',
    deleted: 'Class deleted', deleteHint: 'Deleting a class cannot be undone', notFound: 'Class not found',
    changeStatus: 'Change status', statusUpdated: 'Status updated',
    changeStatusConfirm: '{{name}} — change status to "{{status}}"?',
    statusHint: 'Click the status badge to change it',
  },
  bannerDetail: {
    notFound: 'Banner not found', preview: 'Preview', active: 'Active', inactive: 'Inactive',
    createdBy: 'Created by', edit: 'Edit', deleteHint: 'Permanently delete this banner. This action cannot be undone.',
  },
  bannerTemplate: {
    HERO: { label: 'Photo hero', desc: 'Full image/gradient + scrim + CTA' },
    SOLID: { label: 'Solid color', desc: 'Color/gradient + icon + text' },
    GRADIENT: { label: 'Festive gradient', desc: 'Gradient + decorative circles' },
    SPLIT: { label: 'Split (media + text)', desc: 'Media left, text right' },
    MINIMAL: { label: 'Minimal announcement', desc: 'Light card + colored line' },
    TICKET: { label: 'Ticket (premium)', desc: 'Ticket style + stamp' },
  },
  bannersPage: {
    title: 'Banners', subtitle: 'App home screen — template + 3 languages + light/dark builder', add: 'New banner',
    empty: 'No banners', emptyDesc: 'Create your first banner — it will appear on the app home screen.',
    preview: 'Preview', templateTitle: 'Template / Title', audience: 'Audience', active: 'Active',
    confirmDelete: 'Delete this banner?', editTitle: 'Edit banner', createTitle: 'New banner — builder', template: 'Template',
    content: 'Content (per language)', fieldTitle: 'Title', fieldBody: 'Body', fieldCta: 'Button (CTA)', fieldEyebrow: 'Eyebrow label',
    fallbackHint: 'If left empty, the Uzbek text is used.', design: 'Design (light/dark separately)',
    alignLeft: 'Left', alignCenter: 'Center', scrim: 'Dark gradient', emoji: 'Emoji / icon', themeLight: 'Light', themeDark: 'Dark',
    gradientBg: 'Gradient background', bgColor: 'Background color', gradient1: 'Gradient 1', gradient2: 'Gradient 2', ticketBg: 'Ticket background',
    accentColor: 'Accent color (CTA/line/stamp)', textLight: 'White text', textDark: 'Black text',
    uploadImage: 'Upload image', removeImage: 'Remove image', imageUploadFailed: 'Image upload failed',
    audAll: 'Everyone', audParents: 'Parents', audFathers: 'Fathers', audMothers: 'Mothers', audTeachers: 'Teachers',
    audTeachersMale: 'Male teachers', audTeachersFemale: 'Female teachers', audMales: 'All males', audFemales: 'All females',
    audCustom: 'Selected users', roleFather: 'Father', roleMother: 'Mother', roleTeacherMale: 'Teacher',
    users: 'Users', usersDesc: 'Only selected users will see the banner', usersPlaceholder: 'Name or phone...',
    linkScreen: 'Screen (on tap)', linkUrl: 'External link', startsAt: 'Starts', endsAt: 'Ends', optional: 'optional', screenProfile: 'Profile',
    order: 'Order', activeLabel: 'Active (visible in the app)', livePreview: 'Live preview', saved: 'Saved', deleted: 'Deleted',
    kioskLabel: 'Show on the kiosk screen', kioskDesc: 'The banner will also rotate on the school TV screen', kioskBadge: 'Kiosk',
    kioskAllOnly: 'Only banners with the "Everyone" audience appear on the TV screen',
    kioskBadgeInactive: 'Kiosk (not shown)',
    kioskClearedWarn: 'The kiosk flag is cleared on save — only banners with the "Everyone" audience appear on the TV screen. Set the audience back to "Everyone" before saving if you need it',
    linkScreenFrozen: 'This screen is temporarily disabled — the banner will NOT appear in the app. Pick another screen or leave the link empty.',
  },
  platformSupportPage: {
    subtitle: 'Direct chat with the system superadmin', emptyHint: 'Have a question or an issue? Write to the platform superadmin.',
    messagePlaceholder: 'Type a message...', send: 'Send',
  },
  saasSupportPage: {
    title: 'Support — school admins', subtitle: 'Chat with school admins', emptyTitle: 'No messages',
    emptyDesc: 'They will appear here when school admins write.', youPrefix: 'You: ', selectSchool: 'Select a school',
    replyPlaceholder: 'Type a reply...', send: 'Send',
    search: 'School name...', unreadOnly: 'Unread only',
  },
  saasGiftsPage: {
    title: 'Gifts — all schools', searchPlaceholder: 'Name or phone...', emptyTitle: 'No gifts',
    emptyDesc: 'No Premium gifts have been sent yet.', school: 'School', from: 'From', to: 'To', duration: 'Duration', anonymous: 'anonymous', months: '{{n}} mo',
    tenant: 'School', sortDateDesc: 'Date (newest)', sortDateAsc: 'Date (oldest)', sortMonthsDesc: 'Duration (longest)',
  },
  saasPremiumPage: {
    title: 'Premium — all schools', subtitle: 'Payment control is superadmin-only', premiumUpdated: 'Premium updated',
    searchPlaceholder: 'Name or phone...', school: 'School', allSchools: 'All schools', all: 'All', regular: 'Regular',
    sortNameAsc: 'Name (A-Z)', sortPremiumDesc: 'Premium (longest)', sortPremiumAsc: 'Premium (expiring soon)', sortNewest: 'Newest',
  },
  layout: { search: 'Search' },
  contractGen: {
    tooltip: "Create and send contract", modalTitle: 'Parent contract', contractNumber: 'Contract number',
    contractNumberAuto: 'Leave empty — the server assigns the number automatically',
    contractNumberPlaceholder: 'Automatic',
    contractDate: 'Contract date', studentName: 'Student full name', parentName: 'Parent (or guardian) full name',
    parentAddress: "Parent's residential address", durationMonths: 'Study duration (months)', passport: 'Passport series and number',
    jshshir: 'PINFL (optional)', jshshirPlaceholder: '14 digits',
    selectFromPhones: "Select from parent's numbers", selectPhone: 'Select a number',
    phoneLabel: "Parent phone", phoneLabelExtra: 'Additional',
    parentFillsHint: 'Optional — the parent fills this in via the link',
    identitySection: 'Identity details (optional)',
    identityHint: 'The parent fills in their full name, address, passport and PINFL themselves via the link and confirms them when signing — the school does not have to enter them.',
    parentNameOptional: 'Optional — if left empty, the parent enters it themselves when signing',
    identityFilled: '{{count}} filled in',
    attachPhone: 'Link the new number to the parent',
    attachPhoneHint: "The number will be added to the parent's contacts. If unchecked, the number stays only in the contract.",
    phoneAttached: "The new number was added to the parent's contacts.",
    phoneAttachFailed: 'Could not link the new number to the parent — check the contacts manually. The contract was still created.',
    fromDate: 'Contract period (from)', toDate: 'Contract period (to)', createAndSend: "Create and send",
    parentNameTooShort: 'Full name must be at least 5 characters',
    addressTooShort: 'Address must be at least 5 characters',
    passportInvalid: 'Invalid passport format (e.g. AB 1234567)',
    jshshirInvalid: 'PINFL must contain exactly 14 digits',
    parentPhoneInvalid: 'Enter the full phone number',
    paymentRequired: 'Monthly payment must be a positive number',
    paymentTooBig: 'Monthly payment is too large — check the value',
    monthsInvalid: 'Number of study months must be between 1 and 12',
    fromDateRequired: 'Select the start date', toDateRequired: 'Select the end date',
    toDateBeforeFrom: 'The end date must be later than the start date',
    numberTaken: 'A contract with this number already exists — enter a different number or leave the field empty',
    numberIssued: 'Contract number: {{number}}',
    requisitesTitle: 'School legal details are not filled in',
    requisitesHint: 'The contract document cannot be generated without the school legal details. Fill them in under Settings.',
    requisitesHintNoAccess: 'The contract document cannot be generated without the school legal details. Only the school administration (director or admin) can fill them in — please contact them.',
    requisitesLink: 'Settings — school legal details',
    openContract: 'Open the contract',
    createdNotified: "Contract created and sent to the parent in the app", createdNoApp: "Contract created (parent is not in the app — share the link)",
    create: 'Create contract',
    linkReady: 'Link ready', notified: "The parent was notified in the app — they will review and sign the contract there.", notNotified: "No parent account is linked to this student — no notification was sent. Share the link below with the parent yourself.",
    noParentWarn: "No parent account is linked to this student — no app notification will be sent. After creating the contract, share the link with the parent yourself.",
    copied: 'Copied', copy: 'Copy', linkNote: 'Through the link the parent reads the contract, fills in their details and signs online. If the parent uses the mobile app, the contract also appears there.', close: 'Close',
  },
  contractList: {
    tab: 'Contracts', empty: 'No contracts created', number: 'Number', created: 'Created',
    student: 'Student',
    statusSENT: 'Sent', statusVIEWED: 'Viewed', statusSIGNED: 'Signed', statusREJECTED: 'Rejected', statusCANCELLED: 'Cancelled',
    expired: 'Expired',
    expiredHint: 'The link has expired — the parent cannot sign. Resend it (a new link and a new deadline are issued).',
    expiresAt: 'Link expires at', viewedAt: 'Opened by parent at', notViewed: 'Not opened yet',
    answeredAt: 'Answered at', waitingDays: 'waiting {{n}} day(s)',
    signedAt: 'Signed at', signer: 'Signed by', signature: 'Signature', signatureNone: 'No signature',
    signedVia: 'Signing method', viaApp: 'Mobile app', viaToken: "Public link", rejectedVia: 'Rejection method',
    rejectedAt: 'Rejected at', rejectReason: 'Rejection reason', parentData: 'Data entered by the parent',
    cancelledAt: 'Cancelled at', cancelReason: 'Cancellation reason', cancelledBy: 'Cancelled by', createdBy: 'Created by',
    terms: 'Contract terms', period: 'Validity period',
    compareTitle: 'School data ↔ parent data', field: 'Field', schoolValue: 'School', parentValue: 'Parent', changed: 'changed',
    auditTitle: 'Audit', device: 'Device / browser',
    frozenCopy: 'Frozen copy', frozenYes: 'Stored ({{at}})', frozenNo: 'Not stored — the document is rebuilt every time',
    downloadsLeft: "Downloads left (public link)",
    downloadsLeftHint: "This limit applies ONLY to the public link. There is no limit for the parent in the app or for the school archive.",
    details: 'Details', detailsTitle: 'Contract details',
    link: 'Parent link', openLink: 'Open link', address: 'Address', notFilled: 'The parent has not filled in the data yet',
    openLinkWarn: 'This link is meant for the parent. Signing on their behalf has no legal force — open it only to verify or to share it.',
    loadError: 'Could not load the contracts.', detailLoadError: 'Could not load the contract details.', retry: 'Retry',
    download: 'Download DOCX', downloadFailed: 'Could not download the document',
    resend: 'Resend', resendTitle: 'Resend the contract',
    resendHint: "A new link and a new deadline are issued and the parent is notified again in the app. THE OLD LINK stops working. A rejected contract returns to the \"Sent\" status.",
    resendNewLink: 'New link ready', resendNotified: "The parent was notified in the app.",
    resendNotNotified: "No parent account is linked — share the new link below with the parent yourself.",
    resendDone: 'Contract resent', resendDoneNoApp: "New link created (parent is not in the app)",
    resendFailed: 'Could not resend',
    cancelAction: 'Cancel contract', cancelTitle: 'Cancel the contract',
    cancelHint: "Once cancelled the parent's link stops working IMMEDIATELY and the reason is shown to them. This cannot be undone — create a new contract if needed.",
    cancelReasonLabel: 'Cancellation reason', cancelReasonPlaceholder: 'Write the reason — it will be shown to the parent',
    cancelReasonRequired: 'Write the reason (at least 3 characters)', cancelDone: 'Contract cancelled', cancelFailed: 'Could not cancel',
  },
  contractsPage: {
    emptyFiltered: 'Filters are hiding the results',
    emptyFilteredDesc: 'Active filters: {{list}}. Clear them to see all contracts.',
    search: 'Number, student or parent name...',
    exportCsv: 'Download CSV (all pages)',
    exportAllHint: 'Downloads ALL contracts matching the current filter, not just the open page. It may take a while for large lists.',
    exportTruncated: 'Too many rows: only the first {{n}} of {{total}} were exported. Narrow the filter.',
    exportFailed: 'Export failed — please try again',
    pendingQuick: 'Awaiting response',
    filterExpiry: 'Deadline', expiredOnly: 'Expired', notExpired: 'Not expired',
    studentFilter: 'By student',
    colWaiting: 'Waiting (days)', stale: 'over {{n}} days',
    colLastSent: 'Last sent', lastSentAt: 'Counted from the last send: {{at}}',
    sortNewest: 'Newest contracts', sortLongestWaiting: 'Longest waiting',
    sortNumberDesc: 'Number (desc)', sortNumberAsc: 'Number (asc)',
    sortSigned: 'Signing date', sortExpiringSoon: 'Expiring soon', sortStatus: 'Status',
    activeFilters: 'Active filters', clearAll: 'Clear all', removeFilter: 'Remove filter',
    searchChip: 'Search: {{q}}',
  },
  paymentsPage: {
    selectStudent: 'Select a student', paymentAccepted: 'Payment recorded', totalRevenue: 'Total revenue', paymentsCount: 'Payments count',
    searchPlaceholder: 'Student name or note...', sortAmountDesc: 'Amount (high)', sortAmountAsc: 'Amount (low)',
    method: 'Method', methodCash: 'Cash', methodCard: 'Card', methodTransfer: 'Transfer', methodOther: 'Other',
    studentSearchPlaceholder: 'Search by name...', amountSom: 'Amount (UZS)', paymentMethod: 'Payment method',
    dateFrom: 'Date from', dateTo: 'Date to', dateTimePlaceholder: 'dd.mm.yyyy hh:mm',
    forMonth: 'For month', classFilter: 'Class',
    forMonthRequired: 'Select the month this payment is for — without it the payment will not reduce the debt or appear in the revenue report',
    noMatch: 'No payments match the filter',
    forMonthRangeHint: '"For month" and the payment date range apply TOGETHER: the month is which month the payment belongs to, the range is when it was received. If they do not overlap the list comes back empty.',
    clearRange: 'Clear date range',
    monthCount: 'Number of months', monthsN: '{{count}} mo.', notePlaceholder: 'E.g. 4-month advance payment',
    splitPreview: '{{from}} — {{to}}: the amount is split across months, ≈ {{each}} per month. One receipt is issued.',
    edit: 'Edit', editTitle: 'Edit payment', note: 'Note', editSaved: 'Payment updated',
    editReason: 'Reason for the change', editReasonPlaceholder: 'E.g. the cashier entered the wrong amount', editReasonRequired: 'Enter a reason',
    editFinancialHint: 'Because the amount, month, method or date changed, the original payment will be closed as a refund and a corrected new payment recorded. The old receipt becomes void — a new one is issued.',
    badgeStorno: 'Refund', badgeReversed: 'Refunded',
  },
  receipt: {
    title: 'Payment receipt', no: 'Receipt No. {{no}}', school: 'School', date: 'Date', student: 'Student', class: 'Class',
    forMonth: 'For month', method: 'Payment method', note: 'Note', issuedBy: 'Received by',
    thanks: 'Thank you for your payment!', printedAt: 'Printed: {{at}}',
    print: 'Print', close: 'Close', open: 'Receipt', notFound: 'Receipt not found',
  },
  faceLink: {
    none: 'Not linked', manage: 'Link FACE ID', title: 'Link to FACE ID terminal',
    pickHint: 'Pick a record that exists on the device but is not linked to anyone. ★ — the name looks like this employee.',
    pickPlaceholder: 'Pick a device record', noFree: 'No free records', link: 'Link', or: 'or',
    enrollHint: 'If the employee is not on the device at all — write them to the terminal as a new record. They then register their face at the terminal.',
    enroll: 'Write to terminal', unlink: 'Unlink',
    linked: 'Linked', linkedRestored: 'Linked — attendance for the last {{count}} day(s) restored', unlinked: 'Unlinked',
    enrollQueued: 'Queued — No. {{no}}. It will be written to the terminal when the agent runs',
    pendingHint: 'Queued — the agent has not written it to the terminal yet', okHint: 'Linked, face is on the terminal — attendance is recorded automatically.',
    noFaceHint: 'Linked, but the face is not registered yet — the employee should register their face at the terminal.',
  },
  faceid: {
    pickStaff: 'Pick staff member', linked: 'Linked',
    setHttpHost: 'Point terminal at server',
    setHttpHostHint: 'Press once. After that the device sends every scan to the server itself — nothing needs to stay running at the school.',
    subtitle: 'Face recognition terminal — attendance and control',
    autonomyNote: 'This page does NOT need to be open for attendance to be collected. The terminal sends every scan to the server itself: if someone passes at 07:12, the record arrives stamped 07:12 — regardless of who opens the panel or when.',
    connectTitle: 'Connect to terminal',
    connectHint: "The device's local address and admin password. Stored on the server only.",
    defaultName: 'Main entrance',
    settings: 'Settings',
    name: 'Name', host: 'IP address', port: 'Port', username: 'Login', password: 'Password',
    passwordKeep: 'Leave empty to keep the current password',
    nameRequired: 'Enter a name', hostRequired: 'Enter an IP address', passwordRequired: 'Enter a password',
    chooseTerminal: 'Terminal',
    loadError: 'Could not load the terminal data — please try again.',
    status: 'Status', online: 'Online', offline: 'Offline',
    lastSeen: 'Last contact', lastSync: 'Last sync',
    peopleCount: 'On device', eventCount: 'Events',
    enabled: 'Terminal enabled',
    enabledHint: 'When off, nothing is accepted from the device',
    attendanceEnabled: 'Face attendance',
    attendanceEnabledHint: 'When off, events are stored but not written to attendance — switch to manual entry',
    syncPeople: 'Sync people', syncEvents: 'Pull events', ping: 'Test connection',
    syncHint: 'These run through the on-site agent — it picks the task up from the queue once running.',
    taskCancel: 'Cancel',
    taskCancelled: 'Task cancelled',
    agentLastSeen: 'Agent last ran at {{time}}',
    agentsTitle: "Agents (school computers)",
    agentsHint: "The agent is a small program that delivers panel commands to the terminal. Install it on 2–3 computers on the school network: whichever is on will process the queue.",
    agentsEmpty: "The agent is not installed on any computer yet — commands will pile up in the queue.",
    agentComputer: "Computer",
    agentState: "Status",
    agentTerminal: "Terminal",
    agentVersion: "Version",
    agentSeen: "Last contact",
    agentOnline: "Online",
    agentOffline: "Offline",
    terminalVisible: "Visible",
    terminalHidden: "Not visible",
    terminalUnknown: "Unknown",
    terminalHiddenHint: "The computer is not on the school network or the terminal is off — this agent gets no commands",
    appDownload: "Download SATA Agent (Windows)",
    appVersion: "Version {{v}}",
    appNotReleased: "The SATA Agent installer has not been released yet — contact the SATA administrator.",
    appLinkError: "Could not get the installer link.",
    appStep1: "On a school computer (Windows 10/11), download and install the app.",
    appStep2: "In the app, enter the agent key below and press «Ulash» (connect).",
    appStep3: "From then on the panel opens by itself when the app starts. The school's first computer is approved by the SATA administrator, the next ones by the director (FACE ID → Devices).",
    agentKeyWarn: "The agent key is the school terminal's key — do not send it outside the school.",
    appKeyStaffOnly: "The agent key is provided by the director or an administrator.",
    queued: '{{count}} task(s) queued — they run when the on-site agent starts. New staff reach the terminal\'s memory after that.',
    taskQueued: 'Task queued', taskAlready: 'That task is already queued',
    peopleTitle: 'People on device', noPeople: 'Not synced yet — press "Sync people"',
    unlinkedWarn: '{{count}} people are not linked to an ERP staff member — no attendance is recorded for them',
    employeeNo: 'Number', deviceName: 'Name on device', face: 'Face', erpUser: 'ERP staff',
    faceYes: 'yes', faceNo: 'no', notLinked: 'not linked',
    tasksTitle: 'Tasks',
    noTerminalAsk: 'No terminal has been added yet. A director or administrator adds it.',
    keysTitle: 'Connection keys',
    keysHint: "The first goes into the device's HTTP Listening setting, the second into the agent.",
    ingestUrl: 'Event URL', agentKey: 'Agent key',
    remove: 'Remove terminal', removed: 'Terminal removed',
  },
  agent: {
    holat: {
      eskiVersiya: 'Old version', aloqaYoq: 'No connection', toxtatilgan: 'Paused', ishlayapti: 'Running',
      terminalYoq: 'Terminal not visible', terminalSozlanmagan: 'Terminal not configured', serverYoq: 'Server problem',
      kalitXato: 'Wrong key', tekshirilmoqda: 'Checking',
    },
    davomiylik: { daq: '{{n}} min', soat: '{{n}} h', kun: '{{n}} d' },
    eskiIzoh: 'Does not report its state — update SATA Agent to 0.1.3',
    tur: { QAYTA_ISHGA_TUSHIR: 'Restart', LOG: 'Fetch log', YANGILA: 'Update now', TOXTAT: 'Pause', DAVOM: 'Resume' },
    buyruqHolat: { KUTILMOQDA: 'Pending', YUBORILDI: 'Sent', BAJARILDI: 'Done', XATO: 'Failed', MUDDATI_OTDI: 'Expired' },
    maktab: 'School', terminal: 'Terminal', versiya: 'Version', os: 'System', ip: 'IP',
    ishgaTushgan: 'Started', oxirgiAloqa: 'Last contact', oxirgiXato: 'Last error',
    band: 'Running a command',
    buyruqlar: 'Commands',
    yangilangIzoh: 'The app on this computer is outdated and does not accept commands from the panel. Update SATA Agent to 0.1.3.',
    faqatStaff: 'Commands are issued by the director or an administrator.',
    maktabsiz: 'The terminal is not linked to a school — commands are not available for this computer.',
    tasdiqSarlavha: 'Confirm the command',
    tasdiqQayta: 'The app will restart after the current task finishes (up to 1 minute).',
    tasdiqToxtat: 'Attendance and FACE ID commands will not run on this computer.',
    buyruqYuborildi: 'Command sent — the computer will pick it up within 15 seconds',
    xTakror: 'The previous command has not finished yet — wait for its result.',
    vazifalar: 'Recent tasks', vazifaYoq: 'This computer has not run any tasks yet',
    tarix: 'Command history', tarixYoq: 'No commands yet',
    colTur: 'Type', colHolat: 'Status', colVaqt: 'Time', colKim: 'By', colNatija: 'Result', colMaktab: 'School',
    log: 'Log', logYoq: 'No log fetched yet', logBosh: 'The log is empty', logKutilmoqda: 'Waiting for the log — the computer picks up commands within 15 seconds…',
    nusxaOl: 'Copy', nusxaOlindi: 'Copied',
    yuklanmadi: "Could not load the computer's data — it is hidden so that an outdated state is not shown.",
    qatorniBosing: 'Click a row — state, tasks, log and commands',
    sahifaIzoh: 'Computers of all schools seen in the last 30 days. Problems first.',
    jami: 'Total: {{n}}', muammoli: 'With problems: {{n}}',
    bosh: 'No computers seen in the last 30 days',
    royxatYuklanmadi: 'Could not load the computer list — it is hidden so that outdated states are not shown.',
    qaytaUrinish: 'Try again',
  },
  staffAttendance: {
    title: 'Staff attendance', date: 'Date', staff: 'Staff member', role: 'Role',
    in: 'In', out: 'Out', markIn: 'Mark in', markOut: 'Mark out', done: 'Complete',
    manual: 'Manual',
    summary: '{{kelgan}} of {{jami}} present',
    searchPlaceholder: 'Name or role...',
    undoOut: 'Undo check-out (arrival time stays)',
    restDay: 'Rest day — attendance is not recorded',
    undone: 'Check-out undone',
    found: '{{topilgan}} of {{jami}} found',
    empty: 'No active staff',
    addTitle: 'Mark attendance', editTitle: 'Edit attendance',
    markWithTime: 'Mark with time', edit: 'Edit',
    saved: 'Saved', deleted: 'Record deleted', delete: 'Delete', deleteConfirm: 'Really delete?',
    outBeforeIn: 'Check-out must be after check-in',
    outHint: 'Leave check-out empty if the staff member is still at work.',
    cellHint: 'Click a cell to mark or correct check-in/out for that day',
    range: 'Date range', thisWeek: 'This week', thisMonth: 'This month', lastMonth: 'Last month',
    modeDay: 'Daily', modeMonth: 'Report', month: 'Month',
    daysIn: 'Present (days)', daysOut: 'Absent', hours: 'Hours',
    monthSummary: '{{ish}} working days, {{otgan}} passed',
    legend: 'Green — present, red — absent on a working day, grey — day off, • — not checked out yet',
    faceNote: 'When the face terminal is running, records land here on their own. Manual marking is for days the terminal is down — both write to the same table, so they never conflict.',
  },
  audit: {
    pageDesc: 'Who changed what, when, and from which address',
    logTitle: 'Action log',
    blockedTitle: 'Blocked addresses',
    blockedHint: 'Requests from these addresses are rejected',
    blockedEmpty: 'No blocked addresses',
    blockAdd: 'Block an address',
    blockWarn: 'Careful: a whole school can sit behind one external address — blocking it cuts everyone off. The attendance terminal is unaffected.',
    block: 'Block',
    unblock: 'Unblock',
    blocked: 'Address blocked',
    unblocked: 'Block removed',
    ip: 'Address (IP)',
    reason: 'Reason',
    until: 'Until',
    forever: 'No expiry',
    hits: 'Rejected',
    auto: 'Automatic',
    hours: 'Hours',
    hoursHint: '0 or empty — no expiry',
    when: 'Time',
    who: 'Who',
    school: 'School',
    what: 'Action',
    status: 'Result',
    path: 'Path',
    method: 'Method',
    from: 'From',
    to: 'To',
    empty: 'No records found',
    anon: 'Unknown',
    last24: 'Last 24 hours',
    actions: 'changes',
    rejected: 'Rejected',
    rejectedHint: 'errors and blocked attempts',
    topAccount: 'Busiest account',
    status2: 'Success (2xx)',
    status4: 'Rejected (4xx)',
    status5: 'Server error (5xx)',
    allSchools: 'All schools',
    noTenant: 'Platform (no school)',
  },
  lessonTimes: {
    section: 'Lesson times',
    sectionDesc: 'Schedule hours are derived from these settings',
    start: 'First lesson',
    duration: 'Lesson (min)',
    break: 'Break (min)',
    note: 'lesson n = start + (n-1) × (lesson + break)',
  },
  workDays: {
    section: 'Working days and holidays',
    sectionDesc: 'School and attendance days. The daily rate of a monthly salary comes from «Payroll rule → Payroll working days»',
    mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',
    thisMonth: '{{oy}}: {{kun}} working days',
    holidaysExcluded: '{{n}} holidays excluded',
    holidays: 'Holidays and days off',
    holidaysEmpty: 'No dates marked in {{yil}}',
    date: 'Date',
    name: 'Name',
    namePlaceholder: 'Navruz, Independence Day...',
    note: 'This setting affects:',
    affects: 'student and staff attendance',
  },
  backup: {
    connectedTo: 'Connected chat:',
    hour: 'Time', hourHelp: 'Tashkent time',
    exactAt: 'Exact time: {{time}}',
    tokenConnected: 'Bot connected',
    tokenReplace: 'Connect a different bot',
    section: 'Backup',
    openHint: 'Daily backup via Telegram — open to configure',
    on: 'On',
    warning: 'WARNING: a wrong chat_id sends ALL of the school data to a stranger\'s channel. Check the channel and the bot carefully.',
    token: 'Bot token', tokenSet: 'set', tokenNone: 'not set',
    tokenKeep: 'Leave empty to keep the current token',
    tokenHelp: 'Get it from @BotFather. The bot must be an admin of the channel.',
    tokenBad: 'Invalid token format (123456:ABC-...)',
    chatId: 'Chat ID', chatHelp: 'Channel id (-100...) or @channel_name',
    chatBad: 'Must be a number or @channel',
    daily: 'Every day', dailyHint: 'In the evening, Tashkent time',
    testSend: 'Send now', sent: 'Sent',
    remove: 'Remove configuration', removed: 'Backup configuration removed',
    lastAt: 'Last',
    scopeNote: 'The file contains ONLY this school\'s data — passwords and keys are excluded. Name:',
  },
  export: {
    tooltip: 'Download the WHOLE list for the current filter as Excel',
    empty: 'Nothing to export',
    done: '{{rows}} rows exported',
    doneSheets: '{{rows}} rows across {{sheets}} sheets (by quarter)',
  },
  pager: {
    range: '{{from}}–{{to}} of {{total}}',
    perPage: 'Rows per page', page: 'page',
  },
  parentsPage: {
      add: 'Add parent', addHint: 'The profile opens after creation — link children there.',
    searchPlaceholder: 'Name or phone...', sortPremium: 'Premium expiry', regular: 'Regular', giftsSentReceived: 'Gifts (sent/received)',
  },
  announcementsPage: {
    bodyRequired: 'Enter the body', selectScreen: 'Select a screen', fullUrlRequired: 'Enter a full URL (https://...)', posted: 'Announcement posted',
    searchPlaceholder: 'Title or text...', sortNew: 'Newest announcements', audienceTo: 'Audience', classNamed: 'Class: {{name}}', appNamed: 'App: {{screen}}',
    titleUz: 'Title (Uzbek)', bodyUz: 'Body (Uzbek)', translations: 'Translations (optional — ru/en)',
    titleRu: 'Title (Russian)', bodyRu: 'Body (Russian)', titleEn: 'Title (English)', bodyEn: 'Body (English)',
    whichClass: 'Which class', linkOptional: 'Link (optional)', linkNone: 'No link', linkApp: 'In-app screen', linkUrl: 'External link',
    appScreenLabel: 'App screen', selectScreenPlaceholder: 'Select a screen', url: 'URL', post: 'Post',
    class: 'Class',
  },
  supportPage: {
    back: 'Back',
    title: 'Support — chat with users', searchPlaceholder: 'Name or phone...', noMessages: 'No messages',
    emptyDesc: 'Messages from users will appear here.', youPrefix: 'You: ', selectThread: 'Select a chat', replyPlaceholder: 'Type a reply...',
    unreadOnly: 'Unread only',
    noMatch: 'No conversations found', noMatchDesc: 'Change the search query or filter.',
  },
  premiumPage: {
    title: 'Premium gifts', subManage: 'subscription management is on the Parents page', searchPlaceholder: 'Sender or recipient...', sortMonthsDesc: 'Duration (longest)',
    anonymity: 'Anonymity', anonymous: 'Anonymous', open: 'Open', from: 'From', to: 'To', duration: 'Duration', greeting: 'Greeting', sentAnon: 'sent anonymously', months: '{{n}} mo.',
    emptyTitle: 'No gifts', emptyDesc: 'Premium gifts sent between parents will appear here.',
    errorTitle: 'Could not load the data', errorDesc: 'No access to the Premium gifts list, or the server did not respond.',
  },
  attPage: {
    tabStudents: 'Students', tabStaff: 'Staff',
    saveError: 'Failed to save — please try again', searchStudent: 'Search student', namePlaceholder: 'Name...',
    selectClassToMark: 'Select a class to mark attendance', selectDateToMark: 'Select a date', noStudentsInClass: 'No students in this class', saved: 'Saved',
    restDay: 'Rest day — attendance is not recorded',
    loadError: 'Could not load the attendance — the list is hidden because the statuses could be wrong.', retry: 'Retry',
  },
  gradesPage: {
    selectStudent: 'Select a student', selectSubject: 'Select a subject', gradeRange: 'Grade must be between 1 and 5', gradeAdded: 'Grade added',
    addGrade: 'Add grade', searchPlaceholder: 'Student name...', sortValueDesc: 'Grade (high)', sortValueAsc: 'Grade (low)',
    selectClassToView: 'Select a class to view grades', noGrades: 'No grades', grade: 'Grade', term: 'Term', gradeValue: 'Grade (1-5)',
    period: 'Period', periodAll: 'All', periodDay: 'Daily', periodWeek: 'Weekly', periodMonth: 'Monthly', allSubjects: 'All subjects',
    student: 'Student', dateFrom: 'Date from', dateTo: 'Date to', termN: 'Term {{n}}',
    teacher: 'Teacher',
    actions: 'Actions', edit: 'Edit grade', editSaved: 'Grade updated',
    deleteGrade: 'Delete grade', deleted: 'Grade deleted',
    comment: 'Comment', date: 'Date', selectTerm: 'Select a term',
    noTermSet: 'Not linked to a term',
    onlyOwnGrade: 'Another teacher gave this grade — it cannot be edited',
    termsError: 'The term list failed to load — showing the previous list',
    termsHint: 'Terms are configured under "Academic year and terms"',
  },
  terms: {
    title: 'Academic year and terms',
    subtitle: 'A term belongs to an academic year — when a grade is added, its term is derived from the date automatically.',
    tabYears: 'Academic years', tabTerms: 'Terms', retry: 'Retry',
    yearsTitle: 'Academic years', addYear: 'New academic year', editYear: 'Edit academic year',
    yearName: 'Name', yearNameHint: 'For example: 2026-2027', yearStart: 'Starts', yearEnd: 'Ends',
    yearColumn: 'Academic year', selectYear: 'Select an academic year',
    makeActive: 'Make active', active: 'Active',
    activeHint: 'Only ONE academic year can be active — activating another one turns the current one off automatically.',
    nameRequired: 'Enter a name',
    yearCreated: 'Academic year added', yearUpdated: 'Academic year updated', yearDeleted: 'Academic year deleted',
    yearActivated: '{{name}} is now the active academic year',
    yearsEmpty: 'No academic years',
    yearsEmptyDesc: 'Add the first academic year — classes, terms and the electronic journal all hang off it.',
    yearsLoadError: 'Could not load the academic years',
    yearInUse: 'Classes are linked to this academic year — move or delete them first.',
    noActiveYear: 'No active academic year',
    noActiveYearDesc: 'The journal, terms and reports all work off the active year — pick one with "Make active".',
    activeNoClasses: 'The active academic year ({{name}}) has no classes',
    activeNoClassesDesc: 'The classes may have stayed in another academic year. Add a class under "Classes", or activate the year that holds them.',
    goToClasses: 'Go to classes',
    termsTitle: 'Terms', addTerm: 'New term', editTerm: 'Edit term',
    termName: 'Term name', termIndex: 'Order', termIndexHint: '1 to 4 — used for sorting and term results',
    termStart: 'Starts', termEnd: 'Ends', currentTerm: 'Current',
    termCreated: 'Term added', termUpdated: 'Term updated', termDeleted: 'Term deleted',
    termsEmpty: 'No terms added',
    termsEmptyDesc: 'Without terms the electronic journal, term results and the grade report do not work. Start with "New term".',
    termsLoadError: 'Could not load the terms',
    termsNeedYear: 'Add an academic year first — a term belongs to a year.',
    termOverlap: 'The term dates overlap another term, or this order number is taken.',
    termInUse: 'Grades are linked to this term — move or delete them first.',
    datesRequired: 'Select the start and end dates',
    endAfterStart: 'The end date must be after the start date',
  },
  journal: {
    periodAvg: 'Period average',
    periodGrade: 'Period grade',
    period: 'Period',
    period7: 'Last 7 days',
    period14: 'Last 14 days',
    period30: 'Last 30 days',
    periodTerm: 'Whole term',
    periodCustom: 'Pick dates',
    showAll: 'Show the whole term',
    dateFrom: 'From date',
    dateTo: 'To date',
    dateFilterNote: 'The date filter only narrows the view — the average and suggested grade still cover the whole term.',
    pageTitle: 'Electronic journal',
    pageSubtitle: 'Pick a class, a subject and a term — the journal, bulk grading, term results and the report all work off that selection.',
    title: 'Journal',
    tabMatrix: 'Journal', tabBulk: 'Bulk grades', tabTerm: 'Term results', tabReport: 'Report',
    student: 'Student', avg: 'Average', termGrade: 'Term grade',
    selectFilters: 'Select a class, a subject and a term',
    scrollHint: 'The table is wide — scroll it horizontally to see the dates.',
    loadError: 'Could not load the journal',
    empty: 'No grades for this subject in this term',
    emptyDesc: 'Grade the whole class under "Bulk grades", or click a journal cell.',
    noStudents: 'No students in this class',
    noStudentsDesc: 'Add a student under "Students" first and assign them to this class.',
    cellEmpty: 'No grades on this day',
    addGrade: 'Add grade',
    termNotSet: 'Not set',
    suggestion: 'System suggestion: {{n}}',
    noTerms: 'No terms configured',
    noTermsDesc: 'The electronic journal does not work without terms — set up the academic year terms first.',
    goToTerms: 'Configure terms',
    setupNoClasses: 'No classes',
    setupNoClassesDesc: 'The journal opens per class — add a class first.',
    setupNoSubjects: 'No subjects',
    setupNoSubjectsDesc: 'A grade is given for a subject — add a subject first.',
    goToSubjects: 'Go to subjects',
    goToYears: 'Add an academic year', goToClasses: 'Go to classes',
    selectFiltersDesc: 'Pick a class and a subject in the bar above — the journal opens for that selection.',
    termGradeStale: 'The term grade is frozen; new grades were added after it — current suggestion: {{n}}',
    askAdmin: 'You do not have access to that section — ask an administrator to set it up.',
    stepYears: '1. Academic year', stepTerms: '2. Terms', stepClasses: '3. Classes', stepSubjects: '4. Subjects',
    setupNoYears: 'No academic years',
    setupNoYearsDesc: 'Everything starts with the academic year — terms, classes and the journal all hang off it.',
    setupNoTerms: 'No terms',
    setupNoTermsDesc: 'A grade is tied to a term — set up the academic year terms.',
  },
  bulkGrades: {
    title: 'Bulk grading',
    desc: 'Pick a date and fill the whole list on one screen. Students left blank get no grade.',
    date: 'Date', value: 'Grade', comment: 'Comment', commentPlaceholder: 'Optional comment',
    save: 'Save grades',
    saved: '{{saved}} grades saved',
    savedSkipped: '{{saved}} grades saved, {{skipped}} skipped',
    nothingToSave: 'Set at least one grade',
    selectFilters: 'Select a class and a subject first',
    filled: '{{n}} filled in', fillAll: 'All {{n}}',
    clear: 'Clear', clearOne: 'Remove grade',
    loadError: 'Could not load the student list',
    appendHint: 'Saving ADDS grades, it does not replace earlier ones — a day can hold several grades. Saving twice creates two grades.',
  },
  termSummary: {
    title: 'Term results',
    desc: 'The system averages the current grades and SUGGESTS a value — the teacher sets the final term grade, and it is stored frozen.',
    gradeCount: 'Grade count', suggested: 'Suggested', finalGrade: 'Term grade',
    confirm: 'Confirm', confirmAll: 'Apply the suggestion to everyone',
    saved: 'Term grades saved',
    cancelGrade: 'Cancel term grade', cancelled: 'Term grade cancelled',
    changed: 'Differs from the suggestion', changedHint: 'The system suggested {{n}}',
    alreadySet: 'Set', pending: 'Not confirmed',
    noSuggestion: 'No suggestion — no current grades in this term',
    nothingToSave: 'Set at least one term grade',
    empty: 'No data',
    emptyDesc: 'No students found for the selected class, subject and term.',
    loadError: 'Could not load the term grades',
    needTerm: 'Term results need a class, a subject and a term — all three.',
    notAssigned: 'This subject is not assigned to you',
    notAssignedDesc: 'Term grades can only be set for a subject assigned to you — being a homeroom teacher is not enough. Ask an administrator to add the assignment under "Schedule and assignments".',
    stale: 'Suggestion is stale',
    staleHint: 'The suggestion was {{old}} when it was saved, now it is {{now}} — new grades were added after the term grade.',
  },
  gradeReport: {
    title: 'Grade report',
    gradeCount: 'Grade count', avg: 'Average', termGrade: 'Term grade',
    summaryAvg: 'Overall average', graded: 'Graded', gradedHint: 'With a term grade / total students',
    excellent: 'Excellent (5)', good: 'Good (4)', satisfactory: 'Satisfactory (3)', poor: 'Poor (2)',
    empty: 'No data for the report',
    emptyDesc: 'No grades found for the selected class, subject and term.',
    loadError: 'Could not load the report',
    summaryAvgHint: 'Across term grades (not the current ones)',
  },
  rankingPage: {
    scopeClass: 'Within class', scopeParallel: 'Parallel', scopeSchool: 'Whole school',
    schoolHint: 'No class selected — showing the whole-school ranking.',
    scopeNeedsClass: 'Select a class first to use the “Within class” and “Parallel” scopes.',
    periodInfo: 'Scoring period: last {{days}} days',
    weightsInfo: 'Subjects {{grades}}% · Attendance {{attendance}}% · Behavior {{behavior}}% · Tests {{exams}}% · Homework {{homework}}%',
    colRank: '#', colStudent: 'Full name', colClass: 'Class', colBall: 'Final score',
    colGrades: 'Subjects', colAttendance: 'Attendance', colBehavior: 'Behavior', colExams: 'Tests', colHomework: 'Homework',
    colAdjust: 'Adjustment',
    tipCount: 'Records: {{count}}', tipAvg: 'Average: {{avg}}', tipNoData: 'No data for this area',
    avgGrade: 'Average grade', gradeCount: 'Grade count',
    empty: 'No ranking data', totalStudents: 'Total students: {{count}}',
    settings: 'Settings', settingsTitle: 'Ranking settings',
    weightGrades: 'Subjects weight', weightAttendance: 'Attendance weight', weightBehavior: 'Behavior weight',
    weightExams: 'Tests weight', weightHomework: 'Homework weight', periodDays: 'Scoring period (days)',
    weightsSum: 'Sum of weights: {{sum}}',
    normalizeHint: 'The sum does not have to be exactly 100 — weights are normalized automatically.',
    settingsSaved: 'Settings saved',
    adjust: 'Adjustment', adjustTitle: 'Manual adjustment (bonus / penalty)',
    delta: 'Points (+ bonus / − penalty)', deltaHint: 'From -100 to 100, cannot be 0',
    deltaRequired: 'Points must be a non-zero integer (-100..100)',
    reason: 'Reason', reasonPlaceholder: 'For example: olympiad winner',
    adjustAdded: 'Adjustment added', adjustDeleted: 'Adjustment deleted',
    adjustList: 'Current adjustments', noAdjust: 'No adjustments',
    search: 'Student name...', period7: 'Last 7 days', period30: 'Last 30 days', period90: 'Last 90 days', limitWarning: 'Showing only the first {{n}} students', showLimit: 'Show limit',
    shownOf: 'Showing {{shown}} / {{total}}',
    saveError: 'Save failed — please try again',
  },
  behaviorPage: {
    tabCriteria: 'Criteria', tabGrade: 'Give a score',
    addCriterion: 'Add criterion', editCriterion: 'Edit criterion',
    criterionName: 'Criterion name', criterionNamePlaceholder: 'For example: actively took part in class',
    points: 'Points', pointsHint: 'From -10 to 10 (negative = penalty)', order: 'Order', isActive: 'Active',
    active: 'Active', inactive: 'Archived',
    nameRequired: 'Enter a criterion name', pointsRange: 'Points must be between -10 and 10',
    criterionSaved: 'Criterion saved', criterionDeleted: 'Criterion deleted',
    criterionArchived: 'The criterion has scores — it was archived instead of deleted',
    noCriteria: 'No criteria', showArchived: 'Include archived',
    readOnlyHint: 'Only management can edit criteria.',
    selectClass: 'Class', selectClassFirst: 'Select a class first',
    students: 'Students', selectStudents: 'Select students',
    selectAll: 'Select all', clearAll: 'Clear selection',
    criterion: 'Criterion', value: 'Points (optional)',
    valueHint: 'If left empty, the criterion’s own points are used',
    note: 'Note', date: 'Date', submit: 'Give score', saved: 'Behavior score recorded',
    studentsRequired: 'Select at least one student', criterionRequired: 'Provide a criterion or points',
    recent: 'Latest scores', noRecords: 'No scores',
    colStudent: 'Student', colClass: 'Class', colCriterion: 'Criterion', colValue: 'Points', colNote: 'Note', colDate: 'Date', colBy: 'Given by',
    deleted: 'Score deleted', noCriterion: 'No criterion',
    student: 'Student', positive: 'Positive (+)', negative: 'Negative (−)', dateFrom: 'Date from', dateTo: 'Date to', sortDateDesc: 'Date (newest)', sortValueDesc: 'Points (high)',
    sortDateAsc: 'Date (oldest)', sortValueAsc: 'Points (low)', sortOrder: 'By order',
    allClasses: 'All classes', allStudents: 'All students', allCriteria: 'All criteria', allSigns: 'Positive | Negative', dateRange: 'Date range',
    saveError: 'Save failed — please try again',
  },
  examsPage: {
    add: 'Add exam', edit: 'Edit exam',
    examTitle: 'Exam title', titlePlaceholder: 'For example: English — week 1 test',
    subject: 'Subject', class: 'Class', date: 'Date', maxScore: 'Max score',
    allSchool: 'Whole school', allClasses: 'All classes', allSubjects: 'All subjects',
    scoresCount: 'Scores entered',
    titleRequired: 'Enter an exam title', maxScoreRange: 'Max score must be between 1 and 1000',
    examSaved: 'Exam saved', examDeleted: 'Exam deleted',
    noExams: 'No exams',
    enterScores: 'Enter scores', scoresTitle: 'Test scores',
    selectClassForScores: 'Select a class to enter scores',
    student: 'Student', score: 'Score', comment: 'Comment',
    noStudents: 'No students in this class',
    scoresSaved: 'Scores saved ({{saved}})',
    noPermission: 'Only management or an examining teacher can enter test exam scores.',
    scoreRange: 'Score from 0 to {{max}}',
    testTeacher: 'Examining teacher',
    testTeacherHint: 'This teacher can enter test exam scores',
    testTeacherUpdated: 'Saved',
    searchPlaceholder: 'Exam title...', sortDateDesc: 'Date (newest)', sortDateAsc: 'Date (oldest)',
    allExams: 'All exams', ungraded: 'Scores not entered', dateRange: 'Date range', searchStudent: 'Search student...',
    saveError: 'Save failed — please try again',
    tabList: 'Exams', tabHistory: 'History',
    classes: 'Classes', selectClasses: 'Select classes',
    classesHint: 'Leave empty for a whole-school exam',
    teacher: 'Examiner', allTeachers: 'All teachers', noTeacher: 'Not assigned',
    myExams: 'My exams',
    tooManyClasses: 'Select at most {{max}} classes',
  },
  examHistory: {
    exams: 'Exams', scores: 'Scores entered', avgPercent: 'Average result',
    empty: 'No exams in history', scored: 'Scored', result: 'Result',
    best: 'Best', worst: 'Worst', noScores: 'No scores entered',
    enteredBy: 'Entered by', editedBy: 'Edited by',
    openAudit: 'Score entry history', auditTitle: 'Score entry audit',
    notEdited: 'Not edited',
    sortCreatedDesc: 'Created (newest)', sortUpdatedDesc: 'Edited (newest)',
    sortEnteredDesc: 'Entered (newest)', sortScoreDesc: 'Score (high)', sortScoreAsc: 'Score (low)',
  },
  schedulePage: {
    lessonNo: 'Lesson number',
    lessonNoHint: 'Time is automatic — from the schedule settings',
    selectSubject: 'Select a subject', selectTeacher: 'Select a teacher', lessonAdded: 'Lesson added', assigned: 'Assigned',
    selectClassToStart: 'Select a class to start', scheduleTab: 'Schedule', assignTab: 'Assign teacher', assignTitle: 'Assign a teacher',
    addLesson: 'Add lesson', emptySchedule: 'Schedule is empty', day: 'Day', time: 'Time', room: 'Room', lesson: 'lesson', noAssignments: 'No assignments',
    startTime: 'Start', endTime: 'End', assign: 'Assign',
    allDays: 'All', emptyDay: 'No lessons on this day',
    planningNotice: '{{year}} is not the active academic year: the schedule is entered in advance for that year and does not affect the current one.',
    noClassesInYear: 'No classes in this academic year yet — create them on the Classes page first.',
  },
  classesPage: {
    searchPlaceholder: 'Class name...', sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)', sortNewest: 'Newest classes', searchTeacher: 'Search teacher...',
    academicYear: 'Academic year', sortStudentsDesc: 'Students count (high)',
  },
  subjectsPage: {
    searchPlaceholder: 'Subject name or code...', sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)', sortNewest: 'Recently added',
    nameUz: 'Subject name (Uzbek)', nameRu: 'Russian name', nameEn: 'English name',
    icon: 'Icon', iconAuto: 'Default (based on subject name)',
    iconHint: 'Leave unset — a matching icon is picked automatically from the subject name',
  },
  subjectIcon: {
    calculator: 'Calculator', atom: 'Atom', flask: 'Flask', dna: 'DNA', globe: 'Globe',
    book: 'Book', language: 'Language', code: 'Code', palette: 'Palette', music: 'Music',
    dumbbell: 'Dumbbell', hammer: 'Hammer', brain: 'Brain', chart: 'Chart', map: 'Map',
    history: 'History', shield: 'Shield', heart: 'Heart', leaf: 'Leaf', star: 'Star',
  },
  salaryType: { FIXED: 'Fixed monthly', PER_LESSON: 'Per lesson', HOURLY: 'Hourly' },
  legal: {
    section: 'Legal', back: 'Back', updated: 'Last updated', more: 'Learn more', accept: 'Got it',
    terms: 'Terms of Use', privacy: 'Privacy Policy', cookies: 'Cookie Policy',
    cookieTitle: 'Cookies & local storage',
    cookieText: 'We use browser storage (essential) to keep you signed in. No advertising or tracking cookies are used.',
  },
  deleteAccount: {
    navLabel: 'Delete account',
    title: '{{app}} — delete account',
    developer: 'Developer: {{dev}}',
    intro: 'On this page you can request deletion of your {{app}} account (parent or teacher). Your login and password were issued by your school.',
    inAppTitle: 'How to delete in the app',
    inAppSteps: 'Open the {{app}} app → Profile → Account → “Delete account” → enter your password and confirm.',
    formTitle: 'Request without the app',
    formHint: 'If the app is uninstalled or does not open, send the request here with your login and password. The password confirms that the account is yours.',
    login: 'Login',
    password: 'Password',
    reason: 'Reason (optional)',
    reasonPlaceholder: 'Why do you want to delete it? The school administration will see this',
    confirm: 'I understand: once the request is sent, I can no longer sign in',
    submit: 'Send deletion request',
    required: 'Required',
    confirmRequired: 'Please confirm',
    successTitle: 'Request received',
    successText: 'Your account has been closed. The school administration will complete the request within 30 days and your data will be deleted as described below.',
    errWrong: 'Incorrect login or password',
    errRole: 'For this account type (school staff), deletion is requested through the school administration.',
    errLimit: 'Too many attempts. Please try again in 15 minutes.',
    errGeneric: 'Could not send. Check your connection and try again.',
    timingTitle: 'Timing',
    timingText: 'As soon as the request is sent, the account is closed: you cannot sign in and notifications stop. The school administration completes the request within 30 days. If the school declines it with a reason, the account returns to its previous state and you receive a message with the reason.',
    deletedTitle: 'What is deleted',
    deletedItems: [
      'Login and password',
      'Full name, phone, gender, date of birth, Telegram ID',
      'Profile photo',
      'Additional phone numbers and addresses',
      'Push notification tokens and in-app notifications',
      'Support chat messages',
    ],
    keptTitle: 'What stays as school records',
    keptItems: [
      'Your child’s grades, attendance, payments and contracts (with the details in a signed contract) and the parent contact on the student card',
      'If you are a teacher: grades you gave, homework, schedule, salary and working-time records',
      'These records show “O‘chirilgan foydalanuvchi” (deleted user) instead of your name',
      'Security (audit) log — deleted automatically after 90 days; backups — until they are cleaned up',
      'A staff member’s FACE ID terminal record — removed separately by the school administration',
    ],
    childNote: 'To delete or correct your child’s (student’s) data, contact the school administration.',
    contactTitle: 'Contact',
    contactText: 'Questions: {{email}} or your school administration.',
    privacyLink: 'Privacy Policy',
  },
  deletionRequests: {
    title: 'Account deletion requests',
    subtitle: 'From parents and teachers — complete within 30 days',
    filterNew: 'New ({{n}})',
    filterAll: 'All',
    empty: 'No requests',
    loadError: 'Could not load the list',
    retry: 'Retry',
    status: { NEW: 'New', DONE: 'Done', REJECTED: 'Declined' },
    source: { APP: 'From app', WEB: 'From web page' },
    requested: 'Requested: {{date}}',
    processed: 'Completed: {{date}}{{by}}',
    reason: 'Reason: {{text}}',
    rejectReasonShown: 'Decline reason: {{text}}',
    done: 'Delete',
    reject: 'Decline',
    confirmDoneTitle: 'Delete account',
    confirmDoneText: 'The account of {{name}} will be anonymised: login, password, name, phone, photo, notifications and support chat are deleted. School records (grades, attendance, payments, contracts, salary) stay under the name “O‘chirilgan foydalanuvchi” (deleted user). This cannot be undone.',
    confirmDoneOk: 'Yes, delete',
    rejectTitle: 'Decline request',
    rejectText: 'The account of {{name}} returns to its state before the request and the user can sign in again. The reason is shown to the user in a notification.',
    rejectReason: 'Decline reason (optional)',
    rejectOk: 'Decline',
    cancel: 'Cancel',
    doneOkMsg: 'Account deleted (anonymised)',
    rejectOkMsg: 'Request declined, account restored',
  },
  staffDetail: {
    workDays: 'Working days',
    workDaysWithHoliday: '{{kun}} days ({{bayram}} holidays excluded)',
    perDay: 'Pay per day',
    adjustments: 'Penalties & bonuses',
    adjustmentsEmpty: 'No adjustments this month',
    adjustmentsTotal: 'Total',
    adjustmentAdd: 'Add adjustment',
    adjustmentDate: 'For which day',
    penalty: 'Penalty',
    bonus: 'Bonus',
    reason: 'Reason',
    reasonHint: 'E.g. two hours late / delivered the monthly report early', notFound: 'Staff not found', month: 'Month', salary: 'Salary', shifts: 'Schedule', logs: 'Check in/out', history: 'History', salaryConfig: 'Salary config', salaryType: 'Salary type', monthlyAmount: 'Monthly amount', perLesson: 'Per lesson (som)', perHour: 'Per hour (som)', dailyHours: 'Daily working hours', dailyHoursHint: 'At most this many hours count per day, full hours only', hoursRule: 'At most {{n}} h per day, minutes are not counted', actualTime: 'actual time', hm: '{{h}} h {{m}} min', note: 'Note', calculation: 'Calculation', notConfigured: 'Salary not configured', lessons: 'Lessons', hours: 'Hours', computed: 'Computed', paidThisMonth: 'Paid this month', remaining: 'Remaining', paySalary: 'Pay salary', pay: 'Pay', paid: 'Salary paid', amount: 'Amount', weekday: 'Weekday', start: 'Start', end: 'End', noShifts: 'No schedule', shiftError: 'Failed to add', checkIn: 'Check in', checkOut: 'Check out', noLogs: 'No logs', date: 'Date', in: 'In', out: 'Out', worked: 'Worked', h: 'h', totalPaid: 'Total paid', noHistory: 'No history', forMonth: 'For month', fullyPaid: 'Fully paid', editLog: 'Edit log', overpay: 'Warning: exceeds remaining', openExcluded: 'open log(s) not counted in hours', plannedHint: 'planned, not actual attendance', hireDate: 'Hired', leaveDate: 'Left', prorateHint: 'full month', prorated: 'Prorated', onlyOpen: 'Only open (no check-out)', year: 'Year', allYears: 'All years', filteredTotal: 'Total for selection', noMatch: 'No records match the filter', payrollWarnNoYear: 'No active academic year — lessons were not counted (0 so\'m). Make a year active under "Academic year and terms".', payrollWarnNoClasses: 'The active academic year ({{name}}) has no classes — lessons were not counted (0 so\'m). Add a class, or activate the year that holds them.' },
  parentDetail: { account: 'Account', login: 'Login', newPassword: 'New password', passwordHint: 'Leave empty to keep the current password', loginMin: 'Login must be at least 3 characters', passwordMin: 'Password must be at least 5 characters', notFound: 'Parent not found', blocked: 'Blocked', edit: 'Edit', father: 'Father', mother: 'Mother', children: 'Children', giftsSent: 'Gifts sent', giftsReceived: 'Gifts received', messages: 'Messages', subscription: 'Subscription', until: 'until', free: 'Free plan', noChildren: 'No children linked', balanceMonth: 'Balance: {{month}}', balanceNone: 'No balance data', contacts: 'Contacts', fullName: 'Full name', phone: 'Phone', gender: 'Gender', birthDate: 'Birth date', activeAccount: 'Active account', monthsGive: 'mo. grant', cancelPremium: 'Cancel Premium', tabOverview: 'Overview', tabPayments: 'Payments', child: 'Child', paymentsTotal: 'Total paid', paymentsCount: 'Number of payments', storno: 'Refund', paymentsUnsupportedTitle: 'Payments could not be shown', paymentsUnsupported: 'The server does not support filtering by parent yet (backend update required). The list is hidden to avoid showing wrong data.' },
  att: { PRESENT: 'Present', ABSENT: 'Absent', LATE: 'Late', EXCUSED: 'Excused', filterStatus: 'Status', allStatuses: 'All statuses', sortBy: 'Sort', sortName: 'Name (A-Z)', sortStatus: 'By status', noMatch: 'No students with this status', modeMark: 'Mark', modeView: 'History', markSubtitle: 'Saved automatically when a status is selected', viewSubtitle: 'Attendance records for a date range', allClasses: 'All classes', dateRange: 'Date range', allStudents: 'All students', sortDateDesc: 'Date (newest)', sortDateAsc: 'Date (oldest)', noRecords: 'No records found', total: 'Total', student: 'Student', date: 'Date', status: 'Status', markedBy: 'Marked by', allMarkers: 'All staff', sortMarker: 'By marker' },
  notif: {
    total: 'Total', unread: 'Unread', read: 'Read', allTypes: 'All types', allStatuses: 'All statuses',
    recipient: 'Recipient', type: 'Type', message: 'Message', status: 'Status', date: 'Date',
    searchPlaceholder: 'Title, text or recipient...',
    scopeMine: 'For me', scopeUsers: 'To users', markAll: 'Mark all read', viewAll: 'View all', sortNew: 'Newest', sortOld: 'Oldest', sortType: 'By type', sortTitle: 'Title (A-Z)',
  },
  notifType: {
    ANNOUNCEMENT: 'Announcement', ATTENDANCE: 'Attendance', GRADE: 'Grade', HOMEWORK: 'Homework',
    PAYMENT: 'Payment', PREMIUM: 'Premium', SUPPORT: 'Support', SYSTEM: 'System',
  },
  login: {
    welcome: 'Welcome', subtitle: 'Enter your credentials to access the admin panel',
    loginLabel: 'Login', passwordLabel: 'Password', loginBtn: 'Sign in',
    heroTitle: 'The modern way to run your school',
    heroSubtitle: '{{school}} management platform — all processes in one place.',
    f1: 'Students, classes and attendance in one system', f2: 'Finance, reports and real-time statistics',
    f3: 'Mobile cabinet for parents and teachers', f4: 'Secure role-based permissions',
    denied: 'Access denied', deniedMsg: 'This panel is for staff only. Parents and students use the mobile app.',
    tenantInactive: 'This school is temporarily inactive. Please contact the administrator.',
    tenantNotFound: 'No such school address found. Please check the address.',
    error: 'Login error',
  },
  qurilma: {
    faqatIlovaSarlavha: 'The panel opens only through the SATA app',
    faqatIlovaMatn: 'The admin panel is accessed only through the SATA app on a school computer. Contact the SATA administrator to install the app.',
    loginParolBilan: 'Sign in with login and password',
    loginParolIzoh: 'For teachers and the platform administrator',
    havolaEskirgan: 'The link has expired. Open the panel again from the SATA app.',
    ochilmoqda: 'Opening the panel…',
    xIlovaKerak: 'The panel opens only through the SATA app',
    xBloklangan: 'This computer is blocked — contact the director',
    xKutilmoqda: "The device is awaiting the director's approval",
    xRadEtilgan: 'This computer was rejected — contact the director',
    xBoshqaMaktab: 'This computer is connected to another school',
    xSessiya: 'The panel session has expired — open the panel again from the SATA app',
    xBirinchi: "The school's first device is approved by the SATA administrator",
    xKalitKutilmoqda: 'Wait for the app to reconnect',
    xOzgardi: 'The device changed after you viewed it (it reconnected or its status changed) — the list has been refreshed, check it and try again',
    kartaSarlavha: 'Devices (panel computers)',
    kartaIzoh: 'The panel can be opened only from the SATA app on approved computers in this list.',
    bosh: 'No computer has registered yet',
    colNom: 'Computer', colTerminal: 'Terminal', colIp: 'IP', colFaollik: 'Last activity', colYaratilgan: 'Connected', colHolat: 'Status', colMaktab: 'School',
    holat: { KUTILMOQDA: 'Pending', TASDIQLANGAN: 'Approved', RAD_ETILGAN: 'Rejected', BLOKLANGAN: 'Blocked' },
    amal: { tasdiqlash: 'Approve', 'rad-etish': 'Reject', bloklash: 'Block', 'blokdan-chiqarish': 'Unblock' },
    shuKompyuter: 'this computer',
    kalitKutilmoqda: 'Waiting for the app to reconnect',
    blokdanIzoh: 'The computer will request approval again',
    tasdiqSarlavha: 'Confirm the action',
    tasdiqMatn: 'It will no longer be possible to open the panel from this computer.',
    joriyOgohlantirish: 'You are on this computer — you will be signed out of the panel. If the school has no other approved computer, only the SATA administrator can approve it again.',
    bajarildi: 'Done',
    sozlamaSarlavha: 'Platform setting',
    faqatIlovaSwitch: 'Panel only through the SATA app',
    ochirishOgohlantirish: 'All school staff will be able to sign in from a browser — turn off only in an emergency.',
    majburiyOchiq: 'Forcibly disabled by the Railway variable (PANEL_FAQAT_ILOVA_MAJBURIY_OCHIQ)',
    ulashSarlavha: 'School connection key',
    ulashIzoh: 'Enter the key in the «Connect» window of the SATA app on the school computer.',
    maktabTanlang: 'Select a school',
    kalitYoq: 'This school has no FACE ID terminal — a connection key for the panel will be created (the school will set up the terminal later).',
    kalitYarat: 'Create connection key',
    sozlanmagan: 'not configured',
    holatFiltr: 'Status',
  },
  dashboard: {
    welcome: 'Welcome', subtitle: '{{school}} — admin panel',
    students: 'Total students', active: 'active', classes: 'Classes', teachers: 'Teachers', admissions: 'Open admissions',
    revenue: 'This month revenue', revenueSub: 'For the current month', todayAttendance: "Today's attendance", present: 'Present', absent: 'Absent',
    restDay: 'Rest day — attendance is not recorded',
    qStudent: 'Add student', qAttendance: 'Take attendance', qGrade: 'Give a grade', qPayment: 'Record payment',
    genderStudents: 'Students by gender', genderStaff: 'Staff by gender', genderParents: 'Parents', boys: 'Boys', girls: 'Girls', male: 'Male', female: 'Female', fathers: 'Fathers', mothers: 'Mothers',
  },
  settings: {
    title: 'Settings', profile: 'Profile', fullName: 'Full name', login: 'Login', role: 'Role', language: 'Language',
    changePassword: 'Change password', oldPassword: 'Current password', newPassword: 'New password', confirm: 'Confirm new password',
    change: 'Change', min5: 'At least 5 characters', mismatch: "Passwords don't match", changed: 'Password changed',
    avatar: 'Profile photo', uploadAvatar: 'Upload photo', removeAvatar: 'Remove',
    avatarUpdated: 'Profile photo updated', avatarRemoved: 'Profile photo removed',
    editProfile: 'Edit', profileSaved: 'Profile saved', nothingChanged: 'No changes',
    nameMin: 'Full name must be at least {{n}} characters', nameMax: 'Full name must not exceed {{n}} characters', nameLetters: 'Full name must contain letters',
    loginMin: 'Login must be at least {{n}} characters', loginDesc: 'Used to sign in',
    currentPasswordDesc: 'You are changing your login — enter your current password', currentPasswordRequired: 'Enter your current password',
  },
  kiosk: {
    section: 'Kiosk screen',
    sectionDesc: 'A dedicated link for the TV screen in the school hallway',
    linkLabel: 'Kiosk link',
    linkHint: 'Open the link full screen in the TV browser — ranking, schedule and banners rotate automatically.',
    noLink: 'No link has been created yet. Once created, the TV screen shows the ranking, schedule and banners.',
    create: 'Create link', created: 'Kiosk link created',
    copy: 'Copy', copied: 'Copied', open: 'Open',
    regenerate: 'Regenerate', regenerateTitle: 'Regenerate the link',
    regenerateWarning: 'A new link will be created and the old one will stop working. You will need to open the new link on the TV screen again.',
    regenerated: 'Kiosk link regenerated',
    disable: 'Remove', disableTitle: 'Turn off the kiosk screen',
    disableWarning: 'The link will be removed and the TV screen will stop working. You can create a new link later.',
    disabled: 'Kiosk link removed',
    loadError: 'Could not load the kiosk link status.',
    retry: 'Retry',
  },
  supportEmail: {
    section: 'Support email',
    sectionDesc: 'Contact address shown in legal documents',
    label: 'Support email',
    placeholder: 'support@school.uz',
    hint: 'This address appears in the Terms of Use, Privacy Policy and Cookie Policy, and in the mobile app on the «Questions» line. Leave it empty to show no email.',
    invalid: 'Invalid email format (e.g. support@school.uz)',
    tooLong: 'Email must not exceed 254 characters',
    saved: 'Support email saved',
    cleared: 'Support email removed — documents show no email',
    loadError: 'Could not load the support email.',
    retry: 'Retry',
    current: 'Current: {{email}}',
    notSet: 'Not set yet — documents show no email.',
  },
  requisites: {
    section: 'Contract legal details',
    sectionDesc: 'The details printed in the contract as the school party.',
    incomplete: 'Legal details are incomplete',
    incompleteHint: 'Until the required fields are filled in, no new contract can be created and no document is generated.',
    unsaved: 'These values are not saved yet',
    unsavedHint: 'The values below are only suggestions. Check them and press "Save".',
    optionalSection: 'Optional fields',
    optional: '(optional)',
    required: 'This field is required',
    saved: 'Legal details saved',
    saveFailed: 'Could not save the legal details',
    loadError: 'Could not load the legal details.',
    retry: 'Retry',
    f: {
      schoolName: 'School name', address: 'Address', director: 'Director (full name)',
      stir: 'Tax ID (STIR)', bank: 'Bank', account: 'Bank account', mfo: 'MFO', phone: 'Phone',
      directorShort: 'Director (short form)', jurist: 'Legal counsel', city: 'City',
    },
    d: {
      schoolName: 'Full name as printed in the document — e.g. "NURLI MAKTAB" NTM',
      directorShort: 'Shown in the details block (e.g. A.A. Fathullayev). If empty, the full name is used.',
      jurist: 'If empty, this line is omitted from the document.',
      city: 'The line under the title — e.g. Namangan city.',
    },
  },
  pages: {
    students: { title: 'Students', add: 'New student', search: 'Search by name...', empty: 'No students found', emptyDesc: 'Add a student or change the search query.' },
    classes: { title: 'Classes', add: 'New class', empty: 'No classes. Add an academic year and a class first.' },
    subjects: { title: 'Subjects', add: 'New subject' },
    schedule: { title: 'Schedule & assignments' },
    attendance: { title: 'Attendance' },
    grades: { title: 'Grades / e-journal' },
    homework: { title: 'Homework' },
    ranking: { title: 'Student ranking' },
    behavior: { title: 'Behavior scores' },
    exams: { title: 'Test exams' },
    payments: { title: 'Finance / payments' },
    reports: { title: 'Reports' },
    expenses: { title: 'Expenses & salary' },
    admissions: { title: 'Admissions / CRM', add: 'New applicant' },
    contracts: { title: 'Contracts', empty: 'No contracts found', emptyDesc: 'Change the filter or create a new contract from the student card.' },
    announcements: { title: 'Announcements', add: 'New announcement', empty: 'No announcements' },
    notifications: { title: 'Notifications', empty: 'No notifications' },
    stickers: { title: 'Stickers', subtitle: 'Image sticker packs for app avatars',
      titlePremium: 'Premium stickers', subtitlePremium: 'Image sticker packs for premium parents’ avatars',
      addPack: 'New pack', editPack: 'Edit pack', packTitle: 'Pack title', order: 'Order', titleRequired: 'Enter a title', empty: 'No packs', emptyDesc: 'Add the first sticker pack.', selectPack: 'Select a pack', upload: 'Upload sticker', uploaded: 'Sticker uploaded', noStickers: 'No stickers in this pack — upload an image (PNG/WEBP/ICO).', dragHint: 'Drag a sticker to reorder', count: 'stickers', active: 'Active', inactive: 'Inactive', one: 'Sticker' },
    staff: { title: 'Staff & users', add: 'New user' },
  },
  fields: { title: 'Title', type: 'Type',
    fullName: 'Full name', phone: 'Phone', class: 'Class', subject: 'Subject', parentName: 'Parent full name',
    parentPhone: 'Parent phone', status: 'Status', date: 'Date', amount: 'Amount', month: 'Month',
  },
  confirm: { title: 'Confirm deletion', msg: 'will be deleted? This action cannot be undone.', ok: 'Delete', cancel: 'Cancel' },
  genderRole: { father: 'Father', mother: 'Mother', parent: 'Parent', teacherMale: 'Teacher', teacher: 'Teacher' },
  subjectDetail: { notFound: 'Subject not found', edit: 'Edit', inSchedule: 'In schedule', inHomework: 'In homework', deleted: 'Subject deleted', deleteHint: 'Delete this subject permanently' },
  homeworkDetail: { notFound: 'Homework not found', info: 'Details', edit: 'Edit', deleted: 'Homework deleted', deleteHint: 'Delete this homework permanently', attachedFile: 'Attached file (from the app)', openFile: 'Open', removeFile: 'Remove file' },
  announcementDetail: { notFound: 'Announcement not found', createdBy: 'Created by', edit: 'Edit', deleted: 'Announcement deleted', deleteHint: 'Delete this announcement permanently' },
  tenantsPage: {
    colQurilmalar: 'Devices',
    title: 'Schools (tenants)', totalCount: 'Total: {{n}}', add: 'New school',
    emptyTitle: 'No schools', emptyDesc: 'Create the first school (tenant).',
    searchPlaceholder: 'Name or subdomain...', statusFilter: 'Status', active: 'Active', inactive: 'Inactive',
    sortNewest: 'Newest', sortOldest: 'Oldest', sortNameAsc: 'Name (A-Z)', sortNameDesc: 'Name (Z-A)',
    colName: 'School', colSlug: 'Subdomain', colCounts: 'Users / Students', colUsers: 'Users', colStudents: 'Students',
    colCreated: 'Created', colActive: 'Active',
    createTitle: 'New school (tenant)', name: 'School name', slug: 'Subdomain (slug)', slugPlaceholder: 'e.g. nurli',
    slugDesc: 'URL: <slug>.domen.com', note: 'Note', adminSection: 'School admin (DIRECTOR)',
    adminLogin: 'Admin login', adminPassword: 'Admin password', adminFullName: 'Admin full name',
    cancel: 'Cancel', create: 'Create', save: 'Save', error: 'Error',
    nameRequired: 'Enter a name', slugInvalid: 'Only lowercase letters, digits and hyphens', loginMin: 'Login must be at least 3 characters', passwordMin: 'Password must be at least {{n}} characters',
    created: 'School created', saved: 'Saved', deleted: '{{name}} deleted',
    editFallbackTitle: 'School', activeLabel: 'Active (not suspended)', activeDesc: 'If disabled, the school users cannot sign in',
    dangerZone: 'Danger zone',
    deleteWarning: 'Deleting the school permanently removes all users, students, payments and other data ({{users}} users, {{students}} students).',
    deleteConfirmHint: 'Type the subdomain to confirm:', deleteBtn: 'Permanently delete the school',
    slugTooLong: 'Subdomain must not exceed 63 characters', slugEdgeDash: 'Subdomain must not start or end with a hyphen',
    slugReserved: 'This word is reserved (www, admin, app, api, localhost)', domainFallback: 'domain',
    slugChangeTitle: 'Subdomain will change',
    slugChangeOld: 'The old address ({{old}}) will stop working — school users must sign in at the new address ({{new}}). Sessions open on the old address will be signed out.',
    slugChangeContracts: 'New contract numbers will start with “{{new}}-…” (currently “{{old}}-…”). Existing contracts and files are not affected.',
    slugChangeLegacy: 'This school uses the legacy contract requisites: if they are not saved, the current values will be saved automatically — contracts keep working as before.',
    slugConfirmTitle: 'Change subdomain',
    slugConfirmMsg: 'The old address {{old}} will stop working, the new address is {{new}}. Continue?',
    slugConfirmOk: 'Yes, change it',
    requisitesSaved: "The school's current contract requisites were saved (Settings → Contract requisites).",
  },
  tenantAdmins: {
    add: 'Add admin', addTitle: 'New admin (director or admin)', addSubmit: 'Create',
    added: '{{name}} — admin created', createdTitle: 'Admin created',
    role: 'Role', gender: 'Gender', male: 'Male', female: 'Female', genderRequired: 'Select gender',
    newAdminPasswordDesc: 'At least {{n}} characters',
    section: 'School admins',
    hint: 'Director and admin accounts. The password can be reset — the old password is not required.',
    loadError: 'Could not load the admin list', retry: 'Retry',
    empty: 'This school has no director or admin account.',
    reset: 'Password / login',
    formTitle: '{{name}} — sign-in details',
    loginDesc: 'If changed, the admin signs in with the new login next time',
    newPassword: 'New password',
    passwordDesc: 'At least {{n}} characters. Leave empty to keep the current password.',
    sessionsNote: "Changing the password does not close the admin's currently open sessions.",
    generate: 'Generate strong password', copy: 'Copy', copied: 'Copied',
    saved: '{{name}} — saved',
    doneTitle: 'Sign-in details updated',
    doneHint: 'Share the password with the admin securely — it will not be shown again.',
    nothingToSave: 'Enter a new password or change the login',
  },
};

export const resources = {
  uz: { translation: uz },
  ru: { translation: ru },
  en: { translation: en },
};

export type Lang = 'uz' | 'ru' | 'en';
